import { styled } from "styled-components";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Root, Root as AccessibleIconWrapper } from "@radix-ui/react-accessible-icon";
//#endregion
//#region src/Icon.tsx
const iconList = {
	AddCol: /* @__PURE__ */ jsx("path", { d: "M14,4 C15.1045695,4 16,4.8954305 16,6 L16,16 C16,17.1045695 15.1045695,18 14,18 L11,18 C9.8954305,18 9,17.1045695 9,16 L9,6 C9,4.8954305 9.8954305,4 11,4 L14,4 Z M14.5,11.5 L10.5,11.5 L10.5,15.5 C10.5,16.0522847 10.9477153,16.5 11.5,16.5 L13.5,16.5 C14.0128358,16.5 14.4355072,16.1139598 14.4932723,15.6166211 L14.5,15.5 L14.5,11.5 Z M3.75,7.5 C4.16421356,7.5 4.5,7.83578644 4.5,8.25 L4.5,10.5 L6.75,10.5 C7.16421356,10.5 7.5,10.8357864 7.5,11.25 C7.5,11.6642136 7.16421356,12 6.75,12 L4.5,12 L4.5,14.25 C4.5,14.6642136 4.16421356,15 3.75,15 C3.33578644,15 3,14.6642136 3,14.25 L3,12 L0.75,12 C0.335786438,12 5.07265313e-17,11.6642136 0,11.25 C-5.07265313e-17,10.8357864 0.335786438,10.5 0.75,10.5 L3,10.5 L3,8.25 C3,7.83578644 3.33578644,7.5 3.75,7.5 Z M13.5,5.5 L11.5,5.5 C10.9477153,5.5 10.5,5.94771525 10.5,6.5 L10.5,10.5 L14.5,10.5 L14.5,6.5 C14.5,5.94771525 14.0522847,5.5 13.5,5.5 Z" }),
	AddGroup: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", { d: "M9.95789 13.02H6.33789C5.92789 13.02 5.58789 13.36 5.58789 13.77C5.58789 14.18 5.92789 14.52 6.33789 14.52H10.8379C11.2479 14.52 11.5879 14.18 11.5879 13.77C11.5879 13.75 11.5879 13.73 11.5779 13.71H11.5579C10.9279 13.71 10.3579 13.44 9.95789 13.02Z" }),
		/* @__PURE__ */ jsx("path", { d: "M13.7479 9.93002V11.53C13.7479 12.15 13.4879 12.7 13.0879 13.1V16.53H4.08789V5.52002H9.35789V4.02002H2.58789V18.02H14.5879V9.93002H13.7479Z" }),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.4979 6.76002V3.91002C12.4979 3.39002 12.0779 2.96002 11.5479 2.96002C11.0179 2.96002 10.5979 3.38002 10.5979 3.91002V6.76002H7.74785C7.22785 6.76002 6.79785 7.18002 6.79785 7.71002C6.79785 8.24002 7.21785 8.66002 7.74785 8.66002H10.5979V11.51C10.5979 12.03 11.0179 12.46 11.5479 12.46C12.0779 12.46 12.4979 12.04 12.4979 11.51V8.66002H15.3479C15.8679 8.66002 16.2979 8.24002 16.2979 7.71002C16.2979 7.18002 15.8779 6.76002 15.3479 6.76002H12.4979Z"
		})
	] }),
	AddRow: /* @__PURE__ */ jsx("path", { d: "M13,12 C14.1045695,12 15,12.8954305 15,14 L15,17 C15,18.1045695 14.1045695,19 13,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,14 C1,12.8954305 1.8954305,12 3,12 L13,12 Z M7.5,13.5 L3.5,13.5 C2.94771525,13.5 2.5,13.9477153 2.5,14.5 L2.5,16.5 C2.5,17.0128358 2.88604019,17.4355072 3.38337887,17.4932723 L3.5,17.5 L7.5,17.5 L7.5,13.5 Z M12.5,13.5 L8.5,13.5 L8.5,17.5 L12.5,17.5 C13.0522847,17.5 13.5,17.0522847 13.5,16.5 L13.5,14.5 C13.5,13.9477153 13.0522847,13.5 12.5,13.5 Z M8.25,3 C8.66421356,3 9,3.33578644 9,3.75 L9,6 L11.25,6 C11.6642136,6 12,6.33578644 12,6.75 C12,7.16421356 11.6642136,7.5 11.25,7.5 L9,7.5 L9,9.75 C9,10.1642136 8.66421356,10.5 8.25,10.5 C7.83578644,10.5 7.5,10.1642136 7.5,9.75 L7.5,7.5 L5.25,7.5 C4.83578644,7.5 4.5,7.16421356 4.5,6.75 C4.5,6.33578644 4.83578644,6 5.25,6 L7.5,6 L7.5,3.75 C7.5,3.33578644 7.83578644,3 8.25,3 Z" }),
	AddTag: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", { d: "M9.01957 5.87998C8.23957 6.65998 8.23957 7.90998 9.01957 8.68998C9.79957 9.46998 11.0496 9.46998 11.8296 8.68998C12.6096 7.90998 12.6096 6.65998 11.8296 5.87998C11.0496 5.09998 9.79957 5.09998 9.01957 5.87998ZM11.1296 7.98998C10.7396 8.37998 10.1096 8.37998 9.72957 7.98998C9.33957 7.59998 9.33957 6.96998 9.72957 6.58998C10.1196 6.20998 10.7496 6.19998 11.1296 6.58998C11.5196 6.97998 11.5196 7.60998 11.1296 7.98998Z" }),
		/* @__PURE__ */ jsx("path", { d: "M8.69957 15.49C8.06957 15.49 7.52957 15.15 7.23957 14.64L2.69957 10.1L8.44957 4.34996L8.50957 4.29996C8.58957 4.23996 8.69957 4.20996 8.79957 4.20996C11.1396 4.20996 12.5496 4.49996 12.8796 4.83996C13.2196 5.17996 13.5096 6.58996 13.5096 8.91996V8.99996C13.4896 9.09996 13.4396 9.19996 13.3596 9.26996L12.7596 9.86996C13.0296 10.17 13.1896 10.56 13.1896 10.99V11.54L14.4096 10.32C14.7796 9.94996 14.9896 9.43996 14.9896 8.91996C14.9896 6.20996 14.6396 4.48996 13.9296 3.77996C13.2296 3.05996 11.5096 2.70996 8.79957 2.70996C8.26957 2.70996 7.76957 2.91996 7.39957 3.28996L1.28957 9.38996C0.89957 9.77996 0.89957 10.41 1.28957 10.8L6.90957 16.42C7.29957 16.81 7.92957 16.81 8.30957 16.42L9.23957 15.49H8.68957H8.69957Z" }),
		/* @__PURE__ */ jsx("path", { d: "M12.2 16.59V14.49H14.3C14.69 14.49 15 14.18 15 13.79C15 13.4 14.69 13.09 14.3 13.09H12.2V10.99C12.2 10.6 11.89 10.29 11.5 10.29C11.11 10.29 10.8 10.6 10.8 10.99V13.09H8.7C8.31 13.09 8 13.4 8 13.79C8 14.18 8.31 14.49 8.7 14.49H10.8V16.59C10.8 16.98 11.11 17.29 11.5 17.29C11.89 17.29 12.2 16.98 12.2 16.59Z" })
	] }),
	Alert: /* @__PURE__ */ jsx("path", { d: "M8.8125,14 L7.1796875,14 L7,6 L9,6 L8.8125,14 Z M7,16.0114943 C7,15.7203051 7.08937109,15.4789282 7.26811594,15.2873563 C7.4468608,15.0957845 7.69081971,15 8,15 C8.30918029,15 8.5531392,15.0957845 8.73188406,15.2873563 C8.91062891,15.4789282 9,15.7203051 9,16.0114943 C9,16.2924663 8.91304435,16.5274575 8.73913043,16.7164751 C8.56521652,16.9054926 8.31884217,17 8,17 C7.68115783,17 7.43478348,16.9054926 7.26086957,16.7164751 C7.08695565,16.5274575 7,16.2924663 7,16.0114943 Z" }),
	ArchiveFile: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M0.466073 0.669765V0.672443C0.202715 0.723335 -0.00468088 0.983456 8.03613e-05 1.25576V18.7517C8.03613e-05 19.0558 0.274892 19.3331 0.575429 19.3331H15.424C15.7253 19.3331 16 19.0558 16 18.7504V5.22661C15.9946 5.13747 15.9693 5.04938 15.9266 4.9714L11.5113 0.705502C11.454 0.683627 11.3927 0.671574 11.3312 0.669044H0.574995C0.539286 0.665621 0.501782 0.666342 0.466073 0.669765Z",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.466073 0.669765C0.501782 0.666342 0.539286 0.665621 0.574995 0.669044H11.3312C11.3927 0.671574 11.454 0.683627 11.5113 0.705502L15.9266 4.9714C15.9693 5.04938 15.9946 5.13747 16 5.22661V18.7504C16 19.0558 15.7253 19.3331 15.424 19.3331H0.575429C0.274892 19.3331 8.03613e-05 19.0558 8.03613e-05 18.7517V1.25576C-0.00468088 0.983456 0.202715 0.723335 0.466073 0.672443V0.669765ZM15 5.46661V18.3331H1.00008V1.66904H11.0694L15 5.46661Z",
			fill: "#5B6F98"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.68607 0.666883V0.666748H6.31396V0.666841L8.05205 0.666883V1.45544H7.26349V2.24399H8.05205V3.03254H7.26349V3.82109H8.05205V4.60965H7.26349V5.3982H8.05205V6.18675H7.26349V6.9753H8.05205V7.76386H7.26349V8.55241H8.05205V9.34096C7.18101 9.34096 6.47521 10.0506 6.47521 10.9178V14.0717C6.47521 14.939 7.18101 15.6486 8.05205 15.6486C8.92308 15.6486 9.62888 14.939 9.62888 14.0717V10.9178C9.62888 10.0506 8.92335 9.34096 8.05205 9.34096C8.48724 9.34096 8.8406 8.94655 8.8406 8.55241H8.05205V7.76386H8.8406V6.9753H8.05205V6.18675H8.8406V5.3982H8.05205V4.60965H8.8406V3.82109H8.05205V3.03254H8.8406V2.24399H8.05205V1.45544H8.8406V0.666883H9.68607ZM7.26403 10.9169C7.26403 10.4438 7.61739 10.1283 8.05259 10.1283C8.48778 10.1283 8.84114 10.4438 8.84114 10.9169C8.84114 11.3113 8.48778 11.7054 8.05259 11.7054C7.61739 11.7054 7.26403 11.311 7.26403 10.9169ZM7.26403 13.2822C7.26403 12.8092 7.61739 12.4937 8.05259 12.4937C8.48778 12.4937 8.84114 12.8092 8.84114 13.2822V14.0708C8.84114 14.4652 8.48778 14.8593 8.05259 14.8593C7.61739 14.8593 7.26403 14.4649 7.26403 14.0708V13.2822Z",
			fill: "#5B6F98"
		})
	] }),
	Attach: /* @__PURE__ */ jsx("path", { d: "M4.52067059,17 L3.02170198,17 C2.99275827,13.6267912 2.99275827,9.27431096 3.02174843,7.23327425 C3.10194335,1.5871931 13,1.5871931 13,7.24357419 L13,15.3478847 C13,20.2173718 5.78999996,20.2173718 5.78999996,15.3478847 L5.78999996,8.88580575 C5.78999996,5.53456392 10.2426232,5.53456392 10.2426232,8.88580575 L10.2426232,16 L8.74360115,16 L8.74360115,8.88580575 C8.74360115,7.50062224 7.28999996,7.50062224 7.28999996,8.88580575 L7.28999996,15.3478847 C7.28999996,18.2513135 11.5,18.2513135 11.5,15.3478847 L11.5,7.24357419 C11.5,3.54981811 4.57323523,3.54981811 4.52062414,7.25387413 C4.49181356,9.28226833 4.49181356,13.6368924 4.52067059,17 Z" }),
	AudioFile: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 2V14.4155C15 15.9553 13.7629 17.2035 12.2368 17.2035C10.7108 17.2035 9.47368 15.9553 9.47368 14.4156C9.47368 12.8758 10.7108 11.6277 12.2368 11.6277C12.6606 11.6277 13.0621 11.7239 13.4211 11.8959V7.71408L5.52632 8.37786V15.2121C5.52632 16.7518 4.28921 18 2.76316 18C1.23711 18 0 16.7518 0 15.2121C0 13.6724 1.23711 12.4242 2.76316 12.4242C3.18695 12.4242 3.58845 12.5205 3.94737 12.6925V2.9293L15 2ZM13.4211 14.4155C13.421 13.7557 12.8909 13.2207 12.2368 13.2207C11.5828 13.2207 11.0526 13.7557 11.0526 14.4156C11.0526 15.0754 11.5828 15.6104 12.2368 15.6104C12.8909 15.6104 13.4211 15.0754 13.4211 14.4155ZM2.76316 14.0173C3.41718 14.0173 3.94736 14.5522 3.94737 15.2121C3.94737 15.872 3.41718 16.4069 2.76316 16.4069C2.10914 16.4069 1.57895 15.872 1.57895 15.2121C1.57895 14.5522 2.10914 14.0173 2.76316 14.0173ZM5.52632 6.77925L13.4211 6.11547V3.73136L5.52632 4.39515V6.77925Z",
		fill: "#6355F6"
	}),
	AudioUpload: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 2V14.4155C15 15.9553 13.7629 17.2035 12.2368 17.2035C10.7108 17.2035 9.47368 15.9553 9.47368 14.4156C9.47368 12.8758 10.7108 11.6277 12.2368 11.6277C12.6606 11.6277 13.0621 11.7239 13.4211 11.8959V7.71408L5.52632 8.37786V15.2121C5.52632 16.7518 4.28921 18 2.76316 18C1.23711 18 0 16.7518 0 15.2121C0 13.6724 1.23711 12.4242 2.76316 12.4242C3.18695 12.4242 3.58845 12.5205 3.94737 12.6925V2.9293L15 2ZM13.4211 14.4155C13.421 13.7557 12.8909 13.2207 12.2368 13.2207C11.5828 13.2207 11.0526 13.7557 11.0526 14.4156C11.0526 15.0754 11.5828 15.6104 12.2368 15.6104C12.8909 15.6104 13.4211 15.0754 13.4211 14.4155ZM2.76316 14.0173C3.41718 14.0173 3.94736 14.5522 3.94737 15.2121C3.94737 15.872 3.41718 16.4069 2.76316 16.4069C2.10914 16.4069 1.57895 15.872 1.57895 15.2121C1.57895 14.5522 2.10914 14.0173 2.76316 14.0173ZM5.52632 6.77925L13.4211 6.11547V3.73136L5.52632 4.39515V6.77925Z"
	}),
	Back: /* @__PURE__ */ jsx("path", {
		d: "M8.76519 0.970882C9.04019 1.24588 9.04019 1.69173 8.76519 1.96672L3.39508 7.33684H18.5951C18.984 7.33684 19.2992 7.6521 19.2992 8.041V8.041C19.2992 8.4299 18.984 8.74517 18.5951 8.74517H3.39505L8.7652 14.1153C9.04019 14.3903 9.04019 14.8362 8.7652 15.1112V15.1112C8.4902 15.3862 8.04435 15.3862 7.76935 15.1112L0.699219 8.04102L7.76935 0.970882C8.04435 0.695888 8.4902 0.695888 8.76519 0.970882V0.970882Z",
		fill: "#0F172E"
	}),
	Bold: /* @__PURE__ */ jsx("path", { d: "M4,17 L4,6 L7.71257485,6 C8.27145988,6.00503666 8.79440874,6.06547561 9.28143713,6.18131868 C9.76846551,6.29716175 10.1942763,6.47596033 10.5588822,6.71771978 C10.9234882,6.95947923 11.2095798,7.26796974 11.4171657,7.64320055 C11.6247515,8.01843136 11.7258816,8.46290952 11.7205589,8.97664835 C11.7152362,9.52060712 11.5555571,9.98523159 11.241517,10.3705357 C10.9274768,10.7558398 10.5043273,11.0542572 9.97205589,11.2657967 C10.2967415,11.3514198 10.5854944,11.4735569 10.8383234,11.6322115 C11.0911523,11.7908662 11.302727,11.9809971 11.4730539,12.2026099 C11.6433808,12.4242227 11.7737853,12.669756 11.8642715,12.939217 C11.9547576,13.2086781 12,13.494504 12,13.7967033 C12,14.3205154 11.8988699,14.7813625 11.6966068,15.1792582 C11.4943436,15.577154 11.2135747,15.9095683 10.8542914,16.176511 C10.4950082,16.4434537 10.0691974,16.646176 9.57684631,16.7846841 C9.08449521,16.9231921 8.5535624,16.9949633 7.98403194,17 L4,17 Z M5.9241517,12.0137363 L5.9241517,15.5192308 L8.01596806,15.5192308 C8.31936279,15.5141941 8.5961398,15.470124 8.84630739,15.3870192 C9.09647497,15.3039144 9.31204168,15.1893322 9.49301397,15.0432692 C9.67398627,14.8972062 9.81636675,14.7184077 9.92015968,14.5068681 C10.0239526,14.2953286 10.0758483,14.0586094 10.0758483,13.7967033 C10.0758483,13.5196873 10.0306059,13.2716357 9.94011976,13.0525412 C9.84963361,12.8334467 9.71922906,12.6483524 9.5489022,12.4972527 C9.37857533,12.3461531 9.17099257,12.2290526 8.9261477,12.1459478 C8.68130283,12.062843 8.40718715,12.0187729 8.10379242,12.0137363 L5.9241517,12.0137363 Z M5.9241517,10.6311813 L7.76047904,10.6311813 C8.04790563,10.6261447 8.31536802,10.5896295 8.56287425,10.5216346 C8.81038048,10.4536398 9.02461653,10.3529082 9.20558882,10.2194368 C9.38656112,10.0859654 9.53027226,9.92227661 9.63672655,9.72836538 C9.74318084,9.53445416 9.79640719,9.31158551 9.79640719,9.05975275 C9.79640719,8.78273671 9.74584216,8.54601747 9.64471058,8.34958791 C9.543579,8.15315836 9.40119852,7.99198781 9.21756487,7.86607143 C9.03393122,7.74015505 8.81703385,7.64823747 8.56686627,7.59031593 C8.31669868,7.5323944 8.04258299,7.50091578 7.74451098,7.49587912 L5.9241517,7.49587912 L5.9241517,10.6311813 Z" }),
	Book: /* @__PURE__ */ jsx("path", { d: "M13,3 L13,15 L3.5,15 C2.67157288,15 2,15.6715729 2,16.5 C2,17.3284271 2.67157288,18 3.5,18 L14,18 L14,3 L15,3 L15,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,5 C1,3.8954305 1.8954305,3 3,3 L13,3 Z M3.5,16 L13,16 L13,17 L3.5,17 C3.22385763,17 3,16.7761424 3,16.5 C3,16.2238576 3.22385763,16 3.5,16 Z" }),
	BorderAll: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13 4.5H3C2.72386 4.5 2.5 4.72386 2.5 5V15C2.5 15.2761 2.72386 15.5 3 15.5H13C13.2761 15.5 13.5 15.2761 13.5 15V5C13.5 4.72386 13.2761 4.5 13 4.5ZM3 3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H13C14.1046 17 15 16.1046 15 15V5C15 3.89543 14.1046 3 13 3H3Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 17V3H8.5V17H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 9.5L15 9.5L15 10.5L1 10.5L1 9.5Z"
		})
	] }),
	BorderBottom: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.61721 16.9241L2 16.001V16H2.5V17H2C1.86441 17 1.73512 16.973 1.61721 16.9241ZM13.5 17V16H14L14.3828 16.9241C14.2649 16.973 14.1356 17 14 17H13.5ZM15 4.5H14V4L14.9241 3.61721C14.973 3.73512 15 3.86441 15 4V4.5ZM2.5 3H2C1.86441 3 1.73512 3.02699 1.61721 3.07588L2 3.99896V4H2.5V3ZM1.07588 16.3828L1.99896 16H2L2 15.5H1V16C1 16.1356 1.02699 16.2649 1.07588 16.3828ZM1 14.5H2V13.5H1V14.5ZM1 12.5H2V11.5H1V12.5ZM1 10.5H2V9.5H1V10.5ZM1 8.5H2V7.5H1V8.5ZM1 6.5H2V5.5H1V6.5ZM1 4.5H2V4L1.07588 3.61721C1.02699 3.73512 1 3.86441 1 4V4.5ZM3.5 3V4H4.5V3H3.5ZM5.5 3V4H6.5V3H5.5ZM7.5 3V4H8.5V3H7.5ZM9.5 3V4H10.5V3H9.5ZM11.5 3V4H12.5V3H11.5ZM13.5 3V4H14L14.3828 3.07588C14.2649 3.02699 14.1356 3 14 3H13.5ZM15 5.5H14V6.5H15V5.5ZM15 7.5H14V8.5H15V7.5ZM15 9.5H14V10.5H15V9.5ZM15 11.5H14V12.5H15V11.5ZM15 13.5H14V14.5H15V13.5ZM15 15.5H14V16L14.9241 16.3828C14.973 16.2649 15 16.1356 15 16V15.5ZM12.5 17V16H11.5V17H12.5ZM10.5 17V16H9.5V17H10.5ZM8.5 17V16H7.5V17H8.5ZM6.5 17V16H5.5V17H6.5ZM4.5 17V16H3.5V17H4.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.5V3H8.5V3.5H7.5ZM7.5 5.5V4.5H8.5V5.5H7.5ZM7.5 7.5V6.5H8.5V7.5H7.5ZM7.5 9.5V8.5H8.5V9.5H7.5ZM7.5 11.5V10.5H8.5V11.5H7.5ZM7.5 13.5V12.5H8.5V13.5H7.5ZM7.5 15.5V14.5H8.5V15.5H7.5ZM7.5 17V16.5H8.5V17H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 9.5L15 9.5L15 10.5L14.5 10.5L14.5 9.5ZM12.5 9.5L13.5 9.5L13.5 10.5L12.5 10.5L12.5 9.5ZM10.5 9.5L11.5 9.5L11.5 10.5L10.5 10.5L10.5 9.5ZM8.5 9.5L9.5 9.5L9.5 10.5L8.5 10.5L8.5 9.5ZM6.5 9.5L7.5 9.5L7.5 10.5L6.5 10.5L6.5 9.5ZM4.5 9.5L5.5 9.5L5.5 10.5L4.5 10.5L4.5 9.5ZM2.5 9.5L3.5 9.5L3.5 10.5L2.5 10.5L2.5 9.5ZM1 9.5L1.5 9.5L1.5 10.5L1 10.5L1 9.5Z"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "1",
			y: "15.5",
			width: "14",
			height: "1.5"
		})
	] }),
	BorderInside: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.61721 16.9241L2 16.001V16H2.5V17H2C1.86441 17 1.73512 16.973 1.61721 16.9241ZM13.5 17V16H14L14.3828 16.9241C14.2649 16.973 14.1356 17 14 17H13.5ZM15 4.5H14V4L14.9241 3.61721C14.973 3.73512 15 3.86441 15 4V4.5ZM2.5 3H2C1.86441 3 1.73512 3.02699 1.61721 3.07588L2 3.99896V4H2.5V3ZM1.07588 16.3828L1.99896 16H2L2 15.5H1V16C1 16.1356 1.02699 16.2649 1.07588 16.3828ZM1 14.5H2V13.5H1V14.5ZM1 12.5H2V11.5H1V12.5ZM1 10.5H2V9.5H1V10.5ZM1 8.5H2V7.5H1V8.5ZM1 6.5H2V5.5H1V6.5ZM1 4.5H2V4L1.07588 3.61721C1.02699 3.73512 1 3.86441 1 4V4.5ZM3.5 3V4H4.5V3H3.5ZM5.5 3V4H6.5V3H5.5ZM7.5 3V4H8.5V3H7.5ZM9.5 3V4H10.5V3H9.5ZM11.5 3V4H12.5V3H11.5ZM13.5 3V4H14L14.3828 3.07588C14.2649 3.02699 14.1356 3 14 3H13.5ZM15 5.5H14V6.5H15V5.5ZM15 7.5H14V8.5H15V7.5ZM15 9.5H14V10.5H15V9.5ZM15 11.5H14V12.5H15V11.5ZM15 13.5H14V14.5H15V13.5ZM15 15.5H14V16L14.9241 16.3828C14.973 16.2649 15 16.1356 15 16V15.5ZM12.5 17V16H11.5V17H12.5ZM10.5 17V16H9.5V17H10.5ZM8.5 17V16H7.5V17H8.5ZM6.5 17V16H5.5V17H6.5ZM4.5 17V16H3.5V17H4.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.25 17V3H8.75V17H7.25Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 9.25L15 9.25L15 10.75L1 10.75L1 9.25Z"
		})
	] }),
	BorderInsideHorizontal: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.61721 16.9241L2 16.001V16H2.5V17H2C1.86441 17 1.73512 16.973 1.61721 16.9241ZM13.5 17V16H14L14.3828 16.9241C14.2649 16.973 14.1356 17 14 17H13.5ZM15 4.5H14V4L14.9241 3.61721C14.973 3.73512 15 3.86441 15 4V4.5ZM2.5 3H2C1.86441 3 1.73512 3.02699 1.61721 3.07588L2 3.99896V4H2.5V3ZM1.07588 16.3828L1.99896 16H2L2 15.5H1V16C1 16.1356 1.02699 16.2649 1.07588 16.3828ZM1 14.5H2V13.5H1V14.5ZM1 12.5H2V11.5H1V12.5ZM1 10.5H2V9.5H1V10.5ZM1 8.5H2V7.5H1V8.5ZM1 6.5H2V5.5H1V6.5ZM1 4.5H2V4L1.07588 3.61721C1.02699 3.73512 1 3.86441 1 4V4.5ZM3.5 3V4H4.5V3H3.5ZM5.5 3V4H6.5V3H5.5ZM7.5 3V4H8.5V3H7.5ZM9.5 3V4H10.5V3H9.5ZM11.5 3V4H12.5V3H11.5ZM13.5 3V4H14L14.3828 3.07588C14.2649 3.02699 14.1356 3 14 3H13.5ZM15 5.5H14V6.5H15V5.5ZM15 7.5H14V8.5H15V7.5ZM15 9.5H14V10.5H15V9.5ZM15 11.5H14V12.5H15V11.5ZM15 13.5H14V14.5H15V13.5ZM15 15.5H14V16L14.9241 16.3828C14.973 16.2649 15 16.1356 15 16V15.5ZM12.5 17V16H11.5V17H12.5ZM10.5 17V16H9.5V17H10.5ZM8.5 17V16H7.5V17H8.5ZM6.5 17V16H5.5V17H6.5ZM4.5 17V16H3.5V17H4.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.4375V3H8.5V3.4375H7.5ZM7.5 5.1875V4.3125H8.5V5.1875H7.5ZM7.5 6.9375V6.0625H8.5V6.9375H7.5ZM7.5 8.6875V7.8125H8.5V8.6875H7.5ZM7.5 10V9.5625H8.5V10H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 10.4375V10H8.5V10.4375H7.5ZM7.5 12.1875V11.3125H8.5V12.1875H7.5ZM7.5 13.9375V13.0625H8.5V13.9375H7.5ZM7.5 15.6875V14.8125H8.5V15.6875H7.5ZM7.5 17V16.5625H8.5V17H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 9.25L15 9.25L15 10.75L1 10.75L1 9.25Z"
		})
	] }),
	BorderInsideVertical: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.61721 16.9241L2 16.001V16H2.5V17H2C1.86441 17 1.73512 16.973 1.61721 16.9241ZM13.5 17V16H14L14.3828 16.9241C14.2649 16.973 14.1356 17 14 17H13.5ZM15 4.5H14V4L14.9241 3.61721C14.973 3.73512 15 3.86441 15 4V4.5ZM2.5 3H2C1.86441 3 1.73512 3.02699 1.61721 3.07588L2 3.99896V4H2.5V3ZM1.07588 16.3828L1.99896 16H2L2 15.5H1V16C1 16.1356 1.02699 16.2649 1.07588 16.3828ZM1 14.5H2V13.5H1V14.5ZM1 12.5H2V11.5H1V12.5ZM1 10.5H2V9.5H1V10.5ZM1 8.5H2V7.5H1V8.5ZM1 6.5H2V5.5H1V6.5ZM1 4.5H2V4L1.07588 3.61721C1.02699 3.73512 1 3.86441 1 4V4.5ZM3.5 3V4H4.5V3H3.5ZM5.5 3V4H6.5V3H5.5ZM7.5 3V4H8.5V3H7.5ZM9.5 3V4H10.5V3H9.5ZM11.5 3V4H12.5V3H11.5ZM13.5 3V4H14L14.3828 3.07588C14.2649 3.02699 14.1356 3 14 3H13.5ZM15 5.5H14V6.5H15V5.5ZM15 7.5H14V8.5H15V7.5ZM15 9.5H14V10.5H15V9.5ZM15 11.5H14V12.5H15V11.5ZM15 13.5H14V14.5H15V13.5ZM15 15.5H14V16L14.9241 16.3828C14.973 16.2649 15 16.1356 15 16V15.5ZM12.5 17V16H11.5V17H12.5ZM10.5 17V16H9.5V17H10.5ZM8.5 17V16H7.5V17H8.5ZM6.5 17V16H5.5V17H6.5ZM4.5 17V16H3.5V17H4.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.25 17V3H8.75V17H7.25Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5625 9.5H8V10.5H7.5625V9.5ZM5.8125 9.5H6.6875V10.5H5.8125V9.5ZM4.0625 9.5H4.9375V10.5H4.0625V9.5ZM2.3125 9.5H3.1875V10.5H2.3125V9.5ZM1 9.5H1.4375V10.5H1V9.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5625 9.5H15V10.5H14.5625V9.5ZM12.8125 9.5H13.6875V10.5H12.8125V9.5ZM11.0625 9.5H11.9375V10.5H11.0625V9.5ZM9.3125 9.5H10.1875V10.5H9.3125V9.5ZM8 9.5H8.4375V10.5H8V9.5Z"
		})
	] }),
	BorderLeft: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.61721 16.9241L2 16.001V16H2.5V17H2C1.86441 17 1.73512 16.973 1.61721 16.9241ZM13.5 17V16H14L14.3828 16.9241C14.2649 16.973 14.1356 17 14 17H13.5ZM15 4.5H14V4L14.9241 3.61721C14.973 3.73512 15 3.86441 15 4V4.5ZM2.5 3H2C1.86441 3 1.73512 3.02699 1.61721 3.07588L2 3.99896V4H2.5V3ZM1.07588 16.3828L1.99896 16H2L2 15.5H1V16C1 16.1356 1.02699 16.2649 1.07588 16.3828ZM1 14.5H2V13.5H1V14.5ZM1 12.5H2V11.5H1V12.5ZM1 10.5H2V9.5H1V10.5ZM1 8.5H2V7.5H1V8.5ZM1 6.5H2V5.5H1V6.5ZM1 4.5H2V4L1.07588 3.61721C1.02699 3.73512 1 3.86441 1 4V4.5ZM3.5 3V4H4.5V3H3.5ZM5.5 3V4H6.5V3H5.5ZM7.5 3V4H8.5V3H7.5ZM9.5 3V4H10.5V3H9.5ZM11.5 3V4H12.5V3H11.5ZM13.5 3V4H14L14.3828 3.07588C14.2649 3.02699 14.1356 3 14 3H13.5ZM15 5.5H14V6.5H15V5.5ZM15 7.5H14V8.5H15V7.5ZM15 9.5H14V10.5H15V9.5ZM15 11.5H14V12.5H15V11.5ZM15 13.5H14V14.5H15V13.5ZM15 15.5H14V16L14.9241 16.3828C14.973 16.2649 15 16.1356 15 16V15.5ZM12.5 17V16H11.5V17H12.5ZM10.5 17V16H9.5V17H10.5ZM8.5 17V16H7.5V17H8.5ZM6.5 17V16H5.5V17H6.5ZM4.5 17V16H3.5V17H4.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.5V3H8.5V3.5H7.5ZM7.5 5.5V4.5H8.5V5.5H7.5ZM7.5 7.5V6.5H8.5V7.5H7.5ZM7.5 9.5V8.5H8.5V9.5H7.5ZM7.5 11.5V10.5H8.5V11.5H7.5ZM7.5 13.5V12.5H8.5V13.5H7.5ZM7.5 15.5V14.5H8.5V15.5H7.5ZM7.5 17V16.5H8.5V17H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 9.5L15 9.5L15 10.5L14.5 10.5L14.5 9.5ZM12.5 9.5L13.5 9.5L13.5 10.5L12.5 10.5L12.5 9.5ZM10.5 9.5L11.5 9.5L11.5 10.5L10.5 10.5L10.5 9.5ZM8.5 9.5L9.5 9.5L9.5 10.5L8.5 10.5L8.5 9.5ZM6.5 9.5L7.5 9.5L7.5 10.5L6.5 10.5L6.5 9.5ZM4.5 9.5L5.5 9.5L5.5 10.5L4.5 10.5L4.5 9.5ZM2.5 9.5L3.5 9.5L3.5 10.5L2.5 10.5L2.5 9.5ZM1 9.5L1.5 9.5L1.5 10.5L1 10.5L1 9.5Z"
		}),
		/* @__PURE__ */ jsx("path", { d: "M2.5 3L2.5 17L0.999999 17L1 3L2.5 3Z" })
	] }),
	BorderNone: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.61721 16.9241L2 16.001V16H2.5V17H2C1.86441 17 1.73512 16.973 1.61721 16.9241ZM13.5 17V16H14L14.3828 16.9241C14.2649 16.973 14.1356 17 14 17H13.5ZM15 4.5H14V4L14.9241 3.61721C14.973 3.73512 15 3.86441 15 4V4.5ZM2.5 3H2C1.86441 3 1.73512 3.02699 1.61721 3.07588L2 3.99896V4H2.5V3ZM1.07588 16.3828L1.99896 16H2L2 15.5H1V16C1 16.1356 1.02699 16.2649 1.07588 16.3828ZM1 14.5H2V13.5H1V14.5ZM1 12.5H2V11.5H1V12.5ZM1 10.5H2V9.5H1V10.5ZM1 8.5H2V7.5H1V8.5ZM1 6.5H2V5.5H1V6.5ZM1 4.5H2V4L1.07588 3.61721C1.02699 3.73512 1 3.86441 1 4V4.5ZM3.5 3V4H4.5V3H3.5ZM5.5 3V4H6.5V3H5.5ZM7.5 3V4H8.5V3H7.5ZM9.5 3V4H10.5V3H9.5ZM11.5 3V4H12.5V3H11.5ZM13.5 3V4H14L14.3828 3.07588C14.2649 3.02699 14.1356 3 14 3H13.5ZM15 5.5H14V6.5H15V5.5ZM15 7.5H14V8.5H15V7.5ZM15 9.5H14V10.5H15V9.5ZM15 11.5H14V12.5H15V11.5ZM15 13.5H14V14.5H15V13.5ZM15 15.5H14V16L14.9241 16.3828C14.973 16.2649 15 16.1356 15 16V15.5ZM12.5 17V16H11.5V17H12.5ZM10.5 17V16H9.5V17H10.5ZM8.5 17V16H7.5V17H8.5ZM6.5 17V16H5.5V17H6.5ZM4.5 17V16H3.5V17H4.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.5V3H8.5V3.5H7.5ZM7.5 5.5V4.5H8.5V5.5H7.5ZM7.5 7.5V6.5H8.5V7.5H7.5ZM7.5 9.5V8.5H8.5V9.5H7.5ZM7.5 11.5V10.5H8.5V11.5H7.5ZM7.5 13.5V12.5H8.5V13.5H7.5ZM7.5 15.5V14.5H8.5V15.5H7.5ZM7.5 17V16.5H8.5V17H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 9.5L15 9.5L15 10.5L14.5 10.5L14.5 9.5ZM12.5 9.5L13.5 9.5L13.5 10.5L12.5 10.5L12.5 9.5ZM10.5 9.5L11.5 9.5L11.5 10.5L10.5 10.5L10.5 9.5ZM8.5 9.5L9.5 9.5L9.5 10.5L8.5 10.5L8.5 9.5ZM6.5 9.5L7.5 9.5L7.5 10.5L6.5 10.5L6.5 9.5ZM4.5 9.5L5.5 9.5L5.5 10.5L4.5 10.5L4.5 9.5ZM2.5 9.5L3.5 9.5L3.5 10.5L2.5 10.5L2.5 9.5ZM1 9.5L1.5 9.5L1.5 10.5L1 10.5L1 9.5Z"
		})
	] }),
	BorderOutside: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13 4.5H3C2.72386 4.5 2.5 4.72386 2.5 5V15C2.5 15.2761 2.72386 15.5 3 15.5H13C13.2761 15.5 13.5 15.2761 13.5 15V5C13.5 4.72386 13.2761 4.5 13 4.5ZM3 3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H13C14.1046 17 15 16.1046 15 15V5C15 3.89543 14.1046 3 13 3H3Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.5V3H8.5V3.5H7.5ZM7.5 5.5V4.5H8.5V5.5H7.5ZM7.5 7.5V6.5H8.5V7.5H7.5ZM7.5 9.5V8.5H8.5V9.5H7.5ZM7.5 11.5V10.5H8.5V11.5H7.5ZM7.5 13.5V12.5H8.5V13.5H7.5ZM7.5 15.5V14.5H8.5V15.5H7.5ZM7.5 17V16.5H8.5V17H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 9.5L15 9.5L15 10.5L14.5 10.5L14.5 9.5ZM12.5 9.5L13.5 9.5L13.5 10.5L12.5 10.5L12.5 9.5ZM10.5 9.5L11.5 9.5L11.5 10.5L10.5 10.5L10.5 9.5ZM8.5 9.5L9.5 9.5L9.5 10.5L8.5 10.5L8.5 9.5ZM6.5 9.5L7.5 9.5L7.5 10.5L6.5 10.5L6.5 9.5ZM4.5 9.5L5.5 9.5L5.5 10.5L4.5 10.5L4.5 9.5ZM2.5 9.5L3.5 9.5L3.5 10.5L2.5 10.5L2.5 9.5ZM1 9.5L1.5 9.5L1.5 10.5L1 10.5L1 9.5Z"
		})
	] }),
	BorderRight: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.61721 16.9241L2 16.001V16H2.5V17H2C1.86441 17 1.73512 16.973 1.61721 16.9241ZM13.5 17V16H14L14.3828 16.9241C14.2649 16.973 14.1356 17 14 17H13.5ZM15 4.5H14V4L14.9241 3.61721C14.973 3.73512 15 3.86441 15 4V4.5ZM2.5 3H2C1.86441 3 1.73512 3.02699 1.61721 3.07588L2 3.99896V4H2.5V3ZM1.07588 16.3828L1.99896 16H2L2 15.5H1V16C1 16.1356 1.02699 16.2649 1.07588 16.3828ZM1 14.5H2V13.5H1V14.5ZM1 12.5H2V11.5H1V12.5ZM1 10.5H2V9.5H1V10.5ZM1 8.5H2V7.5H1V8.5ZM1 6.5H2V5.5H1V6.5ZM1 4.5H2V4L1.07588 3.61721C1.02699 3.73512 1 3.86441 1 4V4.5ZM3.5 3V4H4.5V3H3.5ZM5.5 3V4H6.5V3H5.5ZM7.5 3V4H8.5V3H7.5ZM9.5 3V4H10.5V3H9.5ZM11.5 3V4H12.5V3H11.5ZM13.5 3V4H14L14.3828 3.07588C14.2649 3.02699 14.1356 3 14 3H13.5ZM15 5.5H14V6.5H15V5.5ZM15 7.5H14V8.5H15V7.5ZM15 9.5H14V10.5H15V9.5ZM15 11.5H14V12.5H15V11.5ZM15 13.5H14V14.5H15V13.5ZM15 15.5H14V16L14.9241 16.3828C14.973 16.2649 15 16.1356 15 16V15.5ZM12.5 17V16H11.5V17H12.5ZM10.5 17V16H9.5V17H10.5ZM8.5 17V16H7.5V17H8.5ZM6.5 17V16H5.5V17H6.5ZM4.5 17V16H3.5V17H4.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.5V3H8.5V3.5H7.5ZM7.5 5.5V4.5H8.5V5.5H7.5ZM7.5 7.5V6.5H8.5V7.5H7.5ZM7.5 9.5V8.5H8.5V9.5H7.5ZM7.5 11.5V10.5H8.5V11.5H7.5ZM7.5 13.5V12.5H8.5V13.5H7.5ZM7.5 15.5V14.5H8.5V15.5H7.5ZM7.5 17V16.5H8.5V17H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 9.5L15 9.5L15 10.5L14.5 10.5L14.5 9.5ZM12.5 9.5L13.5 9.5L13.5 10.5L12.5 10.5L12.5 9.5ZM10.5 9.5L11.5 9.5L11.5 10.5L10.5 10.5L10.5 9.5ZM8.5 9.5L9.5 9.5L9.5 10.5L8.5 10.5L8.5 9.5ZM6.5 9.5L7.5 9.5L7.5 10.5L6.5 10.5L6.5 9.5ZM4.5 9.5L5.5 9.5L5.5 10.5L4.5 10.5L4.5 9.5ZM2.5 9.5L3.5 9.5L3.5 10.5L2.5 10.5L2.5 9.5ZM1 9.5L1.5 9.5L1.5 10.5L1 10.5L1 9.5Z"
		}),
		/* @__PURE__ */ jsx("path", { d: "M15 3L15 17L13.5 17L13.5 3L15 3Z" })
	] }),
	BorderTop: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.61721 16.9241L2 16.001V16H2.5V17H2C1.86441 17 1.73512 16.973 1.61721 16.9241ZM13.5 17V16H14L14.3828 16.9241C14.2649 16.973 14.1356 17 14 17H13.5ZM15 4.5H14V4L14.9241 3.61721C14.973 3.73512 15 3.86441 15 4V4.5ZM2.5 3H2C1.86441 3 1.73512 3.02699 1.61721 3.07588L2 3.99896V4H2.5V3ZM1.07588 16.3828L1.99896 16H2L2 15.5H1V16C1 16.1356 1.02699 16.2649 1.07588 16.3828ZM1 14.5H2V13.5H1V14.5ZM1 12.5H2V11.5H1V12.5ZM1 10.5H2V9.5H1V10.5ZM1 8.5H2V7.5H1V8.5ZM1 6.5H2V5.5H1V6.5ZM1 4.5H2V4L1.07588 3.61721C1.02699 3.73512 1 3.86441 1 4V4.5ZM3.5 3V4H4.5V3H3.5ZM5.5 3V4H6.5V3H5.5ZM7.5 3V4H8.5V3H7.5ZM9.5 3V4H10.5V3H9.5ZM11.5 3V4H12.5V3H11.5ZM13.5 3V4H14L14.3828 3.07588C14.2649 3.02699 14.1356 3 14 3H13.5ZM15 5.5H14V6.5H15V5.5ZM15 7.5H14V8.5H15V7.5ZM15 9.5H14V10.5H15V9.5ZM15 11.5H14V12.5H15V11.5ZM15 13.5H14V14.5H15V13.5ZM15 15.5H14V16L14.9241 16.3828C14.973 16.2649 15 16.1356 15 16V15.5ZM12.5 17V16H11.5V17H12.5ZM10.5 17V16H9.5V17H10.5ZM8.5 17V16H7.5V17H8.5ZM6.5 17V16H5.5V17H6.5ZM4.5 17V16H3.5V17H4.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.5V3H8.5V3.5H7.5ZM7.5 5.5V4.5H8.5V5.5H7.5ZM7.5 7.5V6.5H8.5V7.5H7.5ZM7.5 9.5V8.5H8.5V9.5H7.5ZM7.5 11.5V10.5H8.5V11.5H7.5ZM7.5 13.5V12.5H8.5V13.5H7.5ZM7.5 15.5V14.5H8.5V15.5H7.5ZM7.5 17V16.5H8.5V17H7.5Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 9.5L15 9.5L15 10.5L14.5 10.5L14.5 9.5ZM12.5 9.5L13.5 9.5L13.5 10.5L12.5 10.5L12.5 9.5ZM10.5 9.5L11.5 9.5L11.5 10.5L10.5 10.5L10.5 9.5ZM8.5 9.5L9.5 9.5L9.5 10.5L8.5 10.5L8.5 9.5ZM6.5 9.5L7.5 9.5L7.5 10.5L6.5 10.5L6.5 9.5ZM4.5 9.5L5.5 9.5L5.5 10.5L4.5 10.5L4.5 9.5ZM2.5 9.5L3.5 9.5L3.5 10.5L2.5 10.5L2.5 9.5ZM1 9.5L1.5 9.5L1.5 10.5L1 10.5L1 9.5Z"
		}),
		/* @__PURE__ */ jsx("path", { d: "M1 3H15V4.5H1V3Z" })
	] }),
	BulletList: /* @__PURE__ */ jsx("path", { d: "M4,16 L16,16 L16,16 L16,18 L4,18 C3.44771525,18 3,17.5522847 3,17 C3,16.4477153 3.44771525,16 4,16 Z M4,12 L16,12 L16,12 L16,14 L4,14 C3.44771525,14 3,13.5522847 3,13 C3,12.4477153 3.44771525,12 4,12 Z M8,8 L16,8 L16,8 L16,10 L8,10 C7.44771525,10 7,9.55228475 7,9 C7,8.44771525 7.44771525,8 8,8 Z M8,4 L16,4 L16,4 L16,6 L8,6 C7.44771525,6 7,5.55228475 7,5 C7,4.44771525 7.44771525,4 8,4 Z M2.75,7.5 C1.78350169,7.5 1,6.71649831 1,5.75 C1,4.78350169 1.78350169,4 2.75,4 C3.71649831,4 4.5,4.78350169 4.5,5.75 C4.5,6.71649831 3.71649831,7.5 2.75,7.5 Z" }),
	Cadmus: /* @__PURE__ */ jsx("path", { d: "M7.39436303,11.7073664 C6.63246367,12.1692263 5.8387871,12.4423204 5.01333333,12.5266486 L6.06670096,12.5801342 C5.54703841,12.8834621 5.0244348,13.1477233 4.51101719,13.3770608 C2.72905305,14.1730427 1.64946042,15.6901762 1.27223928,17.9284614 L0,19 C0.517432935,18.2982306 0.981214351,16.7573651 1.39134425,14.3774034 C2.73508744,6.57973428 9.6578878,2.44072449 16,3.06092427 C13.8814478,3.42840181 12.4423778,4.44025773 11.68279,6.09649202 C11.2131927,6.61148366 10.625596,6.96598632 9.92,7.16 L11.3534344,6.87128721 C10.8320159,8.0282049 10.1621413,9.02366597 9.40399453,9.87823066 C8.84794981,10.3835066 8.27328496,10.6863187 7.68,10.7866667 L8.51114143,10.7866667 C8.14998014,11.1190407 7.77598259,11.4253468 7.39436303,11.7073664 L7.39436303,11.7073664 Z" }),
	Calendar: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", { d: "M4.27793 8.51127H6.24668V10.2613H4.27793V8.51127Z" }),
		/* @__PURE__ */ jsx("path", { d: "M6.24668 11.8363H4.27793V13.5863H6.24668V11.8363Z" }),
		/* @__PURE__ */ jsx("path", { d: "M8.01855 8.51127H9.9873V10.2613H8.01855V8.51127Z" }),
		/* @__PURE__ */ jsx("path", { d: "M9.9873 11.8363H8.01855V13.5863H9.9873V11.8363Z" }),
		/* @__PURE__ */ jsx("path", { d: "M11.7592 8.51127H13.7279V10.2613H11.7592V8.51127Z" }),
		/* @__PURE__ */ jsx("path", { d: "M13.7279 11.8363H11.7592V13.5863H13.7279V11.8363Z" }),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.49043 5.44877H2.12793C1.57565 5.44877 1.12793 5.89649 1.12793 6.44877V16.6488H16.8779V6.44877C16.8779 5.89649 16.4302 5.44877 15.8779 5.44877H14.5154V3.34877H12.9404V5.44877H5.06543V3.34877H3.49043V5.44877ZM2.70293 6.84877V15.2488H15.3029V6.84877H2.70293Z"
		})
	] }),
	CalendarCheck: /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", { d: "M7.88109 13.9379L12.0117 9.81905L11.0234 8.82788L7.88109 11.9612L6.33143 10.416L5.34308 11.4071L7.88109 13.9379Z" }), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.67871 6.95086C1.67871 6.39858 2.12643 5.95086 2.67871 5.95086H3.77832V3.85126H5.17805V5.95086H12.1767V3.85126H13.5765V5.95086H14.6761C15.2284 5.95086 15.6761 6.39858 15.6761 6.95086V17.1488H1.67871V6.95086ZM3.07845 15.749V7.3506H14.2764V15.749H3.07845Z"
	})] }),
	Caption: /* @__PURE__ */ jsx("path", { d: "M2.4866562,12.685112 C2.75458009,12.685112 2.97226499,12.6078181 3.13971743,12.4532279 C3.30716986,12.2986378 3.39424382,12.0931062 3.40094192,11.8366271 L4.76232339,11.8366271 C4.75897434,12.2231025 4.65850439,12.5770735 4.46091052,12.8985507 C4.26331665,13.220028 3.99288502,13.4694765 3.64960754,13.6469038 C3.30633005,13.8243311 2.92705597,13.9130435 2.51177394,13.9130435 C1.73479465,13.9130435 1.12192794,13.6539332 0.673155416,13.1357049 C0.224382895,12.6174765 0,11.9016295 0,10.9881423 L0,10.8880105 C0,10.0096574 0.222708396,9.30874219 0.668131868,8.78524374 C1.11355534,8.2617453 1.72474755,8 2.50172684,8 C3.18158372,8 3.72663322,8.20289652 4.13689168,8.60869565 C4.54715014,9.01449478 4.75562529,9.55467383 4.76232339,10.229249 L3.40094192,10.229249 C3.39424382,9.93412237 3.30716986,9.69433557 3.13971743,9.50988142 C2.97226499,9.32542727 2.7512311,9.23320158 2.47660911,9.23320158 C2.13835519,9.23320158 1.88299406,9.36231755 1.71051805,9.62055336 C1.53804205,9.87878917 1.45180534,10.2977573 1.45180534,10.8774704 L1.45180534,11.0355731 C1.45180534,11.622313 1.5372048,12.0439162 1.70800628,12.3003953 C1.87880776,12.5568744 2.13835514,12.685112 2.4866562,12.685112 Z M8.74097331,13.8076416 C8.67399234,13.6706186 8.62543186,13.5002206 8.59529042,13.2964427 C8.24364031,13.7075119 7.78650203,13.9130435 7.22386185,13.9130435 C6.69136311,13.9130435 6.25013257,13.7514289 5.90015699,13.428195 C5.5501814,13.1049611 5.37519623,12.6974113 5.37519623,12.2055336 C5.37519623,11.6012267 5.58869488,11.1374632 6.01569859,10.8142292 C6.44270229,10.4909953 7.05975525,10.3276241 7.86687598,10.3241107 L8.53500785,10.3241107 L8.53500785,9.99736495 C8.53500785,9.73385903 8.47053963,9.52305744 8.34160126,9.36495389 C8.21266288,9.20685033 8.00921123,9.12779974 7.73124019,9.12779974 C7.48675964,9.12779974 7.29502948,9.18928353 7.15604396,9.31225296 C7.01705844,9.4352224 6.94756672,9.60386366 6.94756672,9.81818182 L5.49576138,9.81818182 C5.49576138,9.48792105 5.59288234,9.18225876 5.78712716,8.90118577 C5.98137198,8.62011278 6.25598985,8.39964946 6.61098901,8.2397892 C6.96598817,8.07992893 7.36451898,8 7.80659341,8 C8.47640314,8 9.00805664,8.17654632 9.40156986,8.52964427 C9.79508308,8.88274221 9.99183673,9.37900427 9.99183673,10.0184453 L9.99183673,12.4901186 C9.99518578,13.0311841 10.0671892,13.4404905 10.2078493,13.7180501 L10.2078493,13.8076416 L8.74097331,13.8076416 Z M7.54034537,12.7483531 C7.75468448,12.7483531 7.95227539,12.6982877 8.13312402,12.5981555 C8.31397265,12.4980232 8.44793258,12.3636372 8.53500785,12.1949934 L8.53500785,11.2147563 L7.99246468,11.2147563 C7.26572112,11.2147563 6.8789118,11.4782582 6.83202512,12.0052701 L6.82700157,12.0948617 C6.82700157,12.2845859 6.89063254,12.4409304 7.01789639,12.5638999 C7.14516024,12.6868693 7.31930816,12.7483531 7.54034537,12.7483531 Z M16,11.0092227 C16,11.8875758 15.8099443,12.591126 15.4298273,13.1198946 C15.0497103,13.6486632 14.5364763,13.9130435 13.8901099,13.9130435 C13.3408659,13.9130435 12.8971236,13.712782 12.5588697,13.312253 L12.5588697,16 L11.1070644,16 L11.1070644,8.10540184 L12.4533752,8.10540184 L12.5036107,8.66403162 C12.8552608,8.22134166 13.3140736,8 13.8800628,8 C14.5498725,8 15.0706418,8.25998862 15.4423862,8.77997365 C15.8141306,9.29995868 16,10.0166841 16,10.9301713 L16,11.0092227 Z M14.5481947,10.8985507 C14.5481947,10.3680255 14.458609,9.95871905 14.2794349,9.67061924 C14.1002607,9.38251942 13.8398761,9.23847167 13.4982732,9.23847167 C13.0428025,9.23847167 12.7296712,9.42116638 12.5588697,9.78656126 L12.5588697,12.1212121 C12.7363693,12.4971472 13.0528496,12.685112 13.5083203,12.685112 C14.2015733,12.685112 14.5481947,12.0895975 14.5481947,10.8985507 Z" }),
	CenterAlign: /* @__PURE__ */ jsx("path", { d: "M1,16 L15,16 C15.5522847,16 16,16.4477153 16,17 C16,17.5522847 15.5522847,18 15,18 L1,18 C0.44771525,18 6.76353751e-17,17.5522847 0,17 C-6.76353751e-17,16.4477153 0.44771525,16 1,16 Z M3,12 L13,12 C13.5522847,12 14,12.4477153 14,13 C14,13.5522847 13.5522847,14 13,14 L3,14 C2.44771525,14 2,13.5522847 2,13 C2,12.4477153 2.44771525,12 3,12 Z M1,8 L15,8 C15.5522847,8 16,8.44771525 16,9 C16,9.55228475 15.5522847,10 15,10 L1,10 C0.44771525,10 6.76353751e-17,9.55228475 0,9 C-6.76353751e-17,8.44771525 0.44771525,8 1,8 Z M3,4 L13,4 C13.5522847,4 14,4.44771525 14,5 C14,5.55228475 13.5522847,6 13,6 L3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 Z" }),
	Check: /* @__PURE__ */ jsx("path", { d: "M8,6 C10.7614237,6 13,8.23857625 13,11 C13,13.7614237 10.7614237,16 8,16 C5.23857625,16 3,13.7614237 3,11 C3,8.23857625 5.23857625,6 8,6 Z M9.86788857,8.5 L7.09668861,11.2517053 L6.13211143,10.2939137 L5,11.418061 L7.09668861,13.5 L11,9.62414734 L9.86788857,8.5 Z" }),
	CheckList: /* @__PURE__ */ jsx("path", { d: "M4,16 L16,16 L16,16 L16,18 L4,18 C3.44771525,18 3,17.5522847 3,17 C3,16.4477153 3.44771525,16 4,16 Z M4,12 L16,12 L16,12 L16,14 L4,14 C3.44771525,14 3,13.5522847 3,13 C3,12.4477153 3.44771525,12 4,12 Z M8,8 L16,8 L16,8 L16,10 L8,10 C7.44771525,10 7,9.55228475 7,9 C7,8.44771525 7.44771525,8 8,8 Z M8,4 L16,4 L16,4 L16,6 L8,6 C7.44771525,6 7,5.55228475 7,5 C7,4.44771525 7.44771525,4 8,4 Z M2.09668861,6.75170532 L4.86788857,4 L6,5.12414734 L2.09668861,9 L0,6.91806102 L1.13211143,5.79391368 L2.09668861,6.75170532 Z" }),
	Close: /* @__PURE__ */ jsx("path", { d: "M8,9.57142857 L10.8643218,6.70710678 C11.2548461,6.31658249 11.8880111,6.31658249 12.2785354,6.70710678 L12.2928932,6.72146465 C12.6834175,7.11198894 12.6834175,7.74515392 12.2928932,8.13567821 L9.42857143,11 L9.42857143,11 L12.2928932,13.8643218 C12.6834175,14.2548461 12.6834175,14.8880111 12.2928932,15.2785354 L12.2785354,15.2928932 C11.8880111,15.6834175 11.2548461,15.6834175 10.8643218,15.2928932 L8,12.4285714 L8,12.4285714 L5.13567821,15.2928932 C4.74515392,15.6834175 4.11198894,15.6834175 3.72146465,15.2928932 L3.70710678,15.2785354 C3.31658249,14.8880111 3.31658249,14.2548461 3.70710678,13.8643218 L6.57142857,11 L6.57142857,11 L3.70710678,8.13567821 C3.31658249,7.74515392 3.31658249,7.11198894 3.70710678,6.72146465 L3.72146465,6.70710678 C4.11198894,6.31658249 4.74515392,6.31658249 5.13567821,6.70710678 L8,9.57142857 L8,9.57142857 Z" }),
	CloseSide: /* @__PURE__ */ jsx("path", { d: "M7.65304175,10 L10,6 L8.27139875,6 L5,10.8811014 L5,11.1188986 L8.27139875,16 L10,16 L7.64715965,12 L16,12 L16,10 L7.65304175,10 Z M0,5 L2,5 L2,17 L0,17 L0,5 Z" }),
	Cloud: /* @__PURE__ */ jsx("path", { d: "M13.9072417,10.1396253 C15.1206325,10.5241334 16,11.659373 16,13 C16,14.6568542 14.6568542,16 13,16 L2,16 C0.8954305,16 0,15.1045695 0,14 C0,12.8954305 0.8954305,12 2,12 L2.03544443,12 C2.27805926,10.3038529 3.73676405,9 5.5,9 C5.8333359,9 6.15578814,9.0465985 6.46119787,9.13363665 C7.13180888,7.86472356 8.46492093,7 10,7 C11.9137769,7 13.5136465,8.3439974 13.9072417,10.1396253 L13.9072417,10.1396253 Z" }),
	CloudStrike: /* @__PURE__ */ jsx("path", { d: "M4.05025253,16.9497475 L3.34314575,16.2426407 L3.586,15.9991458 L2,16 C0.8954305,16 -1.24344979e-14,15.1045695 -1.24344979e-14,14 C-1.24344979e-14,12.9456382 0.815877791,12.0818349 1.85073766,12.0054857 L2.03544443,12 C2.27805926,10.3038529 3.73676405,9 5.5,9 C5.8333359,9 6.15578814,9.0465985 6.46119787,9.13363665 C7.13180888,7.86472356 8.46492093,7 10,7 C10.741609,7 11.4360803,7.20182075 12.0314866,7.55353509 L13.2426407,6.34314575 L13.9497475,7.05025253 L4.05025253,16.9497475 Z M13.9072417,10.1396253 C15.1206325,10.5241334 16,11.659373 16,13 C16,14.6568542 14.6568542,16 13,16 L6.414,15.9991458 L7.414,14.9991458 L13,15 L13.1492623,14.9945143 C14.1841222,14.9181651 15,14.0543618 15,13 C15,11.8954305 14.1045695,11 13,11 C13,10.5367348 12.8949941,10.0979951 12.707485,9.70628361 L13.4460366,8.96778846 C13.657889,9.3262544 13.8154028,9.72064548 13.9072417,10.1396253 Z M10,8 C8.50301765,8 7.26212437,9.09644762 7.03829473,10.5291611 C6.61410295,10.1975979 6.0801272,10 5.5,10 C4.11928813,10 3,11.1192881 3,12.5 C3,12.6142576 3.00766489,12.726725 3.02250854,12.836916 L3.05009729,13.0004345 L2,13 L1.88337887,13.0067277 C1.38604019,13.0644928 1,13.4871642 1,14 C1,14.5128358 1.38604019,14.9355072 1.88337887,14.9932723 L2,15 L4.586,14.9991458 L11.2937164,8.29251502 C10.9020049,8.10500593 10.4632652,8 10,8 Z" }),
	CloudTick: /* @__PURE__ */ jsx("path", { d: "M10,7 C11.9137769,7 13.5136465,8.3439974 13.9072417,10.1396253 C15.1206325,10.5241334 16,11.659373 16,13 C16,14.6568542 14.6568542,16 13,16 L2,16 C0.8954305,16 0,15.1045695 0,14 C0,12.8954305 0.8954305,12 2,12 L2.03544443,12 C2.27805926,10.3038529 3.73676405,9 5.5,9 C5.8333359,9 6.15578814,9.0465985 6.46119787,9.13363665 C7.13180888,7.86472356 8.46492093,7 10,7 Z M9.86788857,9.5 L7.09668861,12.2517053 L6.13211143,11.2939137 L5,12.418061 L7.09668861,14.5 L11,10.6241473 L9.86788857,9.5 Z" }),
	Code: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.5194 8.60632V6.59894L0 9.49412V11.0668L5.5194 13.9906V11.9688L2.18068 10.2816L5.5194 8.60632Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.4806 8.60632V6.59894L16 9.49412V11.0668L10.4806 13.9906V11.9688L13.8193 10.2816L10.4806 8.60632Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.91324 17.0133L8.63436 3.56994L10.0868 3.57437L7.36565 17.0177L5.91324 17.0133Z"
		})
	] }),
	CodeBlock: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", { d: "M0.349591 9.86358L4.68839 12.1619V10.9062L1.538 9.31423L4.68839 7.73342V6.48896L0.349591 8.76487V9.86358Z" }),
		/* @__PURE__ */ jsx("path", { d: "M13.7407 8.78729L9.4019 6.48896V7.73342L12.5523 9.33665L9.4019 10.9175V12.1619L13.7407 9.88601V8.78729Z" }),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.1019 5.99056L14.0407 8.60672V10.0674L9.1019 12.6581V10.7323L11.8871 9.33476L9.1019 7.91737V5.99056ZM4.98839 5.99283V7.91854L2.20503 9.31517L4.98839 10.7217V12.6603L0.0495911 10.0442V8.58346L4.98839 5.99283ZM0.649591 8.94627V9.68301L4.38839 11.6635V11.0908L0.870966 9.31328L4.38839 7.54831V6.98509L0.649591 8.94627ZM9.7019 6.98737V7.54948L13.2175 9.33854L9.7019 11.1026V11.6658L13.4407 9.7046V8.96787L9.7019 6.98737Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.23862 15.1338L7.59078 3.51326L8.8771 3.51709L6.52496 15.1376L5.23862 15.1338Z"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.0127 11.0262L16.014 11.0262V16.7694C16.014 17.6668 15.2864 18.3944 14.389 18.3944H3.61815C2.72069 18.3944 1.99315 17.6668 1.99315 16.7694V13.6654H3.24315V16.7694C3.24315 16.9765 3.41104 17.1444 3.61815 17.1444H14.389C14.5961 17.1444 14.764 16.9765 14.764 16.7694V12.2762L14.0127 12.2762V11.0262Z"
		})
	] }),
	CodeBlockLanguageCaption: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.00016 3.33333C4.31826 3.33333 1.3335 6.3181 1.3335 10C1.3335 13.6814 4.31747 16.6659 7.99869 16.6667H8.00163C11.6829 16.6659 14.6668 13.6814 14.6668 10C14.6668 6.3181 11.6821 3.33333 8.00016 3.33333ZM2.76043 9C2.69898 9.32392 2.66683 9.6582 2.66683 10C2.66683 10.3418 2.69898 10.6761 2.76043 11H4.72226C4.68634 10.6744 4.66683 10.3404 4.66683 10C4.66683 9.65956 4.68634 9.32561 4.72226 9H2.76043ZM3.20298 7.66667H4.96607C5.18164 6.82392 5.49287 6.06852 5.82955 5.44185C5.90684 5.29798 5.98604 5.15984 6.06642 5.02804C4.81236 5.51613 3.78857 6.46499 3.20298 7.66667ZM6.06508 9C6.02322 9.32476 6.00016 9.65902 6.00016 10C6.00016 10.341 6.02322 10.6752 6.06508 11H9.93525C9.9771 10.6752 10.0002 10.341 10.0002 10C10.0002 9.65902 9.9771 9.32476 9.93525 9H6.06508ZM9.65098 7.66667H6.34934C6.527 7.0713 6.75736 6.53216 7.00411 6.07287C7.27487 5.56889 7.5561 5.17848 7.79132 4.92456C7.87334 4.83601 7.94373 4.77063 8.00016 4.72468C8.0566 4.77063 8.12699 4.83601 8.209 4.92456C8.44422 5.17848 8.72546 5.56889 8.99622 6.07287C9.24297 6.53216 9.47332 7.0713 9.65098 7.66667ZM11.2781 9C11.314 9.32561 11.3335 9.65956 11.3335 10C11.3335 10.3404 11.314 10.6744 11.2781 11H13.2399C13.3013 10.6761 13.3335 10.3418 13.3335 10C13.3335 9.6582 13.3013 9.32392 13.2399 9H11.2781ZM12.7973 7.66667H11.0343C10.8187 6.82392 10.5075 6.06852 10.1708 5.44185C10.0935 5.29798 10.0143 5.15984 9.93391 5.02804C11.188 5.51613 12.2118 6.46499 12.7973 7.66667ZM6.06642 14.972C4.81236 14.4839 3.78856 13.535 3.20298 12.3333H4.96607C5.18164 13.1761 5.49287 13.9315 5.82955 14.5582C5.90684 14.702 5.98604 14.8402 6.06642 14.972ZM7.00411 13.9271C6.75736 13.4678 6.527 12.9287 6.34934 12.3333H9.65098C9.47332 12.9287 9.24297 13.4678 8.99622 13.9271C8.72546 14.4311 8.44422 14.8215 8.209 15.0754C8.12699 15.164 8.0566 15.2294 8.00016 15.2753C7.94373 15.2294 7.87334 15.164 7.79132 15.0754C7.5561 14.8215 7.27487 14.4311 7.00411 13.9271ZM10.1708 14.5582C10.5075 13.9315 10.8187 13.1761 11.0343 12.3333H12.7973C12.2118 13.535 11.188 14.4839 9.93391 14.972C10.0143 14.8402 10.0935 14.702 10.1708 14.5582Z",
		fill: "#5B6F98"
	}) }),
	CodeBlockLineNumbers: /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 4.02032H15V5.02032H7V4.02032ZM7 9.01016H15V10.0102H7V9.01016ZM7 14H15V15H7V14ZM4 7.79531H2.54766V3.74375L1 4.16172V2.94375L3.75547 2H4V7.79531Z"
	}), /* @__PURE__ */ jsx("path", { d: "M5.28571 17H1.12292V16.1063L3.04043 14.1077C3.51298 13.5741 3.74925 13.1503 3.74925 12.8362C3.74925 12.5816 3.69325 12.3879 3.58126 12.2552C3.46927 12.1225 3.30675 12.0562 3.09369 12.0562C2.88336 12.0562 2.71265 12.1449 2.58153 12.3223C2.45042 12.4997 2.38487 12.7211 2.38487 12.9865H1C1 12.6236 1.0915 12.2884 1.27452 11.981C1.45753 11.6737 1.71155 11.4333 2.0366 11.26C2.36165 11.0867 2.72494 11 3.12647 11C3.7711 11 4.26755 11.1476 4.61581 11.4428C4.96408 11.738 5.13821 12.1618 5.13821 12.7143C5.13821 12.9472 5.09451 13.174 5.0071 13.3947C4.91969 13.6154 4.7838 13.847 4.59943 14.0894C4.41505 14.3318 4.118 14.6561 3.70828 15.0623L2.93799 15.9438H5.28571V17Z" })] }),
	Color: /* @__PURE__ */ jsx("path", { d: "M16,17 L16,19 L-1.13686838e-13,19 L-1.13686838e-13,17 L16,17 Z M9.0703125,5 L13.375,16 L11.3125,16 L10.3828125,13.7265625 L5.9765625,13.7265625 L5.0546875,16 L3,16 L7.296875,5 L9.0703125,5 Z M8.1796875,7.4140625 L6.53125,12.1328125 L9.828125,12.1328125 L8.1796875,7.4140625 Z" }),
	Comment: /* @__PURE__ */ jsx("path", { d: "M1,4 L15,4 C15.5522847,4 16,4.44771525 16,5 L16,14 C16,14.5522847 15.5522847,15 15,15 L4.24264069,15 C3.44699122,15 2.68392948,15.3160705 2.12132034,15.8786797 L0,18 L0,5 C0,4.44771525 0.44771525,4 1,4 Z M3,12 L3,13 L8.5,13 C8.77614237,13 9,12.7761424 9,12.5 C9,12.2238576 8.77614237,12 8.5,12 L3,12 L3,12 Z M3,9 L3,10 L10.5,10 C10.7761424,10 11,9.77614237 11,9.5 C11,9.22385763 10.7761424,9 10.5,9 L3,9 L3,9 Z M3,6 L3,7 L12.5,7 C12.7761424,7 13,6.77614237 13,6.5 C13,6.22385763 12.7761424,6 12.5,6 L3,6 L3,6 Z" }),
	Copy: /* @__PURE__ */ jsx("path", { d: "M9.5,7.5 L2.5,7.5 C1.98716416,7.5 1.56449284,7.88604019 1.50672773,8.38337887 L1.5,8.5 L1.5,16.5 C1.5,17.0128358 1.88604019,17.4355072 2.38337887,17.4932723 L2.5,17.5 L9.5,17.5 C10.0128358,17.5 10.4355072,17.1139598 10.4932723,16.6166211 L10.5,16.5 L10.5,8.5 C10.5,7.98716416 10.1139598,7.56449284 9.61662113,7.50672773 L9.5,7.5 Z M12,17 C12,18.1045695 11.1045695,19 10,19 L2,19 C0.8954305,19 0,18.1045695 0,17 L0,8 C0,6.8954305 0.8954305,6 2,6 L10,6 C11.1045695,6 12,6.8954305 12,8 L12,14.5 L13.5,14.5 C14.0128358,14.5 14.4355072,14.1139598 14.4932723,13.6166211 L14.5,13.5 L14.5,5.5 C14.5,4.94771525 14.0522847,4.5 13.5,4.5 L6.5,4.5 C5.98716416,4.5 5.56449284,4.88604019 5.50672773,5.38337887 L5.5,5.5 L5.5,5.999 L4,5.999 L4,5 C4,3.8954305 4.8954305,3 6,3 L14,3 C15.1045695,3 16,3.8954305 16,5 L16,14 C16,15.1045695 15.1045695,16 14,16 L12,16 L12,17 Z" }),
	DeleteCol: /* @__PURE__ */ jsx("path", { d: "M14,4 C15.1045695,4 16,4.8954305 16,6 L16,16 C16,17.1045695 15.1045695,18 14,18 L11,18 C9.8954305,18 9,17.1045695 9,16 L9,6 C9,4.8954305 9.8954305,4 11,4 L14,4 Z M14.5,11.5 L10.5,11.5 L10.5,15.5 C10.5,16.0522847 10.9477153,16.5 11.5,16.5 L13.5,16.5 C14.0128358,16.5 14.4355072,16.1139598 14.4932723,15.6166211 L14.5,15.5 L14.5,11.5 Z M2.28033009,8.21966991 L3.87132034,9.81066017 L5.4623106,8.21966991 C5.75520382,7.9267767 6.23007755,7.9267767 6.52297077,8.21966991 C6.81586399,8.51256313 6.81586399,8.98743687 6.52297077,9.28033009 L4.93198052,10.8713203 L6.52297077,12.4623106 C6.81586399,12.7552038 6.81586399,13.2300776 6.52297077,13.5229708 C6.23007755,13.815864 5.75520382,13.815864 5.4623106,13.5229708 L3.87132034,11.9319805 L2.28033009,13.5229708 C1.98743687,13.815864 1.51256313,13.815864 1.21966991,13.5229708 C0.926776695,13.2300776 0.926776695,12.7552038 1.21966991,12.4623106 L2.81066017,10.8713203 L1.21966991,9.28033009 C0.926776695,8.98743687 0.926776695,8.51256313 1.21966991,8.21966991 C1.51256313,7.9267767 1.98743687,7.9267767 2.28033009,8.21966991 Z M13.5,5.5 L11.5,5.5 C10.9477153,5.5 10.5,5.94771525 10.5,6.5 L10.5,10.5 L14.5,10.5 L14.5,6.5 C14.5,5.94771525 14.0522847,5.5 13.5,5.5 Z" }),
	DeleteRow: /* @__PURE__ */ jsx("path", { d: "M13,12 C14.1045695,12 15,12.8954305 15,14 L15,17 C15,18.1045695 14.1045695,19 13,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,14 C1,12.8954305 1.8954305,12 3,12 L13,12 Z M7.5,13.5 L3.5,13.5 C2.94771525,13.5 2.5,13.9477153 2.5,14.5 L2.5,16.5 C2.5,17.0128358 2.88604019,17.4355072 3.38337887,17.4932723 L3.5,17.5 L7.5,17.5 L7.5,13.5 Z M12.5,13.5 L8.5,13.5 L8.5,17.5 L12.5,17.5 C13.0522847,17.5 13.5,17.0522847 13.5,16.5 L13.5,14.5 C13.5,13.9477153 13.0522847,13.5 12.5,13.5 Z M6.28033009,4.21966991 L7.87132034,5.81066017 L9.4623106,4.21966991 C9.75520382,3.9267767 10.2300776,3.9267767 10.5229708,4.21966991 C10.815864,4.51256313 10.815864,4.98743687 10.5229708,5.28033009 L8.93198052,6.87132034 L10.5229708,8.4623106 C10.815864,8.75520382 10.815864,9.23007755 10.5229708,9.52297077 C10.2300776,9.81586399 9.75520382,9.81586399 9.4623106,9.52297077 L7.87132034,7.93198052 L6.28033009,9.52297077 C5.98743687,9.81586399 5.51256313,9.81586399 5.21966991,9.52297077 C4.9267767,9.23007755 4.9267767,8.75520382 5.21966991,8.4623106 L6.81066017,6.87132034 L5.21966991,5.28033009 C4.9267767,4.98743687 4.9267767,4.51256313 5.21966991,4.21966991 C5.51256313,3.9267767 5.98743687,3.9267767 6.28033009,4.21966991 Z" }),
	DocumentFile: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M0.466073 0.669948V0.672626C0.202715 0.723518 -0.00468088 0.983639 8.03613e-05 1.25594V18.7519C8.03613e-05 19.0559 0.274892 19.3333 0.575429 19.3333H15.424C15.7253 19.3333 16 19.056 16 18.7506V5.22679C15.9946 5.13766 15.9693 5.04956 15.9266 4.97159L11.5113 0.705685C11.454 0.68381 11.3927 0.671757 11.3312 0.669227H0.574995C0.539286 0.665804 0.501782 0.666525 0.466073 0.669948Z",
			fill: "#035AC4"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "5.79492",
			width: "10.9983",
			height: "1.2",
			rx: "0.6",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "8.79492",
			width: "10.9983",
			height: "1.2",
			rx: "0.6",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "11.7949",
			width: "10.9983",
			height: "1.2",
			rx: "0.6",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "14.7949",
			width: "6.00303",
			height: "1.2",
			rx: "0.6",
			fill: "white"
		})
	] }),
	Down: /* @__PURE__ */ jsx("polygon", { points: "9 14.347 13 12 13 13.729 8.119 17 7.881 17 3 13.729 3 12 7 14.353 7 5 9 5" }),
	DownArrowhead: /* @__PURE__ */ jsx("polygon", { points: "11 11.729 8.071 14 7.929 14 5 11.729 5 10 7.996 11.937 11 10" }),
	DownCaret: /* @__PURE__ */ jsx("polygon", { points: "5 9 8 14 11 9" }),
	Download: /* @__PURE__ */ jsx("path", { d: "M14,17 L14,15 L16,15 L16,19 L0,19 L0,15 L2,15 L2,17 L14,17 Z M9,11.3469582 L13,9 L13,10.7286013 L8.11889862,14 L7.88110138,14 L3,10.7286013 L3,9 L7,11.3528403 L7,3 L9,3 L9,11.3469582 Z" }),
	Edit: /* @__PURE__ */ jsx("path", { d: "M9.81629639,6.69611308 L12.2670532,9.09477919 L4.91478271,16.2907775 L2,17 L2.46402588,13.8921114 L9.81629639,6.69611308 Z M11.5492432,5 L14,7.39866612 L12.7130432,8.6582687 L10.2622864,6.25960258 L11.5492432,5 Z" }),
	Equation: /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M12.7966 16.0403C12.5632 16.0403 12.3881 15.9694 12.2714 15.8277C12.1546 15.686 12.0379 15.3441 11.9212 14.8022L11.6711 13.6392L10.7832 14.8898C10.5247 15.2566 10.2829 15.5359 10.0578 15.7277C9.84107 15.9111 9.59513 16.0028 9.32 16.0028C9.15326 16.0028 9.01986 15.9569 8.91981 15.8652C8.81977 15.7652 8.76974 15.6318 8.76974 15.465C8.76974 15.315 8.81977 15.1899 8.91981 15.0899C9.01152 14.9898 9.12824 14.9398 9.26998 14.9398C9.3867 14.9398 9.49091 14.969 9.58262 15.0273C9.69101 15.094 9.79522 15.1274 9.89527 15.1274C10.062 15.1274 10.2538 14.9815 10.4705 14.6897L11.5835 13.139L11.2084 11.3256C11.15 11.0588 11.0625 10.8671 10.9458 10.7503C10.8374 10.6336 10.6706 10.5753 10.4455 10.5753C10.3371 10.5753 10.2329 10.5794 10.1329 10.5878C10.0412 10.5961 9.95363 10.6086 9.87025 10.6253L9.90777 10.3877C10.3997 10.3293 10.7957 10.2459 11.0958 10.1376C11.2376 10.0875 11.3584 10.0542 11.4585 10.0375C11.5669 10.0125 11.6502 10 11.7086 10C11.8587 10 11.9587 10.1209 12.0087 10.3627L12.3589 12.051C12.7091 11.5424 12.9967 11.1422 13.2218 10.8504C13.4469 10.5503 13.6053 10.3585 13.697 10.2751C13.7887 10.1834 13.8888 10.1209 13.9972 10.0875C14.1139 10.0459 14.2348 10.025 14.3598 10.025C14.7517 10.025 14.9476 10.1918 14.9476 10.5252C14.9476 10.6753 14.9018 10.7962 14.81 10.8879C14.7183 10.9796 14.6016 11.0255 14.4599 11.0255C14.3348 11.0255 14.2223 10.9963 14.1222 10.9379C14.0639 10.9046 14.0138 10.8837 13.9722 10.8754C13.9388 10.8671 13.9013 10.8629 13.8596 10.8629C13.7762 10.8629 13.6845 10.9046 13.5845 10.988C13.5094 11.0547 13.1301 11.5674 12.4464 12.5262L12.8216 14.2645C12.8633 14.4229 12.9008 14.5646 12.9342 14.6897C12.9675 14.8064 13.0009 14.9064 13.0342 14.9898C13.1093 15.1566 13.2176 15.2399 13.3594 15.2399C13.5928 15.2399 13.9263 14.9231 14.3598 14.2895L14.5349 14.4896C13.8513 15.5234 13.2718 16.0403 12.7966 16.0403Z",
		strokeWidth: "0.6"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.50809 5.74344H14.8501V4.37568L8.54779 4.24891L8.27622 4.23462L4.8959 13.8777L3.55371 9.96993H0.94342V11.6541H2.28352L4.18149 16.9965H5.59118L9.50809 5.74344Z"
	})] }),
	EquationInline: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M6.6045 16.0403C6.37106 16.0403 6.19598 15.9694 6.07926 15.8277C5.96254 15.686 5.84582 15.3441 5.7291 14.8022L5.47898 13.6392L4.59107 14.8898C4.33262 15.2566 4.09084 15.5359 3.86573 15.7277C3.64897 15.9111 3.40302 16.0028 3.12789 16.0028C2.96115 16.0028 2.82775 15.9569 2.72771 15.8652C2.62766 15.7652 2.57764 15.6318 2.57764 15.465C2.57764 15.315 2.62766 15.1899 2.72771 15.0899C2.81942 14.9898 2.93614 14.9398 3.07787 14.9398C3.19459 14.9398 3.2988 14.969 3.39051 15.0273C3.4989 15.094 3.60311 15.1274 3.70316 15.1274C3.8699 15.1274 4.06166 14.9815 4.27842 14.6897L5.39144 13.139L5.01627 11.3256C4.95791 11.0588 4.87037 10.8671 4.75364 10.7503C4.64526 10.6336 4.47852 10.5753 4.25341 10.5753C4.14503 10.5753 4.04081 10.5794 3.94077 10.5878C3.84906 10.5961 3.76152 10.6086 3.67815 10.6253L3.71566 10.3877C4.20756 10.3293 4.60358 10.2459 4.90371 10.1376C5.04545 10.0875 5.16634 10.0542 5.26638 10.0375C5.37477 10.0125 5.45814 10 5.5165 10C5.66657 10 5.76661 10.1209 5.81664 10.3627L6.1668 12.051C6.51696 11.5424 6.8046 11.1422 7.0297 10.8504C7.2548 10.5503 7.41321 10.3585 7.50492 10.2751C7.59663 10.1834 7.69668 10.1209 7.80506 10.0875C7.92178 10.0459 8.04267 10.025 8.16773 10.025C8.55958 10.025 8.7555 10.1918 8.7555 10.5252C8.7555 10.6753 8.70964 10.7962 8.61794 10.8879C8.52623 10.9796 8.40951 11.0255 8.26777 11.0255C8.14271 11.0255 8.03016 10.9963 7.93012 10.9379C7.87176 10.9046 7.82173 10.8837 7.78005 10.8754C7.7467 10.8671 7.70918 10.8629 7.6675 10.8629C7.58412 10.8629 7.49241 10.9046 7.39237 10.988C7.31733 11.0547 6.93799 11.5674 6.25434 12.5262L6.62951 14.2645C6.6712 14.4229 6.70872 14.5646 6.74207 14.6897C6.77541 14.8064 6.80876 14.9064 6.84211 14.9898C6.91715 15.1566 7.02553 15.2399 7.16726 15.2399C7.4007 15.2399 7.73419 14.9231 8.16773 14.2895L8.34281 14.4896C7.65916 15.5234 7.07972 16.0403 6.6045 16.0403Z",
			strokeWidth: "0.6"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11.9465 16.8062H10.9867C10.8542 16.8062 10.7467 16.6992 10.7467 16.5672C10.7467 16.4354 10.8542 16.3284 10.9867 16.3284H11.9465C12.079 16.3284 12.1865 16.2213 12.1865 16.0894V6.05443C12.1864 5.92251 12.0789 5.81548 11.9465 5.81548H10.9867C10.8542 5.81548 10.7467 5.70844 10.7467 5.5766C10.7467 5.44468 10.8542 5.33765 10.9867 5.33765H11.9465C12.3434 5.33765 12.6664 5.65924 12.6664 6.05443V16.0894C12.6664 16.4846 12.3434 16.8062 11.9465 16.8062Z",
			strokeWidth: "0.65"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M13.8213 16.8062H12.8614C12.4645 16.8062 12.1415 16.4846 12.1415 16.0894V6.05443C12.1415 5.65924 12.4645 5.33765 12.8614 5.33765H13.8213C13.9537 5.33765 14.0612 5.44468 14.0612 5.5766C14.0612 5.70844 13.9537 5.81548 13.8213 5.81548H12.8614C12.7289 5.81548 12.6214 5.92251 12.6214 6.05443V16.0894C12.6214 16.2213 12.7289 16.3284 12.8614 16.3284H13.8213C13.9537 16.3284 14.0612 16.4354 14.0612 16.5673C14.0612 16.6992 13.9537 16.8062 13.8213 16.8062Z",
			strokeWidth: "0.65"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11.6551 11.072H13.1551",
			strokeWidth: "0.75",
			strokeLinecap: "round"
		})
	] }),
	Expand: /* @__PURE__ */ jsx("path", { d: "M10,6 C11.1045695,6 12,6.8954305 12,8 L12,17 C12,18.1045695 11.1045695,19 10,19 L2,19 C0.8954305,19 0,18.1045695 0,17 L0,8 C0,6.8954305 0.8954305,6 2,6 L10,6 Z M10,7.5 L2,7.5 C1.75454011,7.5 1.55039163,7.67687516 1.50805567,7.91012437 L1.5,8 L1.5,17 C1.5,17.2454599 1.67687516,17.4496084 1.91012437,17.4919443 L2,17.5 L10,17.5 C10.2454599,17.5 10.4496084,17.3231248 10.4919443,17.0898756 L10.5,17 L10.5,8 C10.5,7.75454011 10.3231248,7.55039163 10.0898756,7.50805567 L10,7.5 Z M16,2 L16,7.5 L14.5,6.5 L14.5,3.5 L11.5,3.5 L10.5,2 L16,2 Z" }),
	Eye: /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", { d: "M8.02 15.015C8.02 15.0177 8.01775 15.02 8.01499 15.02C5.20689 15.0178 2.58916 13.2082 1.18 10.31L1.08111 10.1012C1.02977 9.99282 1.02977 9.86711 1.08111 9.75873L1.18 9.54997C2.58 6.98997 5.36 4.99997 8.04 4.99997C10.49 4.91997 13.08 6.84996 14.28 8.49996C14.5695 8.93422 14.838 9.48371 14.9643 9.75416C15.0134 9.85919 15.0115 9.98014 14.9619 10.0849L14.86 10.3C13.4508 13.2082 10.8331 15.0078 8.02501 15.01C8.02225 15.01 8.02 15.0122 8.02 15.015V15.015ZM3.06765 9.72917C2.99908 9.84717 2.99912 9.99273 3.06745 10.1109C4.22563 12.1132 6.06263 13.57 8.05 13.57C10.0382 13.57 12.6754 11.5101 13.0698 10.054C13.0931 9.96797 13.0784 9.87794 13.0345 9.8004C12.4871 8.83268 10.8285 6.62158 8.05 6.42997C6.06274 6.42997 4.22583 7.73619 3.06765 9.72917Z" }), /* @__PURE__ */ jsx("path", { d: "M8.03999 12.9931C9.69305 12.9931 11.0331 11.653 11.0331 9.99996C11.0331 8.3469 9.69305 7.00684 8.03999 7.00684C6.38694 7.00684 5.04688 8.3469 5.04688 9.99996C5.04688 11.653 6.38694 12.9931 8.03999 12.9931Z" })] }),
	File: /* @__PURE__ */ jsx("path", { d: "M10.5,3 L14,6.5 L14,19 L2,19 L2,3 L10.5,3 Z M8,4.5 L3.5,4.5 L3.5,17.5 L12.5,17.5 L12.5,9 L8,9 L8,4.5 Z M10.75,13.5 C11.1642136,13.5 11.5,13.8357864 11.5,14.25 C11.5,14.6642136 11.1642136,15 10.75,15 L5.25,15 C4.83578644,15 4.5,14.6642136 4.5,14.25 C4.5,13.8357864 4.83578644,13.5 5.25,13.5 L10.75,13.5 Z M10.75,10.5 C11.1642136,10.5 11.5,10.8357864 11.5,11.25 C11.5,11.6642136 11.1642136,12 10.75,12 L5.25,12 C4.83578644,12 4.5,11.6642136 4.5,11.25 C4.5,10.8357864 4.83578644,10.5 5.25,10.5 L10.75,10.5 Z M5.75,7.5 C6.16421356,7.5 6.5,7.83578644 6.5,8.25 C6.5,8.66421356 6.16421356,9 5.75,9 L5.25,9 C4.83578644,9 4.5,8.66421356 4.5,8.25 C4.5,7.83578644 4.83578644,7.5 5.25,7.5 L5.75,7.5 Z M10,4.5 L9.5,4.5 L9.5,7.5 L12.5,7.5 L12.5,7 L10,4.5 Z" }),
	Filter: /* @__PURE__ */ jsx("polygon", { points: "6.5 10.5 2 6 14 6 9.5 10.5 9.5 17 6.5 15" }),
	FirstLine: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 16C0 15.4477 0.447715 15 1 15H16V17H1C0.447715 17 0 16.5523 0 16ZM0 12C0 11.4477 0.447715 11 1 11H16V13H1C0.447715 13 0 12.5523 0 12ZM7 8C7 7.44772 7.44772 7 8 7H16V9H8C7.44772 9 7 8.55228 7 8ZM2.7286 3L5 5.92866V6.07134L2.7286 9H1L2.93737 6.00375L1 3H2.7286Z"
	}),
	Footer: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", { d: "M2.68103 13.3925V8.96237H3.60137V7.82258H2.68103V7.34946C2.68103 6.97312 2.78931 6.7043 3.1791 6.7043C3.30903 6.7043 3.46061 6.72581 3.56889 6.74731V5.58602C3.43896 5.54301 3.16827 5.5 2.94089 5.5C1.73904 5.5 1.21932 6.22043 1.21932 7.3172V7.82258H0.450562V8.96237H1.21932V13.3925H2.68103Z" }),
		/* @__PURE__ */ jsx("path", { d: "M13.34 8.96237H14.1304V11.9839C14.1304 13.0161 14.4986 13.4462 15.5813 13.4462C15.7762 13.4462 16.1877 13.4355 16.48 13.3387V12.3387C16.3284 12.3602 16.2743 12.3602 16.1444 12.3602C15.6896 12.3602 15.5922 12.1989 15.5922 11.8226V8.96237H16.5883V7.82258H15.5922V6.3172H14.1304V7.82258H13.34V8.96237Z" }),
		/* @__PURE__ */ jsx("path", { d: "M6.00474 8.04691C4.188 8.04691 3.44293 9.42539 3.44293 10.7329C3.44293 12.1519 4.08593 13.5 5.93329 13.5C7.72962 13.5 8.46448 12.233 8.46448 10.7025C8.46448 9.28349 7.699 8.04691 6.00474 8.04691ZM5.9435 9.13145C6.69877 9.13145 7.0662 9.66865 7.0662 10.7126C7.0662 11.8175 6.67836 12.4155 5.98432 12.4155C5.23926 12.4155 4.85141 11.8175 4.85141 10.6924C4.85141 9.7396 5.23926 9.13145 5.9435 9.13145Z" }),
		/* @__PURE__ */ jsx("path", { d: "M11.1069 8.04691C9.29021 8.04691 8.54514 9.42539 8.54514 10.7329C8.54514 12.1519 9.18814 13.5 11.0355 13.5C12.8318 13.5 13.5667 12.233 13.5667 10.7025C13.5667 9.28349 12.8012 8.04691 11.1069 8.04691ZM11.0457 9.13145C11.801 9.13145 12.1684 9.66865 12.1684 10.7126C12.1684 11.8175 11.7806 12.4155 11.0865 12.4155C10.3415 12.4155 9.95362 11.8175 9.95362 10.6924C9.95362 9.7396 10.3415 9.13145 11.0457 9.13145Z" })
	] }),
	Fullscreen: /* @__PURE__ */ jsx("path", { d: "M5.5,5.5 L2.5,5.5 L2.5,8.5 L1,10 L1,4 L7,4 L5.5,5.5 Z M2.5,13.5 L2.5,16.5 L5.5,16.5 L7,18 L1,18 L1,12 L2.5,13.5 L2.5,13.5 Z M10.5,16.5 L13.5,16.5 L13.5,13.5 L15,12 L15,18 L9,18 L10.5,16.5 L10.5,16.5 Z M13.5,8.5 L13.5,5.5 L10.5,5.5 L9,4 L15,4 L15,10 L13.5,8.5 L13.5,8.5 Z" }),
	Grade: /* @__PURE__ */ jsx("path", { d: "M11,5 L9.5,6.5 L3.5,6.5 L3.5,17.5 L12.5,17.5 L12.5,9.52081528 L14,8.02081528 L14,19 L2,19 L2,5 L11,5 Z M10.25,14 C10.6642136,14 11,14.3357864 11,14.75 C11,15.1642136 10.6642136,15.5 10.25,15.5 L5.75,15.5 C5.33578644,15.5 5,15.1642136 5,14.75 C5,14.3357864 5.33578644,14 5.75,14 L10.25,14 Z M12.8622223,4.27208481 L14.7002899,6.0710844 L9.18608704,11.4680832 L7,12 L7.34801941,9.66908357 L12.8622223,4.27208481 Z M8,8 L6.5,9.5 L5.75,9.5 C5.33578644,9.5 5,9.16421356 5,8.75 C5,8.33578644 5.33578644,8 5.75,8 L8,8 Z M14.1619324,3 L16,4.79899959 L15.0347824,5.74370152 L13.1967148,3.94470194 L14.1619324,3 Z" }),
	Graph: /* @__PURE__ */ jsx("path", { d: "M16,16.5 L16,18 L0,18 L0,16.5 L16,16.5 Z M3,4.5 C3.55228475,4.5 4,4.94771525 4,5.5 L4,15.5 L1,15.5 L1,5.5 C1,4.94771525 1.44771525,4.5 2,4.5 L3,4.5 Z M8,7.5 C8.55228475,7.5 9,7.94771525 9,8.5 L9,15.5 L6,15.5 L6,8.5 C6,7.94771525 6.44771525,7.5 7,7.5 L8,7.5 Z M13,11.5 C13.5522847,11.5 14,11.9477153 14,12.5 L14,15.5 L11,15.5 L11,12.5 C11,11.9477153 11.4477153,11.5 12,11.5 L13,11.5 Z" }),
	Grow: /* @__PURE__ */ jsx("path", { d: "M4.5,16.5 L7.5,16.5 L7.5,16.5 L9,18 L1,18 L1,10 L2.5,11.5 L2.5,14.5 C2.5,15.6045695 3.3954305,16.5 4.5,16.5 Z M11.5,5.5 L8.5,5.5 L8.5,5.5 L7,4 L15,4 L15,12 L13.5,10.5 L13.5,7.5 C13.5,6.3954305 12.6045695,5.5 11.5,5.5 Z" }),
	H1: /* @__PURE__ */ jsx("path", { d: "M2.58,6 L2.58,10.432 L6.492,10.432 L6.492,6 L8.06,6 L8.06,17 L6.492,17 L6.492,12.144 L2.58,12.144 L2.58,17 L1,17 L1,6 L2.58,6 Z M14.25,6.512 L14.25,17 L12.4468571,17 L12.4468571,8.864 C11.9508571,9.136 10.9908571,9.408 10.4468571,9.472 L10.4468571,7.968 C11.3908571,7.776 12.3988571,7.184 13.0388571,6.512 L14.25,6.512 Z" }),
	H2: /* @__PURE__ */ jsx("path", { d: "M10.9623431,8.832 L9.21966527,8.832 C9.36610879,7.536 10.2008368,6 12.4853556,6 C14.6380753,6 15.6046025,7.36 15.6046025,8.816 C15.6046025,10.096 14.9309623,10.72 14.3891213,10.976 L14.3891213,11.008 C15.0920502,11.28 16,11.984 16,13.6 C16,15.168 15.1066946,16.912 12.4707113,16.912 C10.0251046,16.912 9.11715481,15.28 9,13.872 L10.7866109,13.872 C10.9330544,14.672 11.460251,15.36 12.5292887,15.36 C13.6422594,15.36 14.1548117,14.576 14.1548117,13.568 C14.1548117,12.448 13.583682,11.84 12.3974895,11.84 L11.5920502,11.84 L11.5920502,10.288 L12.2949791,10.288 C13.3640167,10.288 13.8033473,9.872 13.8033473,8.912 C13.8033473,8.112 13.3493724,7.568 12.4267782,7.568 C11.3870293,7.568 11.0941423,8.192 10.9623431,8.832 Z M0,17 L1.58,17 L1.58,12.144 L5.492,12.144 L5.492,17 L7.06,17 L7.06,6 L5.492,6 L5.492,10.432 L1.58,10.432 L1.58,6 L0,6 L0,17 Z" }),
	H3: /* @__PURE__ */ jsx("path", { d: "M-3.10862447e-14,17 L1.58,17 L1.58,12.144 L5.492,12.144 L5.492,17 L7.06,17 L7.06,6 L5.492,6 L5.492,10.432 L1.58,10.432 L1.58,6 L-3.10862447e-14,6 L-3.10862447e-14,17 Z M16,17 L9.02959831,17 L9.02959831,16.944 C9.02959831,15.28512 9.77973784,13.8179328 11.6728173,12.2451671 L12.4480153,11.6152697 C13.4600187,10.7759008 13.7801268,10.3607273 13.7801268,9.504 C13.7801268,8.544 13.3361522,7.92 12.3890063,7.92 C11.3530655,7.92 10.9386892,8.576 10.7906977,9.616 L9,9.616 C9.14799154,7.808 10.243129,6.352 12.3890063,6.352 C14.7864693,6.352 15.6300211,7.936 15.6300211,9.472 C15.6300211,10.9593333 15.0727662,11.6678611 13.4502708,12.9635544 L13.2325581,13.136 C11.97463,14.128 11.4122622,14.8 11.2198732,15.392 L16,15.392 L16,17 Z" }),
	H4: /* @__PURE__ */ jsx("path", { d: "M1.58,6 L1.58,10.432 L5.492,10.432 L5.492,6 L7.06,6 L7.06,17 L5.492,17 L5.492,12.144 L1.58,12.144 L1.58,17 L0,17 L0,6 L1.58,6 Z M14.8477275,5.998 L14.8477275,12.7016474 L15.984,12.7016474 L16,14 L14.8477275,14.206815 L14.8477275,16.998 L13.25,16.998 L13.25,14.206815 L8.984,14.206815 L8.984,12.5679088 L12.9539399,5.998 L14.8477275,5.998 Z M13.25,8.416 L10.75,12.75 L13.25,12.75 L13.25,8.416 Z" }),
	Handle: /* @__PURE__ */ jsx("path", { d: "M13,15 C13.5522847,15 14,15.4477153 14,16 C14,16.5522847 13.5522847,17 13,17 L3,17 C2.44771525,17 2,16.5522847 2,16 C2,15.4477153 2.44771525,15 3,15 L13,15 Z M13,11 C13.5522847,11 14,11.4477153 14,12 C14,12.5522847 13.5522847,13 13,13 L3,13 C2.44771525,13 2,12.5522847 2,12 C2,11.4477153 2.44771525,11 3,11 L13,11 Z M13,7 C13.5522847,7 14,7.44771525 14,8 C14,8.55228475 13.5522847,9 13,9 L3,9 C2.44771525,9 2,8.55228475 2,8 C2,7.44771525 2.44771525,7 3,7 L13,7 Z" }),
	HangingIndent: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 4C0 3.44772 0.447715 3 1 3H16V5H1C0.447715 5 0 4.55228 0 4ZM7 12C7 11.4477 7.44772 11 8 11H16V13H8C7.44772 13 7 12.5523 7 12ZM7 16C7 15.4477 7.44772 15 8 15H16V17H8C7.44772 17 7 16.5523 7 16ZM7 8C7 7.44772 7.44772 7 8 7H16V9H8C7.44772 9 7 8.55228 7 8ZM2.7286 9L5 11.9287V12.0713L2.7286 15H1L2.93737 12.0038L1 9H2.7286Z"
	}),
	Happy: /* @__PURE__ */ jsx("path", { d: "M5.01852466,13 C5.75095206,13.6137494 6.81533358,14 8,14 C9.18466642,14 10.2490479,13.6137494 10.9814753,13 L12,13 C12,14.6568542 10.209139,16 8,16 C5.790861,16 4,14.6568542 4,13 L5.01852466,13 L5.01852466,13 Z M8,19 C3.581722,19 0,15.418278 0,11 C0,6.581722 3.581722,3 8,3 C12.418278,3 16,6.581722 16,11 C16,15.418278 12.418278,19 8,19 Z M8,17.5 C11.5898509,17.5 14.5,14.5898509 14.5,11 C14.5,7.41014913 11.5898509,4.5 8,4.5 C4.41014913,4.5 1.5,7.41014913 1.5,11 C1.5,14.5898509 4.41014913,17.5 8,17.5 Z M5.5,10 C4.67157288,10 4,9.32842712 4,8.5 C4,7.67157288 4.67157288,7 5.5,7 C6.32842712,7 7,7.67157288 7,8.5 C7,9.32842712 6.32842712,10 5.5,10 Z M10.5,10 C9.67157288,10 9,9.32842712 9,8.5 C9,7.67157288 9.67157288,7 10.5,7 C11.3284271,7 12,7.67157288 12,8.5 C12,9.32842712 11.3284271,10 10.5,10 Z" }),
	HeaderColumn: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 5C1 4.17157 1.67157 3.5 2.5 3.5H13.5C14.3284 3.5 15 4.17157 15 5V8.5H1V5ZM2.5 4.5C2.22386 4.5 2 4.72386 2 5V7.5H14V5C14 4.72386 13.7761 4.5 13.5 4.5H2.5Z",
			fill: "#C3CDDF"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 7.5H15V12.5H1V7.5ZM2 8.5V11.5H14V8.5H2Z",
			fill: "#C3CDDF"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 11.5H15V15C15 15.8284 14.3284 16.5 13.5 16.5H2.5C1.67157 16.5 1 15.8284 1 15V11.5ZM2 12.5V15C2 15.2761 2.22386 15.5 2.5 15.5H13.5C13.7761 15.5 14 15.2761 14 15V12.5H2Z",
			fill: "#C3CDDF"
		}),
		/* @__PURE__ */ jsx("path", { d: "M1.5 5C1.5 4.44772 1.94772 4 2.5 4H5.83V16H2.5C1.94771 16 1.5 15.5523 1.5 15V5Z" }),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 5C1 4.17157 1.67157 3.5 2.5 3.5H6.33V16.5H2.5C1.67157 16.5 1 15.8284 1 15V5ZM2.5 4.5C2.22386 4.5 2 4.72386 2 5V15C2 15.2761 2.22386 15.5 2.5 15.5H5.33V4.5H2.5Z"
		})
	] }),
	HeaderRow: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 7.5H15V12.5H1V7.5ZM2 8.5V11.5H14V8.5H2Z",
			fill: "#C3CDDF"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 11.5H15V15C15 15.8284 14.3284 16.5 13.5 16.5H2.5C1.67157 16.5 1 15.8284 1 15V11.5ZM2 12.5V15C2 15.2761 2.22386 15.5 2.5 15.5H13.5C13.7761 15.5 14 15.2761 14 15V12.5H2Z",
			fill: "#C3CDDF"
		}),
		/* @__PURE__ */ jsx("path", { d: "M1.5 5C1.5 4.44772 1.94772 4 2.5 4H13.5C14.0523 4 14.5 4.44772 14.5 5V8H1.5V5Z" }),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 5C1 4.17157 1.67157 3.5 2.5 3.5H13.5C14.3284 3.5 15 4.17157 15 5V8.5H1V5ZM2.5 4.5C2.22386 4.5 2 4.72386 2 5V7.5H14V5C14 4.72386 13.7761 4.5 13.5 4.5H2.5Z"
		})
	] }),
	Hide: /* @__PURE__ */ jsx("path", { d: "M13.3137085,5 L14.0208153,5.70710678 L2.70710678,17.0208153 L2,16.3137085 L3.84192505,14.4717835 C2.11787564,13.2000814 1,11.5172033 1,11 C1,10.1340068 4.13400675,6 8,6 C9.20603677,6 10.3408371,6.40231858 11.3314763,6.98223217 L13.3137085,5 Z M8,7.42857143 C5.23857625,7.42857143 3,10.3814334 3,11 C3,11.3581216 3.75034337,12.4986705 4.91807869,13.3956298 L5.56331024,12.7503983 C5.20880297,12.2577665 5,11.6532675 5,11 C5,9.34314575 6.34314575,8 8,8 C8.65326752,8 9.2577665,8.20880297 9.75039826,8.56331024 L10.2547229,8.05898557 C9.57726234,7.68338506 8.81119042,7.42857143 8,7.42857143 Z M6.76294333,14.3791923 C7.15856796,14.5008353 7.57303419,14.5714286 8,14.5714286 C10.7614237,14.5714286 13,11.6185666 13,11 C13,10.7289629 12.5702098,10.0097582 11.8549657,9.28716993 L12.9587551,8.1833805 C14.2202115,9.32292984 15,10.5680306 15,11 C15,11.8659932 11.8659932,16 8,16 C7.17146561,16 6.37655155,15.810124 5.63890204,15.5032336 L6.76294333,14.3791923 Z M10.9027374,10.2393982 C10.9662099,10.4823016 11,10.7372047 11,11 C11,12.6568542 9.65685425,14 8,14 C7.73720474,14 7.48230159,13.9662099 7.23939824,13.9027374 L10.9027374,10.2393982 Z" }),
	Highlight: /* @__PURE__ */ jsx("path", { d: "M12.0208153,5 L14.8492424,7.7990161 L6.36396103,16.1960644 L3.53553391,13.3970483 L12.0208153,5 Z M2.12132034,14.7965563 L4.94974747,17.5955724 L2.82842712,18.9933187 L-2.66453526e-14,18.9933187 L2.12132034,14.7965563 Z M7.6432709,17.0207967 L16,17.0207967 L16,19 L4.70710678,19 L7.6432709,17.0207967 Z" }),
	Home: /* @__PURE__ */ jsx("path", { d: "M8,7 L13,11 L13,17 L9.5,17 L9.5,13.5 C9.5,12.6715729 8.82842712,12 8,12 C7.22030388,12 6.57955132,12.5948881 6.50686658,13.35554 L6.5,13.5 L6.5,17 L3,17 L3,11 L8,7 Z M12,4 L12,7.285 L15,9.75 C15,10.3634564 14.5580907,10.8736994 13.9752401,10.9797607 L8,6 L2.02575182,10.9799408 C1.48341664,10.8817057 1.06289473,10.4335713 1.00645361,9.87780524 L1,9.75 L8,4 L10.5,6.053 L10.5,4 L12,4 Z" }),
	Image: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.06036 9.06927L1.5 11.8516V5H14.5V13.9786L12.1506 11.0654C11.9792 10.8527 11.6688 10.8171 11.4536 10.9853L8.77913 13.0753V13.084L5.7648 9.15871C5.5956 8.93838 5.27925 8.89822 5.06036 9.06927ZM0 4.5C0 3.94772 0.447715 3.5 1 3.5H15C15.5523 3.5 16 3.94772 16 4.5V15.5C16 16.0523 15.5523 16.5 15 16.5H1C0.447715 16.5 0 16.0523 0 15.5V4.5ZM10.2368 10C11.2033 10 11.9868 9.2165 11.9868 8.25C11.9868 7.2835 11.2033 6.5 10.2368 6.5C9.27034 6.5 8.48684 7.2835 8.48684 8.25C8.48684 9.2165 9.27034 10 10.2368 10Z"
	}),
	ImageAlignCenter: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("rect", {
			x: "1",
			y: "14.9976",
			width: "14",
			height: "1.5",
			rx: "0.75"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "4",
			y: "7",
			width: "8",
			height: "6"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "1",
			y: "3.50238",
			width: "14",
			height: "1.5",
			rx: "0.75"
		})
	] }),
	ImageAlignLeft: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("rect", {
			x: "1",
			y: "14.9976",
			width: "14",
			height: "1.5",
			rx: "0.75"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "1.20001",
			y: "7",
			width: "8",
			height: "6"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "1",
			y: "3.50238",
			width: "14",
			height: "1.5",
			rx: "0.75"
		})
	] }),
	ImageAlignRight: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("rect", {
			x: "1",
			y: "14.9976",
			width: "14",
			height: "1.5",
			rx: "0.75"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "6.79999",
			y: "7",
			width: "8",
			height: "6"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "1",
			y: "3.50238",
			width: "14",
			height: "1.5",
			rx: "0.75"
		})
	] }),
	ImageCover: /* @__PURE__ */ jsx("path", { d: "M0,3 L16,3 L16,15 L0,15 L0,3 Z M2.75,16.5 L13.25,16.5 C13.6642136,16.5 14,16.8357864 14,17.25 C14,17.6642136 13.6642136,18 13.25,18 L2.75,18 C2.33578644,18 2,17.6642136 2,17.25 C2,16.8357864 2.33578644,16.5 2.75,16.5 Z" }),
	ImageFile: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M14.5262 2.01123H1.47332C1.08255 2.01123 0.707861 2.16643 0.431528 2.44276C0.155195 2.71908 0 3.09378 0 3.48455V16.5374C0 16.9282 0.155202 17.3029 0.431528 17.5792C0.707854 17.8556 1.08255 18.0108 1.47332 18.0108H14.5262C14.917 18.0108 15.2917 17.8556 15.568 17.5792C15.8443 17.3029 15.9995 16.9282 15.9995 16.5374V3.48455C15.9995 3.09378 15.8443 2.71909 15.568 2.44276C15.2917 2.16643 14.917 2.01123 14.5262 2.01123Z",
			fill: "#5B6F98"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.36426 13.8007L5.91619 8.80517C6.02354 8.65419 6.24634 8.65009 6.35917 8.79702L8.84478 12.0338L10.6722 10.6057C10.7924 10.5118 10.966 10.5334 11.0595 10.654L13.5001 13.8022L8.83559 13.8023V13.8007L3.00038 13.8007L2.36426 13.8007Z",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11.5013 7.20939C11.5013 8.09035 10.7871 8.80452 9.90616 8.80452C9.0252 8.80452 8.31104 8.09035 8.31104 7.20939C8.31104 6.32842 9.0252 5.61426 9.90616 5.61426C10.7871 5.61426 11.5013 6.32842 11.5013 7.20939Z",
			fill: "white"
		})
	] }),
	ImageFit: /* @__PURE__ */ jsx("path", { d: "M2,7 L14,7 L14,15 L2,15 L2,7 Z M2.75,16.5 L13.25,16.5 C13.6642136,16.5 14,16.8357864 14,17.25 C14,17.6642136 13.6642136,18 13.25,18 L2.75,18 C2.33578644,18 2,17.6642136 2,17.25 C2,16.8357864 2.33578644,16.5 2.75,16.5 Z M2.75,4 L13.25,4 C13.6642136,4 14,4.33578644 14,4.75 C14,5.16421356 13.6642136,5.5 13.25,5.5 L2.75,5.5 C2.33578644,5.5 2,5.16421356 2,4.75 C2,4.33578644 2.33578644,4 2.75,4 Z" }),
	ImageOriginal: /* @__PURE__ */ jsx("path", { d: "M0,7 L16,7 L16,15 L0,15 L0,7 Z M2.75,16.5 L13.25,16.5 C13.6642136,16.5 14,16.8357864 14,17.25 C14,17.6642136 13.6642136,18 13.25,18 L2.75,18 C2.33578644,18 2,17.6642136 2,17.25 C2,16.8357864 2.33578644,16.5 2.75,16.5 Z M2.75,4 L13.25,4 C13.6642136,4 14,4.33578644 14,4.75 C14,5.16421356 13.6642136,5.5 13.25,5.5 L2.75,5.5 C2.33578644,5.5 2,5.16421356 2,4.75 C2,4.33578644 2.33578644,4 2.75,4 Z" }),
	Indent: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 16C3 15.4477 3.44772 15 4 15H16V17H4C3.44772 17 3 16.5523 3 16ZM7 12C7 11.4477 7.44772 11 8 11H16V13H8C7.44772 13 7 12.5523 7 12ZM7 8C7 7.44772 7.44772 7 8 7H16V9H8C7.44772 9 7 8.55228 7 8ZM3 4C3 3.44772 3.44772 3 4 3H16V5H4C3.44772 5 3 4.55228 3 4ZM1.7286 7L4 9.92866V10.0713L1.7286 13H0L1.93737 10.0038L0 7H1.7286Z"
		}),
		/* @__PURE__ */ jsx("mask", {
			id: "mask0_856_23608",
			maskUnits: "userSpaceOnUse",
			x: "7",
			y: "7",
			width: "9",
			height: "2",
			children: /* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7 8C7 7.44772 7.44772 7 8 7H16V9H8C7.44772 9 7 8.55228 7 8Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ jsx("g", { mask: "url(#mask0_856_23608)" })
	] }),
	Italic: /* @__PURE__ */ jsx("polygon", { points: "6.652 16 8.216 7 7 7 7 6 11.25 6 11.25 7 10.076 7 8.514 16 10 16 10 17 5 17 5 16" }),
	Justify: /* @__PURE__ */ jsx("path", { d: "M1,16 L15,16 C15.5522847,16 16,16.4477153 16,17 C16,17.5522847 15.5522847,18 15,18 L1,18 C0.44771525,18 6.76353751e-17,17.5522847 0,17 C-6.76353751e-17,16.4477153 0.44771525,16 1,16 Z M1,12 L15,12 C15.5522847,12 16,12.4477153 16,13 C16,13.5522847 15.5522847,14 15,14 L1,14 C0.44771525,14 6.76353751e-17,13.5522847 0,13 C-6.76353751e-17,12.4477153 0.44771525,12 1,12 Z M1,8 L15,8 C15.5522847,8 16,8.44771525 16,9 C16,9.55228475 15.5522847,10 15,10 L1,10 C0.44771525,10 6.76353751e-17,9.55228475 0,9 C-6.76353751e-17,8.44771525 0.44771525,8 1,8 Z M1,4 L15,4 C15.5522847,4 16,4.44771525 16,5 C16,5.55228475 15.5522847,6 15,6 L1,6 C0.44771525,6 6.76353751e-17,5.55228475 0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 Z" }),
	Left: /* @__PURE__ */ jsx("polygon", { points: "4.653 11 14 11 14 13 4.647 13 7 17 5.271 17 2 12.119 2 11.881 5.271 7 7 7" }),
	LeftAlign: /* @__PURE__ */ jsx("path", { d: "M0,16 L15,16 C15.5522847,16 16,16.4477153 16,17 C16,17.5522847 15.5522847,18 15,18 L0,18 L0,18 L0,16 Z M0,12 L11,12 C11.5522847,12 12,12.4477153 12,13 C12,13.5522847 11.5522847,14 11,14 L0,14 L0,14 L0,12 Z M0,8 L15,8 C15.5522847,8 16,8.44771525 16,9 C16,9.55228475 15.5522847,10 15,10 L0,10 L0,10 L0,8 Z M0,4 L11,4 C11.5522847,4 12,4.44771525 12,5 C12,5.55228475 11.5522847,6 11,6 L0,6 L0,6 L0,4 Z" }),
	LeftArrowhead: /* @__PURE__ */ jsx("polygon", { points: "8.271 8 10 8 8.063 11.004 10 14 8.271 14 6 11.071 6 10.929" }),
	LeftCaret: /* @__PURE__ */ jsx("polygon", { points: "9.8 8 9.8 14 5 11" }),
	Line: /* @__PURE__ */ jsx("path", { d: "M13,10 L15,10 C15.5522847,10 16,10.4477153 16,11 C16,11.5522847 15.5522847,12 15,12 L11,12 L11,12 L13,10 Z M7,10 L11,10 L9,12 L5,12 L7,10 Z M1,10 L5,10 L5,10 L3,12 L1,12 C0.44771525,12 6.76353751e-17,11.5522847 0,11 C-6.76353751e-17,10.4477153 0.44771525,10 1,10 Z" }),
	Link: /* @__PURE__ */ jsx("path", { d: "M9.97838504,10.0494529 L13.8578644,13.9289322 C14.6666667,14.7377345 14.6666667,16.0490621 13.8578644,16.8578644 C13.0490621,17.6666667 11.7377345,17.6666667 10.9289322,16.8578644 L7.04945286,12.978385 C6.94319004,13.9434817 7.26003909,14.9463306 8,15.6862915 L10.3431458,18.0294373 C11.6372294,19.3235209 13.7353536,19.3235209 15.0294373,18.0294373 C16.3235209,16.7353536 16.3235209,14.6372294 15.0294373,13.3431458 L12.6862915,11 C11.9991849,10.3128934 11.0854045,9.99061292 10.1856597,10.0331585 L9.97838504,10.0494529 Z M6.02161496,11.9505471 L2.14213562,8.07106781 C1.33333333,7.26226552 1.33333333,5.95093791 2.14213562,5.14213562 C2.95093791,4.33333333 4.26226552,4.33333333 5.07106781,5.14213562 L8.95054714,9.02161496 C9.05680996,8.05651833 8.73996091,7.05366941 8,6.3137085 L5.65685425,3.97056275 C4.36277058,2.67647908 2.26464641,2.67647908 0.970562748,3.97056275 C-0.323520916,5.26464641 -0.323520916,7.36277058 0.970562748,8.65685425 L3.3137085,11 C4.00081506,11.6871066 4.91459546,12.0093871 5.81434026,11.9668415 L6.02161496,11.9505471 Z M3.89949494,8.07106781 L10.9289322,15.1005051 L12.1005051,13.9289322 L5.07106781,6.89949494 L3.89949494,8.07106781 Z" }),
	Lock: /* @__PURE__ */ jsx("path", { d: "M6.0261016,7.23529412 L6.0261016,9 L9.9738984,9 L9.9738984,7.23529412 L6.0261016,7.23529412 L6.0261016,7.23529412 Z M4.71016933,7.23529412 C4.71016933,5.44849052 6.18307669,4 8,4 C9.81692331,4 11.2898307,5.44849052 11.2898307,7.23529412 L11.2898307,9 L13,9 L13,17 L3,17 L3,9 L4.71016933,9 L4.71016933,7.23529412 Z M8,14.5 C8.82842712,14.5 9.5,13.8284271 9.5,13 C9.5,12.1715729 8.82842712,11.5 8,11.5 C7.17157288,11.5 6.5,12.1715729 6.5,13 C6.5,13.8284271 7.17157288,14.5 8,14.5 Z M9.9738984,7.23529412 C9.9738984,6.16321196 9.09015399,5.29411765 8,5.29411765 C6.90984601,5.29411765 6.0261016,6.16321196 6.0261016,7.23529412 L9.9738984,7.23529412 Z" }),
	Mail: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.5 6C1.5 5.44772 1.94772 5 2.5 5H15.5C16.0523 5 16.5 5.44772 16.5 6V14.6667C16.5 15.219 16.0523 15.6667 15.5 15.6667H2.5C1.94772 15.6667 1.5 15.219 1.5 14.6667V6ZM3.3 6.33333C3.13431 6.33333 3 6.46765 3 6.63333V7.23342L9 9.60379L15 7.23342V6.63333C15 6.46765 14.8657 6.33333 14.7 6.33333H3.3ZM15 8.69251L9 11.0629L3 8.69251V14.0333C3 14.199 3.13431 14.3333 3.3 14.3333H14.7C14.8657 14.3333 15 14.199 15 14.0333V8.69251Z"
	}),
	MediaFile: /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M14.5266 2.01123H1.47336C1.08259 2.01123 0.707883 2.16644 0.431541 2.44277C0.155199 2.71911 0 3.09382 0 3.48459V16.5379C0 16.9286 0.155207 17.3033 0.431541 17.5797C0.707875 17.856 1.08259 18.0112 1.47336 18.0112H14.5266C14.9174 18.0112 15.2921 17.856 15.5685 17.5797C15.8448 17.3034 16 16.9286 16 16.5379V3.48459C16 3.09382 15.8448 2.71911 15.5685 2.44277C15.2921 2.16643 14.9174 2.01123 14.5266 2.01123Z",
		fill: "#6355F6"
	}), /* @__PURE__ */ jsx("path", {
		d: "M10.7899 10.1921L6.48488 13.2097C6.26695 13.3637 5.89453 13.2559 5.89453 13.0327V6.98972C5.89453 6.76652 6.26695 6.65879 6.48488 6.81274C8.16608 7.9912 9.10866 8.65191 10.7899 9.83037C10.8574 9.8735 10.8963 9.94154 10.8945 10.0132C10.8926 10.0848 10.8505 10.1513 10.7807 10.1921L10.7899 10.1921Z",
		fill: "white"
	})] }),
	MergeCells: /* @__PURE__ */ jsx("path", { d: "M8,14 C8.24545989,14 8.44960837,14.1768752 8.49194433,14.4101244 L8.5,14.5 L8.5,17.5 C8.5,17.7761424 8.27614237,18 8,18 C7.75454011,18 7.55039163,17.8231248 7.50805567,17.5898756 L7.5,17.5 L7.5,14.5 C7.5,14.2238576 7.72385763,14 8,14 Z M1.63828653,7 C1.92713929,7 2.20188217,7.12490236 2.39178749,7.34255319 L5.5,10.9048811 L5.5,11.0951189 L2.39178749,14.6574468 C2.20188217,14.8750976 1.92713929,15 1.63828653,15 L0,15 L2.90605428,11.0050063 L0,7 L1.63828653,7 Z M16,7 L13.0939457,11.0050063 L16,15 L14.3617135,15 C14.0728607,15 13.7981178,14.8750976 13.6082125,14.6574468 L10.5,11.0951189 L10.5,10.9048811 L13.6082125,7.34255319 C13.7981178,7.12490236 14.0728607,7 14.3617135,7 L16,7 Z M8,9 C8.24545989,9 8.44960837,9.17687516 8.49194433,9.41012437 L8.5,9.5 L8.5,12.5 C8.5,12.7761424 8.27614237,13 8,13 C7.75454011,13 7.55039163,12.8231248 7.50805567,12.5898756 L7.5,12.5 L7.5,9.5 C7.5,9.22385763 7.72385763,9 8,9 Z M8,4 C8.24545989,4 8.44960837,4.17687516 8.49194433,4.41012437 L8.5,4.5 L8.5,7.5 C8.5,7.77614237 8.27614237,8 8,8 C7.75454011,8 7.55039163,7.82312484 7.50805567,7.58987563 L7.5,7.5 L7.5,4.5 C7.5,4.22385763 7.72385763,4 8,4 Z" }),
	Minus: /* @__PURE__ */ jsx("path", { d: "M3,11 L13,11 C13.5522847,11 14,11.4477153 14,12 C14,12.5522847 13.5522847,13 13,13 L3,13 C2.44771525,13 2,12.5522847 2,12 C2,11.4477153 2.44771525,11 3,11 Z" }),
	More: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.7998 10C4.7998 10.8284 4.12823 11.5 3.2998 11.5C2.47138 11.5 1.7998 10.8284 1.7998 10C1.7998 9.17157 2.47138 8.5 3.2998 8.5C4.12823 8.5 4.7998 9.17157 4.7998 10ZM9.9998 10C9.9998 10.8284 9.32823 11.5 8.4998 11.5C7.67137 11.5 6.9998 10.8284 6.9998 10C6.9998 9.17157 7.67137 8.5 8.4998 8.5C9.32823 8.5 9.9998 9.17157 9.9998 10ZM13.6998 11.5C14.5282 11.5 15.1998 10.8284 15.1998 10C15.1998 9.17157 14.5282 8.5 13.6998 8.5C12.8714 8.5 12.1998 9.17157 12.1998 10C12.1998 10.8284 12.8714 11.5 13.6998 11.5Z"
	}),
	Night: /* @__PURE__ */ jsx("path", { d: "M1,14.1092254 C3.76599768,14.9322973 6.88405759,14.2518782 9.06796788,12.0679679 C11.2518782,9.88405759 11.9322973,6.76599768 11.1092254,4 C11.3796606,4.20312866 11.6390818,4.4277322 11.8851602,4.67381064 C14.7049466,7.49359697 14.7049466,12.0653739 11.8851602,14.8851602 C9.06537392,17.7049466 4.49359697,17.7049466 1.67381064,14.8851602 C1.4277322,14.6390818 1.20312866,14.3796606 1,14.1092254 Z" }),
	Notification: /* @__PURE__ */ jsx("path", { d: "M10.4493742,17.0001048 C10.2151842,18.1409563 9.19622531,18.9995655 7.97469784,18.9995655 C6.75317037,18.9995655 5.73421146,18.1409563 5.50002151,17.0001048 L10.4493742,17.0001048 Z M8,6 C11,6 13,8.790861 13,11 L13.0027848,11.6475127 L13.0144899,12.1773893 C13.0573856,13.4451734 13.2272697,14.8640701 13.9000779,14.9908363 L14,15 C14.5128358,15 14.9355072,15.3860402 14.9932723,15.8833789 L15,16 L1,16 C1,15.4477153 1.44771525,15 2,15 L2.0999221,14.9913636 C3,14.8314435 3,12.486965 3,11 C3,8.790861 5,6 8,6 Z M8,7.5 C6.12012697,7.5 4.5,9.30316915 4.5,11 L4.49201162,12.0393038 L4.47855772,12.4557373 C4.4464841,13.2309856 4.38737316,13.8920368 4.26696013,14.4419723 L4.252,14.5 L11.794,14.5 L11.7816973,14.4542704 C11.7497178,14.326779 11.7210218,14.1943548 11.695099,14.0572765 L11.6582307,13.8482034 C11.5536642,13.2118272 11.5128271,12.5371267 11.5027362,11.6484468 L11.5,11 C11.5,9.30316915 9.87987303,7.5 8,7.5 Z M8,3 C8.55228475,3 9,3.44771525 9,4 C9,4.55228475 8.55228475,5 8,5 C7.44771525,5 7,4.55228475 7,4 C7,3.44771525 7.44771525,3 8,3 Z" }),
	NumberList: /* @__PURE__ */ jsx("path", { d: "M4,16 L16,16 L16,16 L16,18 L4,18 C3.44771525,18 3,17.5522847 3,17 C3,16.4477153 3.44771525,16 4,16 Z M4,12 L16,12 L16,12 L16,14 L4,14 C3.44771525,14 3,13.5522847 3,13 C3,12.4477153 3.44771525,12 4,12 Z M8,8 L16,8 L16,8 L16,10 L8,10 C7.44771525,10 7,9.55228475 7,9 C7,8.44771525 7.44771525,8 8,8 Z M8,4 L16,4 L16,4 L16,6 L8,6 C7.44771525,6 7,5.55228475 7,5 C7,4.44771525 7.44771525,4 8,4 Z M4,9.795312 L2.547656,9.795312 L2.547656,5.74375 L1,6.161719 L1,4.94375 L3.755469,4 L4,4 L4,9.795312 Z" }),
	Open: /* @__PURE__ */ jsx("path", { d: "M13.1849786,4.5 L1.5,4.5 L1.5,17.5 L14.5,17.5 L14.5,5.8150214 L8.3150214,12 L7,10.6849786 L13.1849786,4.5 Z M16,13 L16,19 L0,19 L0,3 L6,3 L7,4.5 L11,4.5 L10,3 L16,3 L16,9 L14.5,8 L14.5,12 L16,13 Z" }),
	Outdent: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 16C3 15.4477 3.44772 15 4 15H16V17H4C3.44772 17 3 16.5523 3 16ZM7 12C7 11.4477 7.44772 11 8 11H16V13H8C7.44772 13 7 12.5523 7 12ZM7 8C7 7.44772 7.44772 7 8 7H16V9H8C7.44772 9 7 8.55228 7 8ZM3 4C3 3.44772 3.44772 3 4 3H16V5H4C3.44772 5 3 4.55228 3 4ZM2.2714 7H4L2.06263 10.0038L4 13H2.2714L0 10.0713V9.92866L2.2714 7Z"
		}),
		/* @__PURE__ */ jsx("mask", {
			id: "mask0_856_23617",
			maskUnits: "userSpaceOnUse",
			x: "7",
			y: "7",
			width: "9",
			height: "2",
			children: /* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7 8C7 7.44772 7.44772 7 8 7H16V9H8C7.44772 9 7 8.55228 7 8Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ jsx("g", { mask: "url(#mask0_856_23617)" })
	] }),
	Paint: /* @__PURE__ */ jsx("path", { d: "M14,14 L14,17.5 C14,18.3284271 13.3284271,19 12.5,19 C11.6715729,19 11,18.3284271 11,17.5 C11,16.9698066 11.9216,15.8733989 13.7648,14.2107768 L14,14 Z M6.2173022,3.14410063 L13.704633,10.4497842 C14.0984557,10.8340526 14.0984557,11.4570747 13.704633,11.841343 L8.71307912,16.7117987 C8.3192564,17.0960671 7.6807436,17.0960671 7.28692088,16.7117987 L2.29536704,11.841343 C1.90154432,11.4570747 1.90154432,10.8340526 2.29536704,10.4497842 L7.28692088,5.5793285 L5.50422308,3.83988002 C5.30731172,3.64774585 5.30731172,3.3362348 5.50422308,3.14410063 C5.70113444,2.95196646 6.02039084,2.95196646 6.2173022,3.14410063 Z M7.2754315,6.93101538 L7.1890873,7.00811295 L4.67903679,9.52378207 C4.49338525,9.70984918 4.3890873,9.96221034 4.3890873,10.225349 C4.3890873,10.7311562 4.76673836,11.1485609 5.25485963,11.209784 L5.37903679,11.2175144 L10.3991378,11.2175144 C10.6616887,11.2175144 10.9134863,11.112983 11.0991378,10.9269159 C11.4857371,10.5394512 11.4857371,9.91124677 11.0991378,9.52378207 L8.5890873,7.00811295 C8.23010221,6.6483243 7.66400415,6.62262511 7.2754315,6.93101538 Z" }),
	PaintRoller: /* @__PURE__ */ jsx("path", { d: "M13.0612 5.42194H12.5376V4.0257C12.5376 3.83368 12.3806 3.67661 12.1885 3.67661H1.01901C0.826995 3.67661 0.669922 3.83368 0.669922 4.0257V7.5163C0.669922 7.70832 0.826995 7.8654 1.01901 7.8654H12.1888C12.3809 7.8654 12.5379 7.70832 12.5379 7.5163V6.12006H13.0615C13.9272 6.12006 14.6322 6.82512 14.6322 7.69079C14.6322 8.55646 13.9272 9.26152 13.0615 9.26152H6.60387C6.41185 9.26152 6.25478 9.41859 6.25478 9.61061V13.1012H5.90568C5.71367 13.1012 5.55659 13.2583 5.55659 13.4503V17.6389C5.55659 17.8309 5.71367 17.988 5.90568 17.988H7.30193C7.49395 17.988 7.65102 17.8309 7.65102 17.6389V13.4503C7.65102 13.2583 7.49395 13.1012 7.30193 13.1012H6.95284V9.95976H13.0613C14.3109 9.95976 15.3301 8.94055 15.3301 7.69097C15.3302 6.44127 14.3108 5.42194 13.0612 5.42194ZM2.06611 7.16715H1.36792V4.37479H2.06599L2.06611 7.16715ZM11.8393 7.16715H11.1413V4.37479H11.8393V7.16715Z" }),
	Paragraph: /* @__PURE__ */ jsx("path", { d: "M3.75,17 L5.44,17 L5.44,12.8 L7.494,12.8 C9.67,12.8 11.398,11.68 11.398,9.36 C11.398,7.28 9.846,6 7.558,6 L3.75,6 L3.75,17 Z M5.44,7.68 L7.584,7.68 C8.688,7.68 9.552,8.192 9.552,9.408 C9.552,10.592 8.768,11.12 7.52,11.12 L5.44,11.12 L5.44,7.68 Z" }),
	PdfFile: /* @__PURE__ */ jsx("path", {
		d: "M0.466073 0.669975V0.672653C0.202715 0.723545 -0.00468088 0.983666 8.03613e-05 1.25597V18.7519C8.03613e-05 19.056 0.274892 19.3334 0.575429 19.3334H15.424C15.7253 19.3334 16 19.056 16 18.7506V5.22682C15.9946 5.13768 15.9693 5.04959 15.9266 4.97161L11.5113 0.705712C11.454 0.683837 11.3927 0.671784 11.3312 0.669254H0.574995C0.539286 0.665831 0.501345 0.665831 0.465635 0.669254L0.466073 0.669975ZM7.13982 3.33664H7.39752C7.64481 3.33664 7.88168 3.42503 8.05369 3.59705C8.76327 4.30673 8.43192 6.03694 8.0772 7.46714C8.05578 7.53158 8.04372 7.58589 8.03301 7.61804C8.46301 8.83293 9.0769 9.81163 9.75407 10.3707C10.0336 10.5857 10.3448 10.7996 10.6894 10.9932C11.172 10.9395 11.636 10.9176 12.0771 10.9176C13.4103 10.9176 14.2155 11.1545 14.5262 11.6598C14.6342 11.8319 14.6862 12.036 14.6542 12.2509C14.6435 12.5197 14.5488 12.7689 14.3555 12.9622C14.1716 13.1663 13.8516 13.2822 13.3783 13.2822C12.5612 13.2822 11.2254 13.0341 10.1499 12.4853C8.30073 12.6902 6.92442 12.941 5.81715 13.2956C5.76343 13.3169 5.69976 13.3356 5.62447 13.3676C4.29132 15.6477 3.30292 16.6703 2.43207 16.6703C2.25992 16.6703 2.08733 16.6262 1.95831 16.5503L1.44261 16.2197L1.40868 16.1651C1.3334 15.9718 1.31108 15.789 1.35408 15.585C1.47237 15.0157 2.08701 14.1103 3.3773 13.3036C3.58159 13.153 3.90283 12.981 4.33298 12.777C4.6554 12.2182 5.00104 11.5624 5.36678 10.8421C5.91508 9.73472 6.25668 8.6399 6.5254 7.69376V7.68067C6.12755 6.37979 5.89334 5.59511 6.29121 4.16505C6.38792 3.75656 6.74219 3.33694 7.14004 3.33694L7.13982 3.33664ZM7.30125 4.0033C7.27968 4.0356 7.24724 4.09051 7.22567 4.13351C7.04295 4.58502 7.05397 5.36894 7.30125 6.33664L7.35586 6.29497C7.431 5.95077 7.46314 5.64853 7.52771 5.41207L7.55895 5.2402C7.66638 4.6274 7.64555 4.31593 7.46269 4.05791L7.30125 4.0033ZM7.38978 8.86539C7.14235 9.66109 6.78526 10.5082 6.3014 11.4435C6.0864 11.852 5.84832 12.2382 5.76235 12.5608L5.88212 12.5191C7.24757 11.9923 8.54008 11.6912 9.47538 11.5191C9.31424 11.4117 9.16173 11.2937 9.03273 11.1754C8.38757 10.6271 7.83065 9.83312 7.3898 8.86554L7.38978 8.86539ZM11.8707 11.8212C11.796 11.8212 11.7201 11.8205 11.624 11.928C12.4078 12.2721 13.1705 12.4775 13.6651 12.4775C13.7398 12.4775 13.8064 12.4673 13.8704 12.4565H13.9158C13.9691 12.435 14.001 12.4209 14.0118 12.3133C13.9905 12.281 13.9691 12.2392 13.9158 12.1961C13.8078 12.0886 13.3758 11.8211 11.8707 11.8211L11.8707 11.8212ZM4.05462 13.7662C3.82891 13.8955 3.64649 14.0142 3.53908 14.0995C2.77579 14.7981 2.29357 15.5062 2.23987 15.9156C2.72372 15.7542 3.35579 15.0462 4.05466 13.7662H4.05462Z",
		fill: "#B30B00"
	}),
	Person: /* @__PURE__ */ jsx("path", { d: "M8,13 C11.8659932,13 15,15.6862915 15,19 L15,19 L1,19 C1,15.6862915 4.13400675,13 8,13 Z M8,4 C10.209139,4 12,5.790861 12,8 C12,10.209139 10.209139,12 8,12 C5.790861,12 4,10.209139 4,8 C4,5.790861 5.790861,4 8,4 Z" }),
	Plus: /* @__PURE__ */ jsx("path", { d: "M9,10.5 L13,10.5 C13.5522847,10.5 14,10.9477153 14,11.5 C14,12.0522847 13.5522847,12.5 13,12.5 L9,12.5 L9,12.5 L9,16 C9,16.5522847 8.55228475,17 8,17 C7.44771525,17 7,16.5522847 7,16 L7,12.5 L7,12.5 L3,12.5 C2.44771525,12.5 2,12.0522847 2,11.5 C2,10.9477153 2.44771525,10.5 3,10.5 L7,10.5 L7,10.5 L7,7 C7,6.44771525 7.44771525,6 8,6 C8.55228475,6 9,6.44771525 9,7 L9,10.5 L9,10.5 Z" }),
	PresentationFile: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M0.466073 0.669948V0.672626C0.202715 0.723518 -0.00468088 0.983639 8.03613e-05 1.25594V18.7519C8.03613e-05 19.0559 0.274892 19.3333 0.575429 19.3333H15.424C15.7253 19.3333 16 19.056 16 18.7506V5.22679C15.9946 5.13766 15.9693 5.04956 15.9266 4.97159L11.5113 0.705685C11.454 0.68381 11.3927 0.671757 11.3312 0.669227H0.574995C0.539286 0.665804 0.501782 0.666525 0.466073 0.669948Z",
			fill: "#CB4A32"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M8.21936 5.99756V10.8182H13.0403C12.8572 8.2431 10.7938 6.18019 8.21936 5.99756Z",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M7.04984 7.08911C4.75989 7.27817 2.95972 9.19596 2.95972 11.5351C2.95972 13.9999 4.95741 15.9976 7.4222 15.9976C9.76185 15.9976 11.6796 14.1979 11.8687 11.9075L7.04984 11.9077V7.08911Z",
			fill: "white",
			fillOpacity: "0.75"
		})
	] }),
	Print: /* @__PURE__ */ jsx("path", { d: "M13,15 L13,12 C13,11.4477153 12.5522847,11 12,11 L4,11 C3.44771525,11 3,11.4477153 3,12 L3,15 L1,15 C0.44771525,15 0,14.5522847 0,14 L0,8 C0,7.44771525 0.44771525,7 1,7 L15,7 C15.5522847,7 16,7.44771525 16,8 L16,14 C16,14.5522847 15.5522847,15 15,15 L13,15 Z M2,10 C2.55228475,10 3,9.55228475 3,9 C3,8.44771525 2.55228475,8 2,8 C1.44771525,8 1,8.44771525 1,9 C1,9.55228475 1.44771525,10 2,10 Z M5,13 L11,13 C11.5522847,13 12,13.4477153 12,14 L12,19 L4,19 L4,14 C4,13.4477153 4.44771525,13 5,13 Z M4,3 L12,3 C12.5522847,3 13,3.44771525 13,4 L13,5 L3,5 L3,4 C3,3.44771525 3.44771525,3 4,3 Z" }),
	Question: /* @__PURE__ */ jsx("path", { d: "M7.36046512,13.3993085 C7.36046512,12.672021 7.4499991,12.2892458 7.62906977,11.8572479 C7.80814043,11.4252501 8.16220666,10.9508798 8.69127907,10.4341229 C9.22035148,9.917366 9.55542565,9.54962652 9.69651163,9.33089343 C9.91356698,8.99732548 10.022093,8.6364213 10.022093,8.24817007 C10.022093,7.73414732 9.89593149,7.34180074 9.64360465,7.07111854 C9.39127781,6.80043635 9.02093267,6.66509729 8.53255814,6.66509729 C8.06588914,6.66509729 7.6901177,6.79770223 7.40523256,7.0629161 C7.12034741,7.32812996 6.97790698,7.68766708 6.97790698,8.14153823 L5,8.14153823 C5.01085277,7.17364433 5.33778748,6.40809001 5.98081395,5.84485232 C6.62384042,5.28161462 7.47441331,5 8.53255814,5 C9.62326127,5 10.4738342,5.2788805 11.0843023,5.83664987 C11.6947705,6.39441923 12,7.17364416 12,8.17434803 C12,9.06568535 11.587601,9.94333869 10.7627907,10.8073344 L9.76162791,11.7998308 C9.40348658,12.2099553 9.2189923,12.6118694 9.20813953,13.3993085 L7.36046512,13.3993085 Z M7.33477472,15.8188327 C7.33477472,15.4571748 7.43942014,15.1644815 7.64871412,14.940744 C7.85800809,14.7170065 8.14083355,14.6051395 8.49719896,14.6051395 C8.85922098,14.6051395 9.14487469,14.7200714 9.35416866,14.9499387 C9.56346264,15.179806 9.66810806,15.4694344 9.66810806,15.8188327 C9.66810806,16.1559713 9.56629089,16.4379376 9.36265351,16.66474 C9.15901613,16.8915424 8.87053416,17.0049419 8.49719896,17.0049419 C8.12386376,17.0049419 7.83679593,16.8915424 7.63598684,16.66474 C7.43517776,16.4379376 7.33477472,16.1559713 7.33477472,15.8188327 Z" }),
	QuoteClose: /* @__PURE__ */ jsx("path", { d: "M10.9775167,16 L9.6458244,16 C10.4762451,15.2670555 11,14.1946925 11,13 C9.34314575,13 8,11.6568542 8,10 C8,8.34314575 9.34314575,7 11,7 C12.6568542,7 14,8.34314575 14,10 C14,10.2479868 13.9699107,10.4889459 13.9131839,10.7194256 C13.610115,12.8290103 12.5323818,14.6883791 10.9775167,16 Z M4.97751673,16 L3.6458244,16 C4.47624511,15.2670555 5,14.1946925 5,13 C3.34314575,13 2,11.6568542 2,10 C2,8.34314575 3.34314575,7 5,7 C6.65685425,7 8,8.34314575 8,10 C8,10.2479868 7.96991072,10.4889459 7.91318386,10.7194256 C7.61011496,12.8290103 6.53238182,14.6883791 4.97751673,16 Z" }),
	QuoteOpen: /* @__PURE__ */ jsx("path", { d: "M6.3541756,7 C5.52375489,7.73294445 5,8.80530747 5,10 C6.65685425,10 8,11.3431458 8,13 C8,14.6568542 6.65685425,16 5,16 C3.34314575,16 2,14.6568542 2,13 C2,12.7520132 2.03008928,12.5110541 2.08681614,12.2805744 C2.38988504,10.1709897 3.46761818,8.31162086 5.02248327,7 L6.3541756,7 Z M12.3541756,7 C11.5237549,7.73294445 11,8.80530747 11,10 C12.6568542,10 14,11.3431458 14,13 C14,14.6568542 12.6568542,16 11,16 C9.34314575,16 8,14.6568542 8,13 C8,12.7520132 8.03008928,12.5110541 8.08681614,12.2805744 C8.38988504,10.1709897 9.46761818,8.31162086 11.0224833,7 L12.3541756,7 Z" }),
	Redo: /* @__PURE__ */ jsx("path", { d: "M9.88227228,7.6 L8,7.6 C5.5699471,7.6 3.6,9.5699471 3.6,12 C3.6,14.4300529 5.5699471,16.4 8,16.4 C10.4300529,16.4 12.4,14.4300529 12.4,12 L14,12 C14,15.3137085 11.3137085,18 8,18 C4.6862915,18 2,15.3137085 2,12 C2,8.6862915 4.6862915,6 8,6 L9.56463883,6 L8,4 L9.382881,4 L11.1701272,6 L11.1740137,6 L11.1740135,6.00434894 L12,6.92866083 L12,7.07133917 L9.382881,10 L8,10 L9.88227228,7.6 Z" }),
	Reset: /* @__PURE__ */ jsx("path", { d: "M8.88227228,6.6 L7,6.6 C4.5699471,6.6 2.6,8.5699471 2.6,11 C2.6,11.845472 2.83846331,12.6352479 3.25180096,13.3057388 L1.88943639,14.1451897 C1.32541452,13.2306692 1,12.1533369 1,11 C1,7.6862915 3.6862915,5 7,5 L8.56463883,5 L7,3 L8.382881,3 L11,5.92866083 L11,6.07133917 L8.382881,9 L7,9 L8.88227228,6.6 Z M7.11772772,15.5379533 L9,15.5379533 C11.4300529,15.5379533 13.4,13.5680062 13.4,11.1379533 C13.4,10.2915932 13.1610355,9.50104634 12.746896,8.83010216 L14.1150195,8 C14.676299,8.91296508 15,9.98765696 15,11.1379533 C15,14.4516618 12.3137085,17.1379533 9,17.1379533 L7.43536117,17.1379533 L9,19 L7.617119,19 L5,16.2092924 L5,16.0666141 L7.617119,13.1379533 L9,13.1379533 L7.11772772,15.5379533 Z" }),
	Right: /* @__PURE__ */ jsx("polygon", { points: "11.347 11 9 7 10.729 7 14 11.881 14 12.119 10.729 17 9 17 11.353 13 2 13 2 11" }),
	RightAlign: /* @__PURE__ */ jsx("path", { d: "M1,16 L16,16 L16,16 L16,18 L1,18 C0.44771525,18 6.76353751e-17,17.5522847 0,17 C-6.76353751e-17,16.4477153 0.44771525,16 1,16 Z M5,12 L16,12 L16,12 L16,14 L5,14 C4.44771525,14 4,13.5522847 4,13 C4,12.4477153 4.44771525,12 5,12 Z M1,8 L16,8 L16,8 L16,10 L1,10 C0.44771525,10 6.76353751e-17,9.55228475 0,9 C-6.76353751e-17,8.44771525 0.44771525,8 1,8 Z M5,4 L16,4 L16,4 L16,6 L5,6 C4.44771525,6 4,5.55228475 4,5 C4,4.44771525 4.44771525,4 5,4 Z" }),
	RightArrowhead: /* @__PURE__ */ jsx("polygon", { points: "7.729 8 10 10.929 10 11.071 7.729 14 6 14 7.937 11.004 6 8" }),
	RightCaret: /* @__PURE__ */ jsx("polygon", { points: "6 14 6 8 10.8 11" }),
	Sad: /* @__PURE__ */ jsx("path", { d: "M8,14 C6.81533358,14 5.75095206,14.3862506 5.01852466,15 L4,15 C4,13.3431458 5.790861,12 8,12 C10.209139,12 12,13.3431458 12,15 L10.9814753,15 C10.2490479,14.3862506 9.18466642,14 8,14 Z M8,19 C3.581722,19 0,15.418278 0,11 C0,6.581722 3.581722,3 8,3 C12.418278,3 16,6.581722 16,11 C16,15.418278 12.418278,19 8,19 Z M8,17.5 C11.5898509,17.5 14.5,14.5898509 14.5,11 C14.5,7.41014913 11.5898509,4.5 8,4.5 C4.41014913,4.5 1.5,7.41014913 1.5,11 C1.5,14.5898509 4.41014913,17.5 8,17.5 Z M5.5,10 C4.67157288,10 4,9.32842712 4,8.5 C4,7.67157288 4.67157288,7 5.5,7 C6.32842712,7 7,7.67157288 7,8.5 C7,9.32842712 6.32842712,10 5.5,10 Z M10.5,10 C9.67157288,10 9,9.32842712 9,8.5 C9,7.67157288 9.67157288,7 10.5,7 C11.3284271,7 12,7.67157288 12,8.5 C12,9.32842712 11.3284271,10 10.5,10 Z" }),
	Search: /* @__PURE__ */ jsx("path", { d: "M10.9362 11.0538C12.2715 9.03834 12.0513 6.29611 10.2755 4.52036C8.24839 2.49321 4.96173 2.49321 2.93458 4.52036C0.907426 6.54751 0.907426 9.83418 2.93458 11.8613C4.71032 13.6371 7.45255 13.8573 9.46802 12.522L13.2389 16.2929C13.6294 16.6834 14.2626 16.6834 14.6531 16.2929L14.7071 16.2389C15.0976 15.8484 15.0976 15.2152 14.7071 14.8247L10.9362 11.0538ZM9.1744 10.7602C7.75539 12.1792 5.45473 12.1792 4.03572 10.7602C2.61672 9.34118 2.61672 7.04051 4.03572 5.62151C5.45473 4.2025 7.75539 4.2025 9.1744 5.62151C10.5934 7.04051 10.5934 9.34118 9.1744 10.7602Z" }),
	Section: /* @__PURE__ */ jsx("path", { d: "M4,8 L12,8 C12.5522847,8 13,8.44771525 13,9 C13,9.55228475 12.5522847,10 12,10 L4,10 C3.44771525,10 3,9.55228475 3,9 C3,8.44771525 3.44771525,8 4,8 Z M1,4 L9,4 C9.55228475,4 10,4.44771525 10,5 C10,5.55228475 9.55228475,6 9,6 L1,6 C0.44771525,6 6.76353751e-17,5.55228475 0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 Z M7,16 L15,16 C15.5522847,16 16,16.4477153 16,17 C16,17.5522847 15.5522847,18 15,18 L7,18 C6.44771525,18 6,17.5522847 6,17 C6,16.4477153 6.44771525,16 7,16 Z M4,12 L12,12 C12.5522847,12 13,12.4477153 13,13 C13,13.5522847 12.5522847,14 12,14 L4,14 C3.44771525,14 3,13.5522847 3,13 C3,12.4477153 3.44771525,12 4,12 Z" }),
	Select: /* @__PURE__ */ jsx("path", { d: "M8.5,4 L8.5,5 L5.5,6 L5.5,16 L8.5,17 L8.5,18 L5.5,17.5 L4,17.5 L1,18 L1,17 L4,16 L4,6 L1,5 L1,4 L4,4.5 L5.5,4.5 L8.5,4 Z M12.1529933,9.00012821 C13.8696723,9.01294307 14.9201774,9.37472544 14.9956377,10.8274895 L15,11 L15,14 L15.0030214,15.2390339 L15.0030214,15.2390339 L15,16 L13.4168514,16 C13.3636364,15.8536148 13.3237251,15.5076136 13.3104213,15.2547665 C13.0709534,15.6673065 12.578714,16 11.3281596,16 C9.69179601,16 9,15.0817659 9,14.0304543 C9,12.5439304 10.1472996,11.8225011 12.0261111,11.771101 L12.2461197,11.7681383 L13.2838137,11.7681383 L13.2838137,11.3023674 C13.2838137,10.7700578 13.1108647,10.2111326 12.0864745,10.2111326 C11.2949002,10.2111326 11.0533537,10.5269836 10.942948,10.9447219 L10.902439,11.1293668 L9.31929047,11.1293668 C9.41241685,10.0115165 10.1175166,8.98682047 12.1529933,9.00012821 Z M13.2971175,12.8061421 L12.405765,12.8061421 C11.195122,12.8061421 10.6629712,13.1654512 10.6629712,13.9373001 C10.6629712,14.4962253 11.0354767,14.9486885 11.767184,14.9486885 C13.0676275,14.9486885 13.2806495,14.0931578 13.2961436,13.1317043 L13.2971175,12.8061421 Z" }),
	Send: /* @__PURE__ */ jsx("polygon", { points: "2.911 11.667 15 11 2.911 10.333 2.911 10.312 1 5 15 11 1 17 2.911 11.676 2.911 11.667" }),
	Settings: /* @__PURE__ */ jsx("path", { d: "M6.59870802,17 C5.93415696,16.8454066 5.31089104,16.5832545 4.74825386,16.2328873 L4.85488937,14.1451106 L2.76711267,14.2517461 C2.41674547,13.689109 2.15459339,13.065843 2,12.401292 L3.55214189,11 L2,9.59870802 C2.15459339,8.93415696 2.41674547,8.31089104 2.76711267,7.74825386 L4.85488937,7.85488937 L4.74825386,5.76711267 C5.31089104,5.41674547 5.93415696,5.15459339 6.59870802,5 L8,6.55214189 L9.40129198,5 C10.065843,5.15459339 10.689109,5.41674547 11.2517461,5.76711267 L11.1451106,7.85488937 L13.2328873,7.74825386 C13.5832545,8.31089104 13.8454066,8.93415696 14,9.59870802 L12.4478581,11 L14,12.401292 C13.8454066,13.065843 13.5832545,13.689109 13.2328873,14.2517461 L11.1451106,14.1451106 L11.2517461,16.2328873 C10.689109,16.5832545 10.065843,16.8454066 9.40129198,17 L8,15.4478581 L6.59870802,17 Z M8,13 C9.1045695,13 10,12.1045695 10,11 C10,9.8954305 9.1045695,9 8,9 C6.8954305,9 6,9.8954305 6,11 C6,12.1045695 6.8954305,13 8,13 Z" }),
	Show: /* @__PURE__ */ jsx("path", { d: "M8,6 C12,6 15,10.3 15,11 C15,11.7 12,16 8,16 C4,16 1,12 1,11 C1,10.3 4,6 8,6 Z M8,7.5 C5.14285714,7.5 3,10.51 3,11 C3,11.7 5.14285714,14.5 8,14.5 C10.8571429,14.5 13,11.49 13,11 C13,10.51 10.8571429,7.5 8,7.5 Z M8,8 C9.65685425,8 11,9.34314575 11,11 C11,12.6568542 9.65685425,14 8,14 C6.34314575,14 5,12.6568542 5,11 C5,9.34314575 6.34314575,8 8,8 Z M7,9 C6.44771525,9 6,9.44771525 6,10 C6,10.5522847 6.44771525,11 7,11 C7.55228475,11 8,10.5522847 8,10 C8,9.44771525 7.55228475,9 7,9 Z" }),
	Shrink: /* @__PURE__ */ jsx("path", { d: "M7,9 C8.1045695,9 9,9.8954305 9,11 L9,17 C9,18.1045695 8.1045695,19 7,19 L2,19 C0.8954305,19 0,18.1045695 0,17 L0,11 C0,9.8954305 0.8954305,9 2,9 L7,9 Z M7,10.5 L2,10.5 C1.75454011,10.5 1.55039163,10.6768752 1.50805567,10.9101244 L1.5,11 L1.5,17 C1.5,17.2454599 1.67687516,17.4496084 1.91012437,17.4919443 L2,17.5 L7,17.5 C7.24545989,17.5 7.44960837,17.3231248 7.49194433,17.0898756 L7.5,17 L7.5,11 C7.5,10.7545401 7.32312484,10.5503916 7.08987563,10.5080557 L7,10.5 Z M10.5,2 L12,3 L12,6 L15,6 L16,7.5 L10.5,7.5 L10.5,2 Z" }),
	Sidebar: /* @__PURE__ */ jsx("path", { d: "M13.3469582,10 L11,6 L12.7286013,6 L16,10.8811014 L16,11.1188986 L12.7286013,16 L11,16 L13.3528403,12 L5,12 L5,10 L13.3469582,10 Z M0,5 L2,5 L2,17 L0,17 L0,5 Z" }),
	Sort: /* @__PURE__ */ jsx("path", { d: "M11,9 L5,9 L8,4 L11,9 Z M11,12 L8,17 L5,12 L11,12 Z" }),
	SplitCells: /* @__PURE__ */ jsx("path", { d: "M8,4 C8.24545989,4 8.44960837,4.17687516 8.49194433,4.41012437 L8.5,4.5 L8.5,17.5 C8.5,17.7761424 8.27614237,18 8,18 C7.75454011,18 7.55039163,17.8231248 7.50805567,17.5898756 L7.5,17.5 L7.5,4.5 C7.5,4.22385763 7.72385763,4 8,4 Z M5.5,7 L2.59394572,11.0050063 L5.5,15 L3.86171347,15 C3.61412539,15 3.37690376,14.908235 3.19458844,14.7449535 L3.10821251,14.6574468 L0,11.0951189 L0,10.9048811 L3.10821251,7.34255319 C3.2709885,7.15599534 3.49609413,7.03757922 3.7389895,7.00755334 L3.86171347,7 L5.5,7 Z M12.1382865,7 C12.3858746,7 12.6230962,7.091765 12.8054116,7.25504649 L12.8917875,7.34255319 L16,10.9048811 L16,11.0951189 L12.8917875,14.6574468 C12.7290115,14.8440047 12.5039059,14.9624208 12.2610105,14.9924467 L12.1382865,15 L10.5,15 L13.4060543,11.0050063 L10.5,7 L12.1382865,7 Z" }),
	SpreadsheetFile: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M0.466073 0.669948V0.672626C0.202715 0.723518 -0.00468088 0.983639 8.03613e-05 1.25594V18.7519C8.03613e-05 19.0559 0.274892 19.3333 0.575429 19.3333H15.424C15.7253 19.3333 16 19.056 16 18.7506V5.22679C15.9946 5.13766 15.9693 5.04956 15.9266 4.97159L11.5113 0.705685C11.454 0.68381 11.3927 0.671757 11.3312 0.669227H0.574995C0.539286 0.665804 0.501782 0.666525 0.466073 0.669948Z",
			fill: "#037945"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.20696 8.19487V14.7949H12.8033V8.19487H3.20696ZM3.00696 6.99487C2.45467 6.99487 2.00696 7.44259 2.00696 7.99487V14.9949C2.00696 15.5472 2.45467 15.9949 3.00696 15.9949H13.0033C13.5556 15.9949 14.0033 15.5472 14.0033 14.9949V7.99487C14.0033 7.44259 13.5556 6.99487 13.0033 6.99487H3.00696Z",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "9.73419",
			width: "10.9983",
			height: "1",
			rx: "0.5",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "5.6532",
			y: "7",
			width: "8.99996",
			height: "1",
			rx: "0.5",
			transform: "rotate(90 5.6532 7)",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "12.2659",
			width: "10.9983",
			height: "1",
			rx: "0.5",
			fill: "white"
		})
	] }),
	Star: /* @__PURE__ */ jsx("polygon", { points: "8 15.609 3.674 18 4.5 12.935 1 9.348 5.837 8.609 8 4 10.163 8.609 15 9.348 11.5 12.935 12.326 18" }),
	StarOutline: /* @__PURE__ */ jsx("path", { d: "M8,15.6085145 L3.67376208,18 L4.5,12.9347524 L1,9.34752416 L5.83688104,8.60851449 L8,4 L10.163119,8.60851449 L15,9.34752416 L11.5,12.9347524 L12.3262379,18 L8,15.6085145 Z M8,14.5029417 L11.0901699,16.2111456 L10.5,12.5931116 L13,10.0308057 L9.54508497,9.50294169 L8,6.21114562 L6.45491503,9.50294169 L3,10.0308057 L5.5,12.5931116 L4.90983006,16.2111456 L8,14.5029417 Z" }),
	Strikethrough: /* @__PURE__ */ jsx("path", { d: "M9.88479534,13.25 L11.8963899,13.25 C11.9654635,13.5064538 12,13.7834139 12,14.0808824 C12,14.9730437 11.6580917,15.6825954 10.9742647,16.2095588 C10.2904378,16.7365222 9.36275096,17 8.19117647,17 C7.41666279,17 6.70466011,16.8566191 6.05514706,16.5698529 C5.40563401,16.2830868 4.9007371,15.8872574 4.54044118,15.3823529 C4.18014526,14.8774485 4,14.289219 4,13.6176471 L5.86029412,13.6176471 C5.86029412,14.2254932 6.0612725,14.6960768 6.46323529,15.0294118 C6.86519809,15.3627468 7.44117272,15.5294118 8.19117647,15.5294118 C8.83823853,15.5294118 9.32475327,15.3982856 9.65073529,15.1360294 C9.97671732,14.8737732 10.1397059,14.5269629 10.1397059,14.0955882 C10.1397059,13.7583356 10.0547363,13.4764742 9.88479534,13.25 Z M16,12.25 L0,12.25 L0,11 L5.29298221,11 C4.65157971,10.446008 4.33088235,9.76954166 4.33088235,8.97058824 C4.33088235,8.10783882 4.68259452,7.39706162 5.38602941,6.83823529 C6.0894643,6.27940897 7.00244537,6 8.125,6 C8.87010176,6 9.53431081,6.13725353 10.1176471,6.41176471 C10.7009833,6.68627588 11.1593121,7.07720335 11.4926471,7.58455882 C11.8259821,8.0919143 11.9926471,8.65440868 11.9926471,9.27205882 L10.1397059,9.27205882 C10.1397059,8.7132325 9.96446254,8.27573687 9.61397059,7.95955882 C9.26347864,7.64338077 8.76225816,7.48529412 8.11029412,7.48529412 C7.50244794,7.48529412 7.03063893,7.61519478 6.69485294,7.875 C6.35906695,8.13480522 6.19117647,8.49754669 6.19117647,8.96323529 C6.19117647,9.35539412 6.37254721,9.68259673 6.73529412,9.94485294 C7.09804103,10.2071092 7.69607426,10.4620086 8.52941176,10.7095588 C8.83934305,10.8016266 9.12655831,10.8984402 9.39105858,11 L16,11 L16,12.25 Z" }),
	Student: /* @__PURE__ */ jsx("path", { d: "M12,11 L12,13 L12,13 C12,15 11,17 8,17 C5,17 4,15 4,13 L4,11 L4,11 L8,12.5 L12,11 Z M8,5 L16,8.125 L15,8.515 L15,15 L14,14 L14,8.905 L8,11.25 L0,8.125 L8,5 Z" }),
	Style: /* @__PURE__ */ jsx("path", { d: "M13.1529933,10.0001282 C14.9356984,10.013436 16,10.4030711 16,12 L16,12 L16,15 C16.0047959,15.411165 16.0047959,16.0778316 16,17 L16,17 L14.4168514,17 C14.3636364,16.8536148 14.3237251,16.5076136 14.3104213,16.2547665 C14.0709534,16.6673065 13.578714,17 12.3281596,17 C10.691796,17 10,16.0817659 10,15.0304543 C10,13.4867564 11.2372506,12.7681383 13.2461197,12.7681383 L13.2461197,12.7681383 L14.2838137,12.7681383 L14.2838137,12.3023674 C14.2838137,11.7700578 14.1108647,11.2111326 13.0864745,11.2111326 C12.1818182,11.2111326 11.9955654,11.6236726 11.902439,12.1293668 L11.902439,12.1293668 L10.3192905,12.1293668 C10.4124169,11.0115165 11.1175166,9.98682047 13.1529933,10.0001282 Z M5.55230769,6 L9,17 L7.10307692,17 L6.23076923,14 L2.61692308,14 L1.77230769,17 L0,17 L3.30923077,6 L5.55230769,6 Z M14.2971175,13.8061421 L13.405765,13.8061421 C12.195122,13.8061421 11.6629712,14.1654512 11.6629712,14.9373001 C11.6629712,15.4962253 12.0354767,15.9486885 12.767184,15.9486885 C14.1241685,15.9486885 14.2971175,15.0171466 14.2971175,14.0057583 L14.2971175,14.0057583 L14.2971175,13.8061421 Z M4.36153846,7.5 L3.01846154,12.5 L5.81538462,12.5 L4.36153846,7.5 Z" }),
	Subscript: /* @__PURE__ */ jsx("path", { d: "M11.4447884,13 L12.4871001,14.974122 L13.5500516,13 L14.9432405,13 L13.2352941,15.9556377 L15,19 L13.6171311,19 L12.50258,16.948244 L11.3931889,19 L10,19 L11.7647059,15.9556377 L10.0619195,13 L11.4447884,13 Z M4.0285205,7 C5.13963717,7 6.01009786,7.277775 6.6399287,7.83333333 C7.26975954,8.38889167 7.59655365,9.15388699 7.62032086,10.1283422 L7.62032086,14.5668449 C7.62032086,15.4521732 7.73321337,16.156266 7.95900178,16.6791444 L7.95900178,16.8217469 L6.22994652,16.8217469 C6.13487772,16.6316093 6.05763547,16.2929317 5.99821747,15.8057041 C5.23172522,16.6019053 4.31670169,17 3.25311943,17 C2.30243137,17 1.52258177,16.7311376 0.913547237,16.1934046 C0.304512701,15.6556717 2.84217094e-14,14.9738603 2.84217094e-14,14.1479501 C2.84217094e-14,13.1437858 0.381754947,12.3639362 1.14527629,11.8083779 C1.90879764,11.2528196 2.98276194,10.9750446 4.36720143,10.9750446 L5.9714795,10.9750446 L5.9714795,10.2174688 C5.9714795,9.64111417 5.79916988,9.18211698 5.45454545,8.84046346 C5.10992103,8.49880994 4.60190472,8.32798574 3.93048128,8.32798574 C3.34224305,8.32798574 2.84908102,8.47652852 2.45098039,8.77361854 C2.05287977,9.07070856 1.85383244,9.43018209 1.85383244,9.85204991 L0.196078431,9.85204991 C0.196078431,9.37076408 0.366902629,8.90582518 0.70855615,8.45721925 C1.05020967,8.00861332 1.51366315,7.65359608 2.09893048,7.39215686 C2.68419782,7.13071765 3.32738806,7 4.0285205,7 Z M5.9714795,12.1426025 L4.67914439,12.1426025 C2.65893226,12.1426025 1.64884135,12.7338028 1.64884135,13.916221 C1.64884135,14.4331577 1.82115098,14.837194 2.1657754,15.1283422 C2.51039982,15.4194905 2.95305731,15.5650624 3.49376114,15.5650624 C4.01069777,15.5650624 4.50088895,15.4313739 4.96434938,15.1639929 C5.4278098,14.8966119 5.76351649,14.5490217 5.9714795,14.1212121 L5.9714795,12.1426025 Z" }),
	SunDarkLight: /* @__PURE__ */ jsx("path", {
		xmlns: "http://www.w3.org/2000/svg",
		d: "M7.808 2.036a.736.736 0 0 0-.519.53c-.046.179-.046.689 0 .868.068.262.3.493.532.53.16.026.064.062-.168.063-.11 0-.32.018-.466.039A5.977 5.977 0 0 0 4.06 5.488l-.167.145.044-.103a.86.86 0 0 0-.014-.583c-.082-.185-.764-.867-.951-.951a.75.75 0 0 0-.98.375.806.806 0 0 0 .004.601c.084.187.766.869.951.951a.86.86 0 0 0 .583.014l.103-.044-.145.167a5.977 5.977 0 0 0-1.422 3.127 4.055 4.055 0 0 0-.039.466c-.001.232-.037.328-.063.168-.039-.244-.292-.485-.572-.543-.236-.049-.79-.021-.941.047a.74.74 0 0 0-.223 1.194c.167.167.296.21.68.222.396.014.587-.019.755-.131.144-.095.278-.288.301-.431.026-.16.062-.064.063.168.002.552.193 1.374.468 2.013.31.723.696 1.288 1.277 1.868a5.825 5.825 0 0 0 2.439 1.49c.451.142 1.095.255 1.452.255.118 0 .204.012.204.027s-.019.027-.041.027c-.083 0-.303.134-.395.242-.147.172-.178.297-.178.731 0 .471.033.583.228.778a.715.715 0 0 0 1.041-.003c.188-.188.225-.314.225-.775 0-.414-.037-.567-.176-.729-.094-.109-.313-.244-.397-.244-.022 0-.041-.012-.041-.027s.086-.027.204-.027c.226 0 .65-.057.999-.134a6 6 0 0 0 2.615-1.338l.178-.156-.054.141a.865.865 0 0 0 .018.594c.079.166.771.851.934.924a.75.75 0 0 0 .981-.375.804.804 0 0 0-.004-.602c-.073-.163-.758-.855-.924-.934a.865.865 0 0 0-.594-.018l-.141.054.156-.178a6 6 0 0 0 1.338-2.615c.076-.344.134-.772.135-.993 0-.228.036-.323.062-.164.039.244.292.485.572.543.236.049.79.021.941-.047a.74.74 0 0 0 .223-1.194c-.167-.167-.296-.21-.68-.222-.396-.014-.587.019-.755.131-.144.095-.278.288-.301.431-.026.159-.062.064-.062-.164a5.751 5.751 0 0 0-.135-.993 6 6 0 0 0-1.338-2.615l-.156-.178.141.054a.865.865 0 0 0 .594-.018c.166-.079.851-.771.924-.934a.75.75 0 0 0-.375-.981.804.804 0 0 0-.602.004c-.163.073-.855.758-.934.924a.865.865 0 0 0-.018.594l.054.141-.178-.156a5.997 5.997 0 0 0-2.628-1.341 5.272 5.272 0 0 0-.976-.131c-.232-.001-.328-.037-.168-.063.244-.039.485-.292.543-.572.049-.236.021-.79-.047-.941a.75.75 0 0 0-.867-.415m.771 3.498a4.462 4.462 0 0 1 2.604 1.283 4.468 4.468 0 0 1 1.283 2.604 4.505 4.505 0 0 1-3.887 5.045 4.48 4.48 0 0 1-3.762-1.283 4.48 4.48 0 0 1-1.283-3.762 4.462 4.462 0 0 1 1.283-2.604 4.48 4.48 0 0 1 3.762-1.283M7.56 6.537a3.51 3.51 0 0 0-2.936 2.581 3.511 3.511 0 0 0 .412 2.721 3.504 3.504 0 0 0 2.071 1.533c.234.061.634.121.806.121H8V6.507l-.127.003c-.069.002-.21.014-.313.027m-4.507 7.515c-.165.04-.276.124-.632.479-.422.42-.484.524-.484.802 0 .418.312.73.73.73.278 0 .382-.062.802-.484.39-.391.467-.506.494-.733a.681.681 0 0 0-.214-.594.707.707 0 0 0-.696-.2",
		fillRule: "evenodd"
	}),
	SunLightDark: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", {
		xmlns: "http://www.w3.org/2000/svg",
		d: "M7.813 2.023c-.249.082-.445.263-.518.478-.06.176-.058.828.003 1.007.062.181.281.4.446.444.068.018.123.042.123.054 0 .011-.093.021-.207.021-.386.001-1.001.112-1.493.27-1.282.41-2.394 1.256-3.175 2.415-.555.821-.963 2.069-.965 2.948 0 .114-.01.207-.021.207-.012 0-.035-.051-.052-.114-.04-.149-.194-.325-.364-.414-.133-.07-.149-.072-.59-.072-.441 0-.457.002-.59.072a.73.73 0 0 0-.188 1.18c.195.195.307.228.778.228.472 0 .583-.033.779-.229a.591.591 0 0 0 .173-.262c.018-.068.042-.123.054-.123.011 0 .021.093.021.207 0 .114.018.327.039.473a5.932 5.932 0 0 0 1.456 3.161l.179.202-.148-.075a.744.744 0 0 0-.582-.03c-.108.037-.2.112-.525.432-.457.45-.536.574-.536.841a.74.74 0 0 0 .743.745c.277 0 .382-.066.833-.524.33-.335.406-.428.443-.536a.744.744 0 0 0-.03-.582l-.075-.148.202.179a5.98 5.98 0 0 0 2.185 1.24c.451.142 1.095.255 1.452.255.118 0 .204.012.204.027s-.019.027-.041.027c-.083 0-.303.134-.395.242-.147.172-.178.297-.178.731 0 .471.033.583.228.778a.714.714 0 0 0 1.038 0c.195-.195.228-.307.228-.778 0-.434-.031-.559-.178-.731-.092-.108-.312-.242-.395-.242-.022 0-.041-.012-.041-.027s.086-.027.204-.027c.357 0 1.001-.113 1.452-.255a6.07 6.07 0 0 0 2.171-1.223c.103-.089.173-.144.156-.122-.062.081-.121.346-.102.461.04.243.108.342.514.746.444.443.551.509.819.509.532-.001.898-.554.683-1.035-.079-.178-.759-.867-.948-.961a.825.825 0 0 0-.625-.013l-.116.053.158-.18a5.995 5.995 0 0 0 1.34-2.617c.077-.349.134-.773.134-.999 0-.112.01-.204.021-.204.012 0 .036.055.054.123a.591.591 0 0 0 .173.262c.196.196.307.229.779.229.471 0 .583-.033.778-.228a.71.71 0 0 0 .183-.749.774.774 0 0 0-.371-.431c-.133-.07-.149-.072-.59-.072-.441 0-.457.002-.59.072-.159.084-.315.254-.359.392-.055.171-.078.153-.078-.062 0-.363-.112-1.004-.255-1.458a5.825 5.825 0 0 0-1.49-2.439 5.825 5.825 0 0 0-2.439-1.49c-.462-.145-1.078-.254-1.449-.255-.114 0-.207-.01-.207-.021 0-.012.055-.036.123-.054.165-.044.384-.263.446-.444.061-.179.063-.831.003-1.007a.757.757 0 0 0-.664-.491.852.852 0 0 0-.228.013M2.48 3.943c-.37.122-.589.437-.552.796.025.238.097.344.52.761.365.36.406.392.551.434a.745.745 0 0 0 .935-.935c-.042-.144-.075-.186-.423-.54-.426-.434-.549-.514-.804-.529a.847.847 0 0 0-.227.013m10.667 0c-.179.059-.31.162-.656.514-.406.414-.464.51-.464.77a.76.76 0 0 0 .746.746c.261 0 .355-.057.78-.475.422-.415.494-.521.519-.759a.737.737 0 0 0-.698-.809.844.844 0 0 0-.227.013M8.579 5.534a4.462 4.462 0 0 1 2.604 1.283 4.468 4.468 0 0 1 1.283 2.604 4.505 4.505 0 0 1-3.887 5.045 4.48 4.48 0 0 1-3.762-1.283 4.48 4.48 0 0 1-1.283-3.762 4.462 4.462 0 0 1 1.283-2.604 4.48 4.48 0 0 1 3.762-1.283M8 10v3.493h.087c.351 0 .923-.128 1.299-.29a3.499 3.499 0 0 0 1.987-4.095 3.507 3.507 0 0 0-2.48-2.48 4.323 4.323 0 0 0-.806-.121H8V10",
		fillRule: "evenodd"
	}) }),
	Superscript: /* @__PURE__ */ jsx("path", { d: "M4.0285205,7 C5.13963717,7 6.01009786,7.277775 6.6399287,7.83333333 C7.26975954,8.38889167 7.59655365,9.15388699 7.62032086,10.1283422 L7.62032086,14.5668449 C7.62032086,15.4521732 7.73321337,16.156266 7.95900178,16.6791444 L7.95900178,16.8217469 L6.22994652,16.8217469 C6.13487772,16.6316093 6.05763547,16.2929317 5.99821747,15.8057041 C5.23172522,16.6019053 4.31670169,17 3.25311943,17 C2.30243137,17 1.52258177,16.7311376 0.913547237,16.1934046 C0.304512701,15.6556717 2.7533531e-14,14.9738603 2.7533531e-14,14.1479501 C2.7533531e-14,13.1437858 0.381754947,12.3639362 1.14527629,11.8083779 C1.90879764,11.2528196 2.98276194,10.9750446 4.36720143,10.9750446 L5.9714795,10.9750446 L5.9714795,10.2174688 C5.9714795,9.64111417 5.79916988,9.18211698 5.45454545,8.84046346 C5.10992103,8.49880994 4.60190472,8.32798574 3.93048128,8.32798574 C3.34224305,8.32798574 2.84908102,8.47652852 2.45098039,8.77361854 C2.05287977,9.07070856 1.85383244,9.43018209 1.85383244,9.85204991 L0.196078431,9.85204991 C0.196078431,9.37076408 0.366902629,8.90582518 0.70855615,8.45721925 C1.05020967,8.00861332 1.51366315,7.65359608 2.09893048,7.39215686 C2.68419782,7.13071765 3.32738806,7 4.0285205,7 Z M5.9714795,12.1426025 L4.67914439,12.1426025 C2.65893226,12.1426025 1.64884135,12.7338028 1.64884135,13.916221 C1.64884135,14.4331577 1.82115098,14.837194 2.1657754,15.1283422 C2.51039982,15.4194905 2.95305731,15.5650624 3.49376114,15.5650624 C4.01069777,15.5650624 4.50088895,15.4313739 4.96434938,15.1639929 C5.4278098,14.8966119 5.76351649,14.5490217 5.9714795,14.1212121 L5.9714795,12.1426025 Z M12.4808795,5 C13.2329547,5 13.8121395,5.17219417 14.2184512,5.51658768 C14.624763,5.86098118 14.8279159,6.35544701 14.8279159,7 C14.8279159,7.27172332 14.7769285,7.53633363 14.6749522,7.79383886 C14.5729759,8.0513441 14.414437,8.32148358 14.1993308,8.6042654 C13.9842245,8.88704723 13.6376697,9.26540047 13.1596558,9.73933649 L12.2609943,10.7677725 L15,10.7677725 L15,12 L10.1434034,12 L10.1434034,10.957346 L12.3804971,8.62559242 C12.9318065,8.00315645 13.207457,7.50869062 13.207457,7.14218009 C13.207457,6.84518019 13.1421294,6.61927408 13.0114723,6.46445498 C12.8808152,6.30963588 12.6912058,6.23222749 12.4426386,6.23222749 C12.1972582,6.23222749 11.9980887,6.33570197 11.8451243,6.54265403 C11.6921598,6.74960609 11.6156788,7.00789735 11.6156788,7.31753555 L10,7.31753555 C10,6.8941527 10.1067548,6.50316135 10.3202677,6.14454976 C10.5337805,5.78593818 10.8301447,5.50553024 11.209369,5.30331754 C11.5885934,5.10110483 12.012426,5 12.4808795,5 Z" }),
	Table: /* @__PURE__ */ jsx("path", { d: "M15,16 C15,17.1045695 14.1045695,18 13,18 L3,18 C1.8954305,18 1,17.1045695 1,16 L1,6 C1,4.8954305 1.8954305,4 3,4 L13,4 C14.1045695,4 15,4.8954305 15,6 L15,16 Z M2.5,15.5 C2.5,16.0128358 2.88604019,16.4355072 3.38337887,16.4932723 L3.5,16.5 L7.5,16.5 L7.5,11.5 L2.5,11.5 L2.5,15.5 Z M13.5,11.5 L8.5,11.5 L8.5,16.5 L12.5,16.5 C13.0128358,16.5 13.4355072,16.1139598 13.4932723,15.6166211 L13.5,15.5 L13.5,11.5 Z M12.5,5.5 L8.5,5.5 L8.5,10.5 L13.5,10.5 L13.5,6.5 C13.5,5.94771525 13.0522847,5.5 12.5,5.5 Z M7.5,5.5 L3.5,5.5 C2.98716416,5.5 2.56449284,5.88604019 2.50672773,6.38337887 L2.5,6.5 L2.5,10.5 L7.5,10.5 L7.5,5.5 Z" }),
	Tag: /* @__PURE__ */ jsx("path", { d: "M13.9356321,5.06436654 C14.6460571,5.77479168 15.0008449,7.48746743 15,10.2023938 C14.9998535,10.7291473 14.7905285,11.2342791 14.4180576,11.6067501 L8.31578541,17.7090229 C7.92781596,18.0969924 7.2987932,18.0969924 6.91082375,17.7090229 L1.29097709,12.0891756 C0.903007637,11.7012061 0.903007637,11.0721833 1.29097709,10.6842138 L7.39323334,4.5819569 C7.76569942,4.20949078 8.27082457,4.00016845 8.79757112,4.00000153 C11.512517,3.99915058 13.225204,4.35393841 13.9356321,5.06436654 Z M12.8819108,6.1180879 C12.5457646,5.78194167 11.1338352,5.4894566 8.79803903,5.49018865 C8.69268968,5.49018865 8.59079965,5.52372138 8.50658209,5.58479485 L8.44695459,5.63567826 L2.69593875,11.3866947 L7.61330458,16.3040611 L13.3643363,10.5530287 C13.438828,10.478537 13.4872126,10.3828292 13.5036049,10.2800842 L13.50981,10.2019275 C13.5105395,7.86615005 13.2180549,6.454232 12.8819108,6.1180879 Z M11.8281896,7.17180926 C12.6041285,7.94774825 12.6041285,9.20579391 11.8281896,9.98173289 C11.0522507,10.7576719 9.79420515,10.7576719 9.01826625,9.98173289 C8.24232734,9.20579391 8.24232734,7.94774825 9.01826625,7.17180926 C9.79420515,6.39587028 11.0522507,6.39587028 11.8281896,7.17180926 Z M11.1257087,7.87429017 C10.7377393,7.48632068 10.1087165,7.48632068 9.72074708,7.87429017 C9.33277763,8.26225966 9.33277763,8.89128249 9.72074708,9.27925199 C10.1087165,9.66722148 10.7377393,9.66722148 11.1257087,9.27925199 C11.5136782,8.89128249 11.5136782,8.26225966 11.1257087,7.87429017 Z" }),
	Teacher: /* @__PURE__ */ jsx("path", { d: "M14,10 L14,16 L14.381966,16 C14.7607381,16 15.1070012,16.2140024 15.2763932,16.5527864 L16,18 L0,18 L0.723606798,16.5527864 C0.892998812,16.2140024 1.23926193,16 1.61803399,16 L2,16 L2,10 L4,10 L4,16 L7,16 L7,10 L8.999,10 L9,16 L12,16 L11.999,10 L14,10 Z M8,4 L16,8 L14,9 L2,9 L0,8 L8,4 Z" }),
	Template: /* @__PURE__ */ jsx("path", { d: "M16,17 C16,18.1045695 15.1045695,19 14,19 L2,19 C0.8954305,19 1.3527075e-16,18.1045695 0,17 L0,5 C-1.3527075e-16,3.8954305 0.8954305,3 2,3 L14,3 C15.1045695,3 16,3.8954305 16,5 L16,17 Z M6,4.5 L2.5,4.5 C1.98716416,4.5 1.56449284,4.88604019 1.50672773,5.38337887 L1.5,5.5 L1.5,16.5 C1.5,17.0128358 1.88604019,17.4355072 2.38337887,17.4932723 L2.5,17.5 L6,17.5 L6,4.5 Z M14.5,11 L8,11 L8,17.5 L13.5,17.5 C14.0128358,17.5 14.4355072,17.1139598 14.4932723,16.6166211 L14.5,16.5 L14.5,11 Z M13.5,4.5 L8,4.5 L8,9 L14.5,9 L14.5,5.5 C14.5,4.94771525 14.0522847,4.5 13.5,4.5 Z" }),
	TextFile: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M0.466073 0.669948V0.672626C0.202715 0.723518 -0.00468088 0.983639 8.03613e-05 1.25594V18.7519C8.03613e-05 19.0559 0.274892 19.3333 0.575429 19.3333H15.424C15.7253 19.3333 16 19.056 16 18.7506V5.22679C15.9946 5.13766 15.9693 5.04956 15.9266 4.97159L11.5113 0.705685C11.454 0.68381 11.3927 0.671757 11.3312 0.669227H0.574995C0.539286 0.665804 0.501782 0.666525 0.466073 0.669948Z",
			fill: "#5B6F98"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "5.79492",
			width: "10.9983",
			height: "1.2",
			rx: "0.6",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "8.79492",
			width: "10.9983",
			height: "1.2",
			rx: "0.6",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "11.7949",
			width: "10.9983",
			height: "1.2",
			rx: "0.6",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "2.50085",
			y: "14.7949",
			width: "6.00303",
			height: "1.2",
			rx: "0.6",
			fill: "white"
		})
	] }),
	ThumbsDown: /* @__PURE__ */ jsx("path", { d: "M1,13 L5,13 L5,6 L1,6 L1,13 Z M6,13.2353374 L8.2932981,19 C9.68736781,19 9.99943484,17.5016438 9.22949917,14.5049313 C9.09083677,13.965264 9.40290364,13.4119257 9.92651311,13.2690175 C10.0084358,13.2466584 10.0928247,13.2353374 10.177571,13.2353374 L14.0192506,13.2353374 C14.5609035,13.2353374 15,12.7827733 15,12.2245072 C15,12.1699229 14.9957103,12.1154283 14.987173,12.0615578 L14.1609147,6.84788089 C14.0834354,6.35898805 13.6736224,6 13.1929922,6 L6,6 L6,13.2353374 Z" }),
	ThumbsUp: /* @__PURE__ */ jsx("path", { d: "M1,8 L5,8 L5,15 L1,15 L1,8 Z M6,7.7646626 L8.2932981,2 C9.68736781,2 9.99943484,3.49835623 9.22949917,6.49506869 C9.09083677,7.03473601 9.40290364,7.58807434 9.92651311,7.73098254 C10.0084358,7.75334161 10.0928247,7.7646626 10.177571,7.7646626 L14.0192506,7.7646626 C14.5609035,7.7646626 15,8.21722671 15,8.77549282 C15,8.83007712 14.9957103,8.88457175 14.987173,8.93844215 L14.1609147,14.1521191 C14.0834354,14.641012 13.6736224,15 13.1929922,15 L6,15 L6,7.7646626 Z" }),
	Tick: /* @__PURE__ */ jsx("path", { d: "M5.9,17 L1.65909049,12.5571424 C1.29023121,12.1707184 1.29023121,11.5626149 1.65909049,11.1761909 L1.7,11.1333333 C2.06902663,10.746734 2.68158249,10.7324885 3.06818182,11.1015152 C3.07903306,11.1118732 3.08964199,11.1224821 3.1,11.1333333 L5.9,14.0666667 L5.9,14.0666667 L12.9,6.73333333 C13.2690266,6.34673401 13.8815825,6.33248852 14.2681818,6.70151515 C14.2790331,6.71187316 14.289642,6.72248209 14.3,6.73333333 L14.3409095,6.77619092 C14.7097688,7.16261492 14.7097688,7.77071841 14.3409095,8.15714241 L5.9,17 L5.9,17 Z" }),
	Time: /* @__PURE__ */ jsx("path", { d: "M8,3 C12.418278,3 16,6.581722 16,11 C16,15.418278 12.418278,19 8,19 C3.581722,19 0,15.418278 0,11 C0,6.581722 3.581722,3 8,3 Z M8,4.5 C4.41014913,4.5 1.5,7.41014913 1.5,11 C1.5,14.5898509 4.41014913,17.5 8,17.5 C11.5898509,17.5 14.5,14.5898509 14.5,11 C14.5,7.41014913 11.5898509,4.5 8,4.5 Z M8.5,6 L8.5,11.132 L11.2141016,12.7 L10.4641016,13.9990381 L7.002,12 L7,12 L7,6 L8.5,6 Z" }),
	Trash: /* @__PURE__ */ jsx("path", { d: "M5.03846154,5 L5.03846154,4 L10.9615385,4 L10.9615385,5 L14,5 L14,6.5 L2,6.5 L2,5 L5.03846154,5 Z M2.67986425,8 L13.5011312,8 L12.3427254,17 L3.63680821,17 L2.67986425,8 Z" }),
	Turnitin: /* @__PURE__ */ jsxs("g", { children: [/* @__PURE__ */ jsx("path", { d: "M-4.26325641e-14,10.2097204 C0.897427189,7.99562416 1.39161169,5.55576644 1.39161169,3 L9.80217913,3 C9.80217913,7.12525238 8.92590433,11.0361511 7.35739399,14.5414396 L4.14950608,14.5414396 L-4.26325641e-14,10.2097204 Z M4.14950608,13.583749 L6.84731152,13.583749 C8.09166485,10.6160347 8.82863028,7.38608224 8.94395796,3.96839423 L2.2910598,3.96853507 C2.18987863,6.17432192 1.73732527,8.25673569 0.990659379,10.2097204 L4.14950608,13.583749 L4.14950608,13.583749 Z" }), /* @__PURE__ */ jsx("path", { d: "M13.4891619 6.11706961C14.8338881 7.857954 13.5051946 12.0301051 9.95576973 15.0271134 6.6828079 17.789065 2.76516974 18.8528058 1.52714866 17.2467022.672699888 16.138457 1.3002657 13.9423879 2.39992051 12.7859765L4.14937135 14.5710678 4.14937135 10.2789396-8.2600593e-14 10.2789396 1.74109767 12.100101C.271073939 13.6408562-.40351215 16.1905667.777653466 17.8534274 1.14020812 18.3636794 1.69596359 18.6676053 2.34198721 18.8222442 4.28544724 19.2867241 7.34419059 18.1410163 10.0430739 15.8632618 13.907629 12.6006352 15.5541471 8.25835319 13.9080331 6.12678736 13.0806648 5.05501888 11.5473187 4.7761619 9.72632693 5.17008259 11.2401374 4.85249548 12.8760121 5.32317225 13.4891619 6.11706961zM15.1024841 3.57574107C15.1024841 3.25674559 14.8556613 3 14.5505011 3 14.245206 3 14 3.25674559 14 3.57574107 14 3.89487739 14.245206 4.15317219 14.5505011 4.15317219 14.8556613 4.15317219 15.1024841 3.89487739 15.1024841 3.57574107L15.1024841 3.57574107zM15.0115423 3.57574107C15.0115423 3.84178189 14.8048686 4.05782563 14.5505011 4.05782563 14.2959987 4.05782563 14.0909418 3.84178189 14.0909418 3.57574107 14.0909418 3.30970025 14.2959987 3.09520572 14.5505011 3.09520572 14.8048686 3.09520572 15.0115423 3.30970025 15.0115423 3.57574107L15.0115423 3.57574107zM14.4052636 3.54602449L14.4052636 3.35969733 14.5593931 3.35969733C14.6223114 3.35969733 14.6658287 3.39575157 14.6658287 3.45222715 14.6658287 3.51630792 14.6163833 3.54602449 14.5428215 3.54602449L14.4052636 3.54602449zM14.309741 3.89487739L14.4052636 3.89487739 14.4052636 3.63207581 14.4622538 3.63207581C14.5355462 3.63207581 14.5639739 3.65855314 14.638883 3.79798163L14.6911577 3.89487739 14.8076979 3.89487739 14.7358876 3.77460271C14.6868464 3.69122729 14.6491224 3.6381318 14.5984644 3.61968217L14.5984644 3.61630209C14.6987025 3.61010526 14.7671446 3.53827847 14.7671446 3.43786179 14.7671446 3.37054177 14.7181034 3.27547689 14.5715187 3.27547689L14.309741 3.27547689 14.309741 3.89487739 14.309741 3.89487739z" })] }),
	Underline: /* @__PURE__ */ jsx("path", { d: "M0,17.5 L16,17.5 L16,19 L0,19 L0,17.5 Z M12.5691057,6 L12.5691057,12.0487805 C12.5636856,13.1653172 12.2127406,14.0785872 11.5162602,14.7886179 C10.8197797,15.4986485 9.87534472,15.8970185 8.68292683,15.9837398 L8.26829268,16 C6.97289325,16 5.94038325,15.65041 5.17073171,14.9512195 C4.40108016,14.252029 4.01084016,13.289979 4,12.0650407 L4,6 L5.54471545,6 L5.54471545,12.0162602 C5.54471545,12.872633 5.78048545,13.537938 6.25203252,14.0121951 C6.72357959,14.4864522 7.39565959,14.7235772 8.26829268,14.7235772 C9.15176593,14.7235772 9.82791093,14.4878072 10.296748,14.0162602 C10.765585,13.5447131 11,12.8807631 11,12.0243902 L11,6 L12.5691057,6 Z" }),
	Undo: /* @__PURE__ */ jsx("path", { d: "M6.11772772,7.6 L8,10 L6.617119,10 L4,7.07133917 L4,6.92866083 L4.82598647,6.00434894 L4.8259863,6 L4.82987278,6 L6.617119,4 L8,4 L6.43536117,6 L8,6 C11.3137085,6 14,8.6862915 14,12 C14,15.3137085 11.3137085,18 8,18 C4.6862915,18 2,15.3137085 2,12 L3.6,12 C3.6,14.4300529 5.5699471,16.4 8,16.4 C10.4300529,16.4 12.4,14.4300529 12.4,12 C12.4,9.5699471 10.4300529,7.6 8,7.6 L6.11772772,7.6 Z" }),
	UnknownFile: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M0.466073 0.669765V0.672443C0.202715 0.723335 -0.00468088 0.983456 8.03613e-05 1.25576V18.7517C8.03613e-05 19.0558 0.274892 19.3331 0.575429 19.3331H15.424C15.7253 19.3331 16 19.0558 16 18.7504V5.22661C15.9946 5.13747 15.9693 5.04938 15.9266 4.9714L11.5113 0.705502C11.454 0.683627 11.3927 0.671574 11.3312 0.669044H0.574995C0.539286 0.665621 0.501782 0.666342 0.466073 0.669765Z",
			fill: "#0F172E"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M4.66663 9.36104C4.66663 7.52009 6.15901 6.02771 7.99996 6.02771C9.84091 6.02771 11.3333 7.52009 11.3333 9.36104C11.3333 10.9142 10.271 12.2193 8.83329 12.5894V13.1215H7.16663V11.0277H7.99996C8.92044 11.0277 9.66663 10.2815 9.66663 9.36104C9.66663 8.44057 8.92044 7.69438 7.99996 7.69438C7.07949 7.69438 6.33329 8.44057 6.33329 9.36104H4.66663Z",
			fill: "#F2F5FC"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M8.83329 16.0277V14.361H7.16663V16.0277H8.83329Z",
			fill: "#F2F5FC"
		})
	] }),
	Unset: /* @__PURE__ */ jsx("path", { d: "M5.05198724,15.2518035 C7.06888937,16.5226711 9.76621001,16.2797259 11.522968,14.522968 C13.2797259,12.76621 13.5226711,10.0688894 12.2518035,8.05198724 L5.05198724,15.2518035 L5.05198724,15.2518035 Z M3.74819648,13.9480128 L10.9480128,6.74819648 C8.93111063,5.47732888 6.23378999,5.72027406 4.47703203,7.47703203 C2.72027406,9.23378999 2.47732888,11.9311106 3.74819648,13.9480128 L3.74819648,13.9480128 Z M12.9497475,15.9497475 C10.2160774,18.6834175 5.78392257,18.6834175 3.05025253,15.9497475 C0.316582489,13.2160774 0.316582489,8.78392257 3.05025253,6.05025253 C5.78392257,3.31658249 10.2160774,3.31658249 12.9497475,6.05025253 C15.6834175,8.78392257 15.6834175,13.2160774 12.9497475,15.9497475 Z" }),
	Up: /* @__PURE__ */ jsx("polygon", { points: "9 7.653 9 17 7 17 7 7.647 3 10 3 8.271 7.881 5 8.119 5 13 8.271 13 10" }),
	UpArrowhead: /* @__PURE__ */ jsx("polygon", { points: "11 12.271 11 14 7.996 12.063 5 14 5 12.271 7.929 10 8.071 10" }),
	UpCaret: /* @__PURE__ */ jsx("polygon", { points: "11 14 5 14 8 9" }),
	Upload: /* @__PURE__ */ jsx("path", { d: "M14,17 L14,15 L16,15 L16,19 L0,19 L0,15 L2,15 L2,17 L14,17 Z M7,5.65304175 L3,8 L3,6.27139875 L7.88110138,3 L8.11889862,3 L13,6.27139875 L13,8 L9,5.64715965 L9,14 L7,14 L7,5.65304175 Z" }),
	VideoUpload: /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", { d: "M14.5266 2.01123H1.47336C1.08259 2.01123 0.707883 2.16644 0.431541 2.44277C0.155199 2.71911 0 3.09382 0 3.48459V16.5379C0 16.9286 0.155207 17.3033 0.431541 17.5797C0.707875 17.856 1.08259 18.0112 1.47336 18.0112H14.5266C14.9174 18.0112 15.2921 17.856 15.5685 17.5797C15.8448 17.3034 16 16.9286 16 16.5379V3.48459C16 3.09382 15.8448 2.71911 15.5685 2.44277C15.2921 2.16643 14.9174 2.01123 14.5266 2.01123Z" }), /* @__PURE__ */ jsx("path", {
		d: "M10.7899 10.1921L6.48488 13.2097C6.26695 13.3637 5.89453 13.2559 5.89453 13.0327V6.98972C5.89453 6.76652 6.26695 6.65879 6.48488 6.81274C8.16608 7.9912 9.10866 8.65191 10.7899 9.83037C10.8574 9.8735 10.8963 9.94154 10.8945 10.0132C10.8926 10.0848 10.8505 10.1513 10.7807 10.1921L10.7899 10.1921Z",
		fill: "white"
	})] }),
	WebpageFile: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M0.466073 0.669948V0.672626C0.202715 0.723518 -0.00468088 0.983639 8.03613e-05 1.25594V18.7519C8.03613e-05 19.0559 0.274892 19.3333 0.575429 19.3333H15.424C15.7253 19.3333 16 19.056 16 18.7506V5.22679C15.9946 5.13766 15.9693 5.04956 15.9266 4.97159L11.5113 0.705685C11.454 0.68381 11.3927 0.671757 11.3312 0.669227H0.574995C0.539286 0.665804 0.501782 0.666525 0.466073 0.669948Z",
			fill: "#5B6F98"
		}),
		/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.53927 15.7036L8.44405 6.29325L9.46073 6.29635L7.55595 15.7067L6.53927 15.7036Z",
			fill: "white"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M2.85608 10.9972L5.64989 13.0946V12.3608L3.83425 10.9972L5.64989 9.6336V8.90002L2.85608 10.9972Z",
			fill: "white",
			stroke: "white",
			strokeWidth: "0.5",
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M13.1439 10.9972L10.3501 13.0946V12.3608L12.1657 10.9972L10.3501 9.6336V8.90002L13.1439 10.9972Z",
			fill: "white",
			stroke: "white",
			strokeWidth: "0.5",
			strokeLinecap: "square"
		})
	] }),
	Wifi: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", { d: "M15.7491 8.12873C15.8344 8.21406 15.9181 8.30045 16 8.38786L14.8923 9.49556C14.8109 9.40776 14.7275 9.32113 14.6421 9.23574C10.9738 5.56742 5.02624 5.56742 1.35791 9.23574C1.27252 9.32113 1.18912 9.40776 1.1077 9.49556L0 8.38786C0.081931 8.30045 0.165563 8.21406 0.250897 8.12873C4.53061 3.84902 11.4694 3.84902 15.7491 8.12873Z" }),
		/* @__PURE__ */ jsx("path", { d: "M13.5351 10.3428C13.6205 10.4282 13.7036 10.5152 13.7843 10.6035L12.6758 11.712C12.5962 11.6228 12.5136 11.5354 12.4281 11.4498C9.98251 9.00422 6.01749 9.00422 3.57194 11.4498C3.48636 11.5354 3.40377 11.6228 3.32418 11.712L2.21571 10.6035C2.2964 10.5152 2.37947 10.4282 2.46493 10.3428C5.52186 7.28582 10.4781 7.28582 13.5351 10.3428Z" }),
		/* @__PURE__ */ jsx("path", { d: "M11.5664 12.8214C11.4886 12.7309 11.4068 12.6426 11.321 12.5568C9.48688 10.7226 6.51312 10.7226 4.67896 12.5568C4.59316 12.6426 4.51138 12.7309 4.43361 12.8214L5.54551 13.9333C5.61958 13.8401 5.69973 13.75 5.78597 13.6638C7.00875 12.441 8.99126 12.441 10.214 13.6638C10.3003 13.75 10.3804 13.8401 10.4545 13.9333L11.5664 12.8214Z" }),
		/* @__PURE__ */ jsx("path", { d: "M8 16.3878L9.3325 15.0553C9.26994 14.9542 9.19478 14.8586 9.10702 14.7708C8.49563 14.1594 7.50438 14.1594 6.89299 14.7708C6.80523 14.8586 6.73007 14.9542 6.6675 15.0553L8 16.3878Z" })
	] }),
	WifiDisabled: /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", { d: "M15.7491 8.12873C15.8344 8.21406 15.9181 8.30045 16 8.38786L14.8923 9.49556C14.8109 9.40776 14.7275 9.32113 14.6421 9.23574C10.9738 5.56742 5.02624 5.56742 1.35791 9.23574C1.27252 9.32113 1.18912 9.40776 1.1077 9.49556L0 8.38786C0.081931 8.30045 0.165563 8.21406 0.250897 8.12873C4.53061 3.84902 11.4694 3.84902 15.7491 8.12873Z" }),
		/* @__PURE__ */ jsx("path", { d: "M13.5351 10.3428C13.6205 10.4282 13.7036 10.5152 13.7843 10.6035L12.6758 11.712C12.5962 11.6228 12.5136 11.5354 12.4281 11.4498C9.98251 9.00422 6.01749 9.00422 3.57194 11.4498C3.48636 11.5354 3.40377 11.6228 3.32418 11.712L2.21571 10.6035C2.2964 10.5152 2.37947 10.4282 2.46493 10.3428C5.52186 7.28582 10.4781 7.28582 13.5351 10.3428Z" }),
		/* @__PURE__ */ jsx("path", { d: "M11.5664 12.8214C11.4886 12.7309 11.4068 12.6426 11.321 12.5568C9.48688 10.7226 6.51312 10.7226 4.67896 12.5568C4.59316 12.6426 4.51138 12.7309 4.43361 12.8214L5.54551 13.9333C5.61958 13.8401 5.69973 13.75 5.78597 13.6638C7.00875 12.441 8.99126 12.441 10.214 13.6638C10.3003 13.75 10.3804 13.8401 10.4545 13.9333L11.5664 12.8214Z" }),
		/* @__PURE__ */ jsx("path", { d: "M8 16.3878L9.3325 15.0553C9.26994 14.9542 9.19478 14.8586 9.10702 14.7708C8.49563 14.1594 7.50438 14.1594 6.89299 14.7708C6.80523 14.8586 6.73007 14.9542 6.6675 15.0553L8 16.3878Z" }),
		/* @__PURE__ */ jsx("path", {
			d: "M9.21875 14.2793H9.58428L9.59363 13.9139L9.87488 2.91388L9.88471 2.5293H9.5H6.5H6.1157L6.12511 2.91348L6.39464 13.9135L6.40361 14.2793H6.76953H9.21875Z",
			fill: "#D92644",
			stroke: "white",
			strokeWidth: "0.75"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M6.53659 13.9776C6.1722 14.3682 6 14.8568 6 15.4049C6 15.939 6.16928 16.4161 6.52336 16.801C6.90092 17.2113 7.41811 17.3877 8 17.3877C8.58189 17.3877 9.09908 17.2113 9.47664 16.801C9.83072 16.4161 10 15.939 10 15.4049C10 14.8568 9.82779 14.3682 9.46341 13.9776C9.08367 13.5706 8.57524 13.3877 8 13.3877C7.42476 13.3877 6.91633 13.5706 6.53659 13.9776Z",
			fill: "#D92644",
			stroke: "white"
		})
	] })
};
/**
* Renders a **Cadmus Icon**
*
* Cadmus icons are built with SVG, meaning they are infinitely scalable. They
* can be used inline with text, and will scale to an inherited font size. They
* can also be used independently (for example, in buttons).
*
*/
const Icon = (props) => {
	const { iconName, titleAccess, ...other } = props;
	return /* @__PURE__ */ jsxs(SVG, {
		focusable: "false",
		viewBox: "0 0 16 21",
		"aria-hidden": titleAccess != null && titleAccess !== "" ? "false" : "true",
		width: "1em",
		height: "100%",
		...other,
		children: [titleAccess != null && titleAccess !== "" ? /* @__PURE__ */ jsx("title", { children: titleAccess }) : null, iconName && iconList[iconName]]
	});
};
const SVG = styled.svg`
  display: inline-flex;
  vertical-align: text-bottom;
`;
//#endregion
//#region src/generated/AddCircleIcon.tsx
const SvgAddCircleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.1 11.1V7.5h1.8v3.6h3.6v1.8h-3.6v3.6h-1.8v-3.6H7.5v-1.8zM12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-1.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4"
			})
		})
	});
};
const ForwardRef = forwardRef(SvgAddCircleIcon);
//#endregion
//#region src/generated/AddCircleSolidIcon.tsx
const SvgAddCircleSolidIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: 16,
					height: 16,
					fill: "#3F5982",
					rx: 8
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#fff",
					fillRule: "evenodd",
					d: "M7.41 7.41V5.049c0-.322.262-.583.584-.583h.012c.322 0 .583.26.583.583V7.41h2.363c.322 0 .584.261.584.583v.012a.583.583 0 0 1-.584.583H8.59v2.363a.583.583 0 0 1-.583.584h-.012a.583.583 0 0 1-.583-.584V8.59H5.048a.583.583 0 0 1-.584-.583v-.012c0-.322.261-.583.584-.583z",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ jsx("mask", {
					id: "AddCircleSolidIcon_svg__a",
					width: 8,
					height: 8,
					x: 4,
					y: 4,
					maskUnits: "userSpaceOnUse",
					style: { maskType: "luminance" },
					children: /* @__PURE__ */ jsx("path", {
						fill: "#fff",
						fillRule: "evenodd",
						d: "M7.41 7.41V5.049c0-.322.262-.583.584-.583h.012c.322 0 .583.26.583.583V7.41h2.363c.322 0 .584.261.584.583v.012a.583.583 0 0 1-.584.583H8.59v2.363a.583.583 0 0 1-.583.584h-.012a.583.583 0 0 1-.583-.584V8.59H5.048a.583.583 0 0 1-.584-.583v-.012c0-.322.261-.583.584-.583z",
						clipRule: "evenodd"
					})
				})
			]
		})
	});
};
const ForwardRef$1 = forwardRef(SvgAddCircleSolidIcon);
//#endregion
//#region src/generated/ArrowCirclingLeftIcon.tsx
const SvgArrowCirclingLeftIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M10.118 8.6 12 11h-1.383L8 8.071V7.93l.826-.925V7h.004l1.787-2H12l-1.565 2H12a6 6 0 1 1-6 6h1.6A4.4 4.4 0 1 0 12 8.6z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$2 = forwardRef(SvgArrowCirclingLeftIcon);
//#endregion
//#region src/generated/ArrowDownTrayIcon.tsx
const SvgArrowDownTrayIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18 18v-2h2v4H4v-4h2v2zm-5-5.653L17 10v1.729L12.119 15h-.238L7 11.729V10l4 2.353V4h2z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$3 = forwardRef(SvgArrowDownTrayIcon);
//#endregion
//#region src/generated/ArrowImportLineIcon.tsx
const SvgArrowImportLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M4 5.667C4 5.298 4.298 5 4.667 5H10a4.667 4.667 0 0 1 4.667 4.667v3.723l2.862-2.861a.667.667 0 0 1 .942.942l-4 4a.667.667 0 0 1-.942 0l-4-4a.667.667 0 1 1 .942-.942l2.862 2.861V9.668A3.333 3.333 0 0 0 10 6.333H4.667A.667.667 0 0 1 4 5.667m4.667 8.666c.368 0 .666.299.666.667v2h9.334v-2A.667.667 0 0 1 20 15v2.667a.667.667 0 0 1-.667.666H8.667A.667.667 0 0 1 8 17.667V15c0-.368.298-.667.667-.667",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$4 = forwardRef(SvgArrowImportLineIcon);
//#endregion
//#region src/generated/ArrowIntoLineDownIcon.tsx
const SvgArrowIntoLineDownIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M4 5.667C4 5.298 4.298 5 4.667 5H10a4.667 4.667 0 0 1 4.667 4.667v3.723l2.862-2.861a.667.667 0 0 1 .942.942l-4 4a.667.667 0 0 1-.942 0l-4-4a.667.667 0 1 1 .942-.942l2.862 2.861V9.668A3.333 3.333 0 0 0 10 6.333H4.667A.667.667 0 0 1 4 5.667m4.667 8.666c.368 0 .666.299.666.667v2h9.334v-2A.667.667 0 0 1 20 15v2.667a.667.667 0 0 1-.667.666H8.667A.667.667 0 0 1 8 17.667V15c0-.368.298-.667.667-.667",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$5 = forwardRef(SvgArrowIntoLineDownIcon);
//#endregion
//#region src/generated/ArrowLeftIcon.tsx
const SvgArrowLeftIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 20 21",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M8.766 3.65a.704.704 0 0 1 0 .995l-5.37 5.37h15.2a.704.704 0 0 1 0 1.409h-15.2l5.37 5.37a.704.704 0 0 1-.996.996L.7 10.72l7.07-7.07a.704.704 0 0 1 .996 0" })
		})
	});
};
const ForwardRef$6 = forwardRef(SvgArrowLeftIcon);
//#endregion
//#region src/generated/ArrowLeftRightIcon.tsx
const SvgArrowLeftRightIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m7 17-5-5 5-5 1.4 1.4L5.825 11h12.35L15.6 8.4 17 7l5 5-5 5-1.4-1.4 2.575-2.6H5.825L8.4 15.6z"
			})
		})
	});
};
const ForwardRef$7 = forwardRef(SvgArrowLeftRightIcon);
//#endregion
//#region src/generated/ArrowPathIcon.tsx
const SvgArrowPathIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M12.882 7.6H11a4.4 4.4 0 0 0-3.748 6.706l-1.363.84A6 6 0 0 1 11 6h1.566L11 3.999h1.383L15 6.929v.142L12.383 10H11zm-1.764 8.938H13a4.4 4.4 0 0 0 3.747-6.708L18.115 9A6 6 0 0 1 13 18.138h-1.565L13 20h-1.383L9 17.21v-.143l2.617-2.929H13z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$8 = forwardRef(SvgArrowPathIcon);
//#endregion
//#region src/generated/ArrowRightIcon.tsx
const SvgArrowRightIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 12 10",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M9.347 4 7 0h1.729L12 4.881v.238L8.729 10H7l2.353-4H0V4z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$9 = forwardRef(SvgArrowRightIcon);
//#endregion
//#region src/generated/ArrowTopRightOnSquareIcon.tsx
const SvgArrowTopRightOnSquareIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10.2 6.6v1.8H5.7v9.9h9.9v-4.5h1.8v5.4a.9.9 0 0 1-.9.9H4.8a.9.9 0 0 1-.9-.9V7.5a.9.9 0 0 1 .9-.9zm9.9-2.7v7.2h-1.8V6.972l-7.014 7.014-1.272-1.272L17.026 5.7H12.9V3.9z"
			})
		})
	});
};
const ForwardRef$10 = forwardRef(SvgArrowTopRightOnSquareIcon);
//#endregion
//#region src/generated/ArrowUpTrayIcon.tsx
const SvgArrowUpTrayIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M18 18v-2h2v4H4v-4h2v2zM11 6.653 7 9V7.271L11.881 4h.238L17 7.271V9l-4-2.353V15h-2z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$11 = forwardRef(SvgArrowUpTrayIcon);
//#endregion
//#region src/generated/ArrowsCirclingIcon.tsx
const SvgArrowsCirclingIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 6a5.99 5.99 0 0 1 4.768 2.357L15 10.125h4.5v-4.5l-1.664 1.664A7.5 7.5 0 0 0 4.5 12H6a6 6 0 0 1 6-6m6 6a6 6 0 0 1-10.768 3.643L9 13.875H4.5v4.5l1.664-1.664A7.5 7.5 0 0 0 19.5 12z"
			})
		})
	});
};
const ForwardRef$12 = forwardRef(SvgArrowsCirclingIcon);
//#endregion
//#region src/generated/BarChartIcon.tsx
const SvgBarChartIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M3.9 12h3.6v8.1H3.9zm12.6-3.6h3.6v11.7h-3.6zM10.2 3h3.6v17.1h-3.6z" })
		})
	});
};
const ForwardRef$13 = forwardRef(SvgBarChartIcon);
//#endregion
//#region src/generated/BookIcon.tsx
const SvgBookIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				fillRule: "evenodd",
				d: "M17 4v12H7.5a1.5 1.5 0 0 0 0 3H18V4h1v16H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM7.5 17H17v1H7.5a.5.5 0 0 1 0-1",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$14 = forwardRef(SvgBookIcon);
//#endregion
//#region src/generated/BookMarkFilledIcon.tsx
const SvgBookMarkFilledIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 22",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 16,
				height: 22,
				fill: "#E1F4EE",
				rx: 2
			}), /* @__PURE__ */ jsx("path", {
				fill: "#3B404F",
				stroke: "#3B404F",
				d: "M7.714 14.518 8 14.32l.286.2L13 17.798V4.57c0-.236-.242-.571-.783-.571H3.783C3.242 4 3 4.335 3 4.571v13.227z"
			})]
		})
	});
};
const ForwardRef$15 = forwardRef(SvgBookMarkFilledIcon);
//#endregion
//#region src/generated/BookMarkIcon.tsx
const SvgBookMarkIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 12 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				stroke: "#3B404F",
				d: "M5.515 11.28 6 10.942l.485.338 4.165 2.897V1.62c0-.016-.005-.056-.066-.108a.56.56 0 0 0-.367-.113H1.783a.56.56 0 0 0-.367.113c-.06.052-.066.092-.066.108v12.557zM1.35 15.198Zm9.3 0v-.006z"
			})
		})
	});
};
const ForwardRef$16 = forwardRef(SvgBookMarkIcon);
//#endregion
//#region src/generated/BuildingLibraryIcon.tsx
const SvgBuildingLibraryIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				fillRule: "evenodd",
				d: "M18 11v6h.382a1 1 0 0 1 .894.553L20 19H4l.724-1.447A1 1 0 0 1 5.618 17H6v-6h2v6h3v-6h1.999L13 17h3l-.001-6zm-6-6 8 4-2 1H6L4 9z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$17 = forwardRef(SvgBuildingLibraryIcon);
//#endregion
//#region src/generated/BurgerIcon.tsx
const SvgBurgerIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				fillRule: "evenodd",
				d: "M6 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$18 = forwardRef(SvgBurgerIcon);
//#endregion
//#region src/generated/CadmusIcon.tsx
const SvgCadmusIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M11.394 12.707a5.7 5.7 0 0 1-2.38.82l1.053.053a16 16 0 0 1-1.556.797q-2.673 1.194-3.239 4.551L4 20q.776-1.053 1.391-4.623C6.735 7.58 13.658 3.441 20 4.061q-3.178.551-4.317 3.035-.705.773-1.763 1.064l1.433-.289a11.9 11.9 0 0 1-1.949 3.007q-.834.758-1.724.909h.831q-.543.497-1.117.92",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$19 = forwardRef(SvgCadmusIcon);
//#endregion
//#region src/generated/CalendarFilledIcon.tsx
const SvgCalendarFilledIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M16.5 3.9h3.6a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h3.6V2.1h1.8v1.8h5.4V2.1h1.8zM4.8 9.3v9h14.4v-9zm1.8 1.8h1.8v1.8H6.6zm4.5 0h1.8v1.8h-1.8zm4.5 0h1.8v1.8h-1.8z"
			})
		})
	});
};
const ForwardRef$20 = forwardRef(SvgCalendarFilledIcon);
//#endregion
//#region src/generated/CalendarIcon.tsx
const SvgCalendarIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M7.8 10.512h1.75v1.75H7.8zM9.55 13.837H7.8v1.75h1.75zM11.125 10.512h1.75v1.75h-1.75zM12.875 13.837h-1.75v1.75h1.75zM14.45 10.512h1.75v1.75h-1.75zM16.2 13.837h-1.75v1.75h1.75z"
			}), /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M7.1 7.45H6a1 1 0 0 0-1 1v10.2h14V8.45a1 1 0 0 0-1-1h-1.1v-2.1h-1.4v2.1h-7v-2.1H7.1zm-.7 1.4v8.4h11.2v-8.4z",
				clipRule: "evenodd"
			})]
		})
	});
};
const ForwardRef$21 = forwardRef(SvgCalendarIcon);
//#endregion
//#region src/generated/CalendarWithCheckIcon.tsx
const SvgCalendarWithCheckIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M9.3 2.1v1.8h5.4V2.1h1.8v1.8h3.6a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h3.6V2.1zm9.9 6.3H4.8v9.9h14.4zm-4.468 1.922 1.273 1.273-4.455 4.455-3.182-3.182 1.274-1.273 1.909 1.91 3.182-3.183" })
		})
	});
};
const ForwardRef$22 = forwardRef(SvgCalendarWithCheckIcon);
//#endregion
//#region src/generated/CameraIcon.tsx
const SvgCameraIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M9.3 3.9h5.4l1.8 1.8h3.6a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V6.6a.9.9 0 0 1 .9-.9h3.6zM12 18.3a5.4 5.4 0 1 0 0-10.8 5.4 5.4 0 0 0 0 10.8m0-1.8a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2"
			})
		})
	});
};
const ForwardRef$23 = forwardRef(SvgCameraIcon);
//#endregion
//#region src/generated/CaretIcon.tsx
const SvgCaretIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.333 6.333 8 3 4.667 6.333zm0 3.334L8 13 4.667 9.667z"
			})
		})
	});
};
const ForwardRef$24 = forwardRef(SvgCaretIcon);
//#endregion
//#region src/generated/CheckCircleIcon.tsx
const SvgCheckCircleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "#9188F8",
				stroke: "#9188F8",
				strokeWidth: .2,
				d: "M14.379 3.066a.604.604 0 0 1-.002.855l-6.421 6.404a.6.6 0 0 1-.427.177zm0 0a.604.604 0 0 0-.855-.001l-5.976 5.96-2.113-2.294a.604.604 0 0 0-.89.819h.001l2.538 2.757c.112.12.267.19.431.194z"
			}), /* @__PURE__ */ jsx("path", {
				fill: "#9188F8",
				stroke: "#9188F8",
				strokeWidth: .2,
				d: "M14.186 7.395a.604.604 0 0 0-.605.604A5.59 5.59 0 0 1 8 13.581 5.59 5.59 0 0 1 2.417 8 5.59 5.59 0 0 1 8 2.417.604.604 0 1 0 8 1.21a6.8 6.8 0 0 0-6.79 6.79 6.8 6.8 0 0 0 6.79 6.791A6.8 6.8 0 0 0 14.79 8a.604.604 0 0 0-.604-.605Z"
			})]
		})
	});
};
const ForwardRef$25 = forwardRef(SvgCheckCircleIcon);
//#endregion
//#region src/generated/CheckIcon.tsx
const SvgCheckIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "m5 13 4 4L19 7"
			})
		})
	});
};
const ForwardRef$26 = forwardRef(SvgCheckIcon);
//#endregion
//#region src/generated/CheckRoundIcon.tsx
const SvgCheckRoundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 16,
				height: 16,
				fill: "currentColor",
				rx: 8
			}), /* @__PURE__ */ jsx("path", {
				fill: "#F2F8F2",
				fillRule: "evenodd",
				d: "M6.754 8.925 5.008 7.426 3.75 8.702l3.004 2.775 5.496-5.679-1.258-1.276z",
				clipRule: "evenodd"
			})]
		})
	});
};
const ForwardRef$27 = forwardRef(SvgCheckRoundIcon);
//#endregion
//#region src/generated/ChevronDownIcon.tsx
const SvgChevronDownIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M10 12.155 4.167 6.32 2.988 7.5 10 14.512 17.012 7.5 15.834 6.32z" })
		})
	});
};
const ForwardRef$28 = forwardRef(SvgChevronDownIcon);
//#endregion
//#region src/generated/ChevronLeftIcon.tsx
const SvgChevronLeftIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 21",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6.014 10.5 11 5.508 9.993 4.5 4 10.5l5.993 6L11 15.492z"
			})
		})
	});
};
const ForwardRef$29 = forwardRef(SvgChevronLeftIcon);
//#endregion
//#region src/generated/ChevronRightIcon.tsx
const SvgChevronRightIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 21",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M9.986 10.5 5 15.492 6.007 16.5l5.993-6-5.993-6L5 5.508z"
			})
		})
	});
};
const ForwardRef$30 = forwardRef(SvgChevronRightIcon);
//#endregion
//#region src/generated/CircleIcon.tsx
const SvgCircleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 8 8",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("circle", {
				cx: 4,
				cy: 4,
				r: 4,
				fill: "currentColor"
			})
		})
	});
};
const ForwardRef$32 = forwardRef(SvgCircleIcon);
//#endregion
//#region src/generated/ClockIcon.tsx
const SvgClockIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			className: "ClockIcon_svg__size-6",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
			})
		})
	});
};
const ForwardRef$33 = forwardRef(SvgClockIcon);
//#endregion
//#region src/generated/ClockWithCircledLineIcon.tsx
const SvgClockWithCircledLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10 3a7 7 0 1 1-7 7h1.4a5.6 5.6 0 1 0 1.305-3.594L7.2 7.9H3V3.7l1.713 1.712A6.99 6.99 0 0 1 10 3m.7 3.5v3.21l2.27 2.27-.99.99-2.68-2.68V6.5z"
			})
		})
	});
};
const ForwardRef$34 = forwardRef(SvgClockWithCircledLineIcon);
//#endregion
//#region src/generated/CloseFillIcon.tsx
const SvgCloseFillIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-10.273L9.455 8.181 8.18 9.455 10.727 12l-2.546 2.545 1.274 1.274L12 13.273l2.545 2.546 1.274-1.274L13.273 12l2.546-2.545-1.274-1.274z"
			})
		})
	});
};
const ForwardRef$35 = forwardRef(SvgCloseFillIcon);
//#endregion
//#region src/generated/CloseIcon.tsx
const SvgCloseIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "m12 10.571 2.864-2.864a1 1 0 0 1 1.415 0l.014.014a1 1 0 0 1 0 1.415L13.429 12l2.864 2.864a1 1 0 0 1 0 1.415l-.014.014a1 1 0 0 1-1.415 0L12 13.429l-2.864 2.864a1 1 0 0 1-1.415 0l-.014-.014a1 1 0 0 1 0-1.415L10.571 12 7.707 9.136a1 1 0 0 1 0-1.415l.014-.014a1 1 0 0 1 1.415 0z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$36 = forwardRef(SvgCloseIcon);
//#endregion
//#region src/generated/CloseRoundIcon.tsx
const SvgCloseRoundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 16 17",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				"{titleAccess ?: null}",
				/* @__PURE__ */ jsx("rect", {
					width: 16,
					height: 16,
					y: .5,
					rx: 8
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#fff",
					d: "m8 7.667 1.67-1.671a.583.583 0 0 1 .826 0l.008.008a.583.583 0 0 1 0 .825L8.834 8.5l1.67 1.67a.583.583 0 0 1 0 .826l-.008.008a.583.583 0 0 1-.825 0L8 9.334l-1.671 1.67a.583.583 0 0 1-.825 0l-.009-.008a.583.583 0 0 1 0-.825L7.166 8.5l-1.67-1.67a.583.583 0 0 1 0-.826l.008-.008a.583.583 0 0 1 .825 0z"
				}),
				/* @__PURE__ */ jsx("mask", {
					id: "CloseRoundIcon_svg__a",
					width: 6,
					height: 7,
					x: 5,
					y: 5,
					maskUnits: "userSpaceOnUse",
					children: /* @__PURE__ */ jsx("path", {
						fill: "#fff",
						d: "m8 7.667 1.67-1.671a.583.583 0 0 1 .826 0l.008.008a.583.583 0 0 1 0 .825L8.834 8.5l1.67 1.67a.583.583 0 0 1 0 .826l-.008.008a.583.583 0 0 1-.825 0L8 9.334l-1.671 1.67a.583.583 0 0 1-.825 0l-.009-.008a.583.583 0 0 1 0-.825L7.166 8.5l-1.67-1.67a.583.583 0 0 1 0-.826l.008-.008a.583.583 0 0 1 .825 0z"
					})
				})
			]
		})
	});
};
const ForwardRef$37 = forwardRef(SvgCloseRoundIcon);
//#endregion
//#region src/generated/Cog6ToothIcon.tsx
const SvgCog6ToothIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.206 16.5a9 9 0 0 1-.88-2.094 2.7 2.7 0 0 0 .002-4.812 9 9 0 0 1 2.25-3.903 2.7 2.7 0 0 0 4.168-2.407 9 9 0 0 1 4.507.002 2.7 2.7 0 0 0 4.169 2.405A9 9 0 0 1 19.794 7.5c.39.674.681 1.377.88 2.093a2.7 2.7 0 0 0-.002 4.812 9 9 0 0 1-2.25 3.904 2.701 2.701 0 0 0-4.168 2.406 9 9 0 0 1-4.507-.002A2.7 2.7 0 0 0 5.58 18.31a9 9 0 0 1-1.373-1.81m5.094.176a4.5 4.5 0 0 1 2.025 2.493q.675.064 1.35 0a4.5 4.5 0 0 1 2.025-2.492 4.5 4.5 0 0 1 3.172-.509A7 7 0 0 0 18.547 15a4.5 4.5 0 0 1-1.146-3c0-1.134.423-2.194 1.146-3q-.284-.616-.675-1.17a4.5 4.5 0 0 1-3.171-.507 4.5 4.5 0 0 1-2.025-2.493q-.675-.064-1.35 0A4.5 4.5 0 0 1 9.3 7.321a4.5 4.5 0 0 1-3.172.509 7 7 0 0 0-.674 1.168A4.5 4.5 0 0 1 6.6 12 4.5 4.5 0 0 1 5.454 15q.284.615.675 1.168a4.5 4.5 0 0 1 3.171.508M12 14.7a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4m0-1.8a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8"
			})
		})
	});
};
const ForwardRef$38 = forwardRef(SvgCog6ToothIcon);
//#endregion
//#region src/generated/Cog8ToothIcon.tsx
const SvgCog8ToothIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M10.599 18a6.1 6.1 0 0 1-1.85-.767l.106-2.088-2.088.107A6.1 6.1 0 0 1 6 13.402L7.552 12 6 10.599a6.1 6.1 0 0 1 .767-1.85l2.088.106-.107-2.088A6.1 6.1 0 0 1 10.598 6L12 7.552 13.401 6a6.1 6.1 0 0 1 1.85.767l-.106 2.088 2.088-.107c.35.563.612 1.186.767 1.85L16.448 12 18 13.401a6.1 6.1 0 0 1-.767 1.85l-2.088-.106.107 2.088a6.1 6.1 0 0 1-1.85.767L12 16.448zM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$39 = forwardRef(SvgCog8ToothIcon);
//#endregion
//#region src/generated/CommentBubbleIcon.tsx
const SvgCommentBubbleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M2 2h17v5h3v14.922l-5.184-3.632H6.075v-3.298L2 17.846zm4.075 10.55V7H17V4H4v10.004zm2 3.74V9H20v9.078l-2.553-1.788z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$40 = forwardRef(SvgCommentBubbleIcon);
//#endregion
//#region src/generated/CommentIcon.tsx
const SvgCommentIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 14",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3B404F",
				fillRule: "evenodd",
				d: "M1 0h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4.243a3 3 0 0 0-2.122.879L0 14V1a1 1 0 0 1 1-1m2 8v1h5.5a.5.5 0 0 0 0-1zm0-3v1h7.5a.5.5 0 0 0 0-1zm0-3v1h9.5a.5.5 0 0 0 0-1z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$41 = forwardRef(SvgCommentIcon);
//#endregion
//#region src/generated/CommentWithFeatherIcon.tsx
const SvgCommentWithFeatherIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				stroke: "#3F5982",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.2,
				d: "M3.333 4.98c0-.26.095-.509.264-.693A.87.87 0 0 1 4.234 4h11.532c.239 0 .468.103.637.287s.264.433.264.693v8.726c0 .26-.095.51-.264.693a.87.87 0 0 1-.637.287H7.027l-2.568 2.647-1.126-1.666z"
			}), /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				fillRule: "evenodd",
				d: "M6.768 10.817c1.403-3.649 4.874-4.912 7.593-3.922q-1.363-.072-2.116.88-.429.468-.99.498l.606.064a7 7 0 0 1-.347.448q-.824.849-1.601.828h-.021l.579.142a6 6 0 0 1-.43.281q-.777.366-1.49.273l.581.16q-.36.133-.718.216l-.055.013q-1.285.288-2 1.803l-.013.031-.67.384q.051-.05.105-.115l.02-.024.01-.013.02-.025.02-.028.01-.013.02-.03.021-.029.01-.015.021-.031.01-.016.022-.033.021-.034.022-.035.021-.037.011-.018.022-.038.022-.039.011-.02.022-.04.023-.042.022-.042.023-.044.012-.022.023-.046.023-.046.023-.048.024-.048.023-.05.024-.05.024-.052.024-.053.025-.054.037-.083.024-.057.025-.057.025-.06.038-.09.026-.061.026-.063.025-.063.04-.098.039-.1.04-.102z",
				clipRule: "evenodd"
			})]
		})
	});
};
const ForwardRef$42 = forwardRef(SvgCommentWithFeatherIcon);
//#endregion
//#region src/generated/CommentWithFeatherMinusIcon.tsx
const SvgCommentWithFeatherMinusIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", {
					stroke: "#3F5982",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.2,
					d: "M4 5.153c0-.306.114-.599.317-.815C4.519 4.12 4.794 4 5.08 4H18.92c.287 0 .562.121.764.338.203.216.317.51.317.815v10.263c0 .306-.114.6-.317.816a1.05 1.05 0 0 1-.764.337H8.432l-3.08 3.114L4 17.723z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					fillRule: "evenodd",
					d: "M8.122 12.018c1.683-4.292 5.848-5.777 9.111-4.613q-1.636-.085-2.539 1.035-.516.55-1.188.586l.727.075a8 8 0 0 1-.416.527q-.989.999-1.922.974h-.025l.695.168q-.255.18-.515.33-.933.43-1.789.321l.698.188a7 7 0 0 1-.863.254l-.065.015q-1.542.339-2.4 2.121l-.016.037-.805.45q.063-.057.127-.134l.024-.029.012-.014.024-.03.024-.033.012-.016.025-.034.025-.034.012-.018.025-.037.013-.02.025-.038.025-.04.026-.041.026-.043.013-.021.026-.045.027-.046.013-.023.027-.048.027-.048.027-.05.027-.052.014-.026.027-.054.028-.054.028-.056.029-.057.028-.059.029-.06.028-.06.03-.062.029-.064.044-.097.03-.067.03-.068.03-.07.045-.105.03-.073.032-.073.03-.075.047-.115.048-.117.048-.121zM13.757 22.243a6 6 0 1 0 8.486-8.485 6 6 0 0 0-8.486 8.485",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#fff",
					fillRule: "evenodd",
					d: "M14.55 21.448a4.877 4.877 0 1 0 6.896-6.896 4.877 4.877 0 0 0-6.897 6.896",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					fillRule: "evenodd",
					d: "M15 17.4h6v1.2h-6z",
					clipRule: "evenodd"
				})
			]
		})
	});
};
const ForwardRef$43 = forwardRef(SvgCommentWithFeatherMinusIcon);
//#endregion
//#region src/generated/ContributionsIcon.tsx
const SvgContributionsIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 6.3-8.588v1.912A7.203 7.203 0 0 0 12 19.2a7.2 7.2 0 0 0 6.676-4.5h1.912A9 9 0 0 1 12 21m8.955-8.1H11.1V3.045Q11.545 3 12 3a9 9 0 0 1 8.955 9.9M12.9 4.856V11.1h6.244A7.2 7.2 0 0 0 12.9 4.856"
			})
		})
	});
};
const ForwardRef$44 = forwardRef(SvgContributionsIcon);
//#endregion
//#region src/generated/CopyIcon.tsx
const SvgCopyIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M7.5 6.6V3.9a.9.9 0 0 1 .9-.9h10.8a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9h-2.7v2.7c0 .497-.405.9-.906.9H4.806a.9.9 0 0 1-.906-.9l.003-12.6c0-.497.405-.9.906-.9zM5.703 8.4 5.7 19.2h9V8.4zM9.3 6.6h7.2v9h1.8V4.8h-9z" })
		})
	});
};
const ForwardRef$45 = forwardRef(SvgCopyIcon);
//#endregion
//#region src/generated/CorrectRoundIcon.tsx
const SvgCorrectRoundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 18 19",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: 17,
					height: 17,
					x: .5,
					y: 1,
					fill: "#00A854",
					rx: 2.5
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#fff",
					d: "m7.888 11.198-2.26-1.94L4 10.907 7.888 14.5 15 7.151 13.373 5.5z"
				}),
				/* @__PURE__ */ jsx("rect", {
					width: 17,
					height: 17,
					x: .5,
					y: 1,
					stroke: "#00A854",
					rx: 2.5
				})
			]
		})
	});
};
const ForwardRef$46 = forwardRef(SvgCorrectRoundIcon);
//#endregion
//#region src/generated/CreateSubQuestionIcon.tsx
const SvgCreateSubQuestionIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: 24,
					height: 24,
					fill: "#F5F5FA",
					rx: 3
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					stroke: "#3F5982",
					d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M8.5 13a.5.5 0 0 0 0-1zM6 19h-.5v.5H6zm2.5.5a.5.5 0 0 0 0-1zM5.5 7v5.5h1V7zm.5 6h2.5v-1H6zm-.5-.5V19h1v-6.5zm.5 7h2.5v-1H6z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					stroke: "#3F5982",
					d: "M11 12.5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1ZM11 19a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Z"
				})
			]
		})
	});
};
const ForwardRef$47 = forwardRef(SvgCreateSubQuestionIcon);
//#endregion
//#region src/generated/CrossIcon.tsx
const SvgCrossIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "m12 10.727 4.455-4.455 1.273 1.273L13.273 12l4.455 4.455-1.273 1.273L12 13.273l-4.455 4.455-1.273-1.273L10.727 12 6.272 7.545l1.273-1.273z"
			})
		})
	});
};
const ForwardRef$48 = forwardRef(SvgCrossIcon);
//#endregion
//#region src/generated/DisabledIcon.tsx
const SvgDisabledIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 18 18",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#B7C0D0",
				d: "M9 18a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9M4.5 8.1v1.8h9V8.1z"
			})
		})
	});
};
const ForwardRef$49 = forwardRef(SvgDisabledIcon);
//#endregion
//#region src/generated/DocumentPencilIcon.tsx
const SvgDocumentPencilIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M19 5.799 17.162 4l-.965.945 1.838 1.799zm-3.138-.527 1.838 1.8-5.514 5.396L10 13l.348-2.33zM14 6l-1.5 1.5h-6v11h9v-7.98l1.5-1.5V20H5V6zm-6 9.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75M8.75 9a.75.75 0 0 0 0 1.5h.75L11 9z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$50 = forwardRef(SvgDocumentPencilIcon);
//#endregion
//#region src/generated/DoubleQuotesIcon.tsx
const SvgDoubleQuotesIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M15.563 6.01c.773.82 1.187 1.74 1.187 3.232 0 2.625-1.842 4.977-4.522 6.14l-.67-1.033c2.501-1.353 2.99-3.108 3.185-4.216-.402.209-.93.282-1.446.234-1.353-.126-2.42-1.236-2.42-2.617a2.625 2.625 0 0 1 2.625-2.625c.805 0 1.574.367 2.061.884m-7.5 0c.773.82 1.187 1.74 1.187 3.232 0 2.625-1.842 4.977-4.522 6.14l-.67-1.033c2.501-1.353 2.99-3.108 3.185-4.216-.402.209-.93.282-1.446.234-1.353-.126-2.42-1.236-2.42-2.617a2.625 2.625 0 0 1 2.626-2.625c.805 0 1.574.367 2.06.884"
			})
		})
	});
};
const ForwardRef$51 = forwardRef(SvgDoubleQuotesIcon);
//#endregion
//#region src/generated/DownloadIcon.tsx
const SvgDownloadIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M18 18v-2h2v4H4v-4h2v2zm-5-5.653L17 10v1.729L12.119 15h-.238L7 11.729V10l4 2.353V4h2z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$52 = forwardRef(SvgDownloadIcon);
//#endregion
//#region src/generated/DropdownIcon.tsx
const SvgDropdownIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M12.9 10.2h4.5L12 15.6l-5.4-5.4h4.5V3.9h1.8zm-8.1 8.1h14.4V12H21v7.2a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V12h1.8z" })
		})
	});
};
const ForwardRef$53 = forwardRef(SvgDropdownIcon);
//#endregion
//#region src/generated/EditLineIcon.tsx
const SvgEditLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M6.973 15.6 16.1 6.472 14.828 5.2 5.7 14.327V15.6zm.746 1.8H3.9v-3.819L14.192 3.29a.9.9 0 0 1 1.272 0l2.546 2.546a.9.9 0 0 1 0 1.273zM3.9 19.2h16.2V21H3.9z"
			})
		})
	});
};
const ForwardRef$54 = forwardRef(SvgEditLineIcon);
//#endregion
//#region src/generated/EllipsisHorizontalIcon.tsx
const SvgEllipsisHorizontalIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M8 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$55 = forwardRef(SvgEllipsisHorizontalIcon);
//#endregion
//#region src/generated/ErrorIcon.tsx
const SvgErrorIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", {
					fill: "#DB0025",
					d: "M7.35 4.734a.75.75 0 0 1 1.3 0l4.7 8.143a.75.75 0 0 1-.65 1.125H3.3a.75.75 0 0 1-.65-1.125z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#fff",
					fillRule: "evenodd",
					d: "M8.457 11.438h-.918l-.101-4.5h1.125zm-1.02 1.13q0-.245.151-.406A.54.54 0 0 1 8 12q.26 0 .412.162.15.16.15.407 0 .237-.146.396-.147.16-.416.16-.27 0-.416-.16a.56.56 0 0 1-.146-.396",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ jsx("mask", {
					id: "ErrorIcon_svg__a",
					width: 2,
					height: 8,
					x: 7,
					y: 6,
					maskUnits: "userSpaceOnUse",
					style: { maskType: "luminance" },
					children: /* @__PURE__ */ jsx("path", {
						fill: "#fff",
						fillRule: "evenodd",
						d: "M8.457 11.438h-.918l-.101-4.5h1.125zm-1.02 1.13q0-.245.151-.406A.54.54 0 0 1 8 12q.26 0 .412.162.15.16.15.407 0 .237-.146.396-.147.16-.416.16-.27 0-.416-.16a.56.56 0 0 1-.146-.396",
						clipRule: "evenodd"
					})
				})
			]
		})
	});
};
const ForwardRef$56 = forwardRef(SvgErrorIcon);
//#endregion
//#region src/generated/ExclamationCircleIcon.tsx
const SvgExclamationCircleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10",
				clipRule: "evenodd"
			}), /* @__PURE__ */ jsx("g", {
				fill: "#fff",
				children: /* @__PURE__ */ jsx("path", { d: "M11.292 3.486v9.227H8.708V3.486zM11.292 16.513v-2.171H8.708v2.17z" })
			})]
		})
	});
};
const ForwardRef$57 = forwardRef(SvgExclamationCircleIcon);
//#endregion
//#region src/generated/ExclamationTriangleIcon.tsx
const SvgExclamationTriangleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m12.74 3.932 8.145 14.27a.87.87 0 0 1-.312 1.182.85.85 0 0 1-.428.116H3.855a.85.85 0 0 1-.74-.432.87.87 0 0 1 0-.865l8.144-14.27A.86.86 0 0 1 12 3.5a.85.85 0 0 1 .74.432m-1.595 11.244v1.73h1.71v-1.73zm0-6.054v4.324h1.71V9.122z"
			})
		})
	});
};
const ForwardRef$58 = forwardRef(SvgExclamationTriangleIcon);
//#endregion
//#region src/generated/ExitIcon.tsx
const SvgExitIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 18 18",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#DB0025",
				d: "M2.8 14.4h1.8v1.8h10.8V1.8H4.6v1.8H2.8V.9a.9.9 0 0 1 .9-.9h12.6a.9.9 0 0 1 .9.9v16.2a.9.9 0 0 1-.9.9H3.7a.9.9 0 0 1-.9-.9zm1.8-6.3h6.3v1.8H4.6v2.7L.1 9l4.5-3.6z"
			})
		})
	});
};
const ForwardRef$59 = forwardRef(SvgExitIcon);
//#endregion
//#region src/generated/ExportIcon.tsx
const SvgExportIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.8 18.3h14.4v-4.5H21v5.4a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9v-5.4h1.8zm7.2-8.1H9.3a5.4 5.4 0 0 0-4.369 2.226A7.2 7.2 0 0 1 12 6.6V3l7.2 5.4-7.2 5.4z"
			})
		})
	});
};
const ForwardRef$60 = forwardRef(SvgExportIcon);
//#endregion
//#region src/generated/EyeClosedIcon.tsx
const SvgEyeClosedIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.268 6.541 2.454 3.728l1.273-1.274 17.82 17.82-1.274 1.273-2.98-2.98A9.85 9.85 0 0 1 12 20.1c-4.853 0-8.89-3.492-9.737-8.1a9.9 9.9 0 0 1 3.006-5.459zm9.213 9.214-1.317-1.317a2.7 2.7 0 0 1-3.601-3.601L8.245 9.519a4.5 4.5 0 0 0 6.236 6.236M8.377 4.585A9.9 9.9 0 0 1 12 3.9c4.853 0 8.89 3.492 9.737 8.1a9.85 9.85 0 0 1-1.81 4.133l-3.475-3.474a4.5 4.5 0 0 0-5.112-5.112z"
			})
		})
	});
};
const ForwardRef$61 = forwardRef(SvgEyeClosedIcon);
//#endregion
//#region src/generated/EyeIcon.tsx
const SvgEyeIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M2.263 11.998c.846-4.608 4.884-8.1 9.737-8.1s8.89 3.492 9.737 8.1c-.846 4.608-4.884 8.1-9.737 8.1s-8.89-3.492-9.737-8.1m9.737 4.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-1.8A2.7 2.7 0 1 1 12 9.3a2.7 2.7 0 0 1 0 5.4"
			})
		})
	});
};
const ForwardRef$62 = forwardRef(SvgEyeIcon);
//#endregion
//#region src/generated/FileAttachmentIcon.tsx
const SvgFileAttachmentIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 52 69",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "#0F3063",
				d: "M51.868 59.984c-.069-1.016-.133-1.98-.069-2.85.453-6.296-.25-12.742-.931-18.978-.748-6.838-1.52-13.91-.737-20.704q.048-.415.11-.83c.172-1.218.353-2.477-.042-3.74-.3-.958-.64-2.045-1.372-3.03a34 34 0 0 1-1.328-1.96 37 37 0 0 0-1.39-2.05C44.643 3.873 42.635 1.175 39.66.33c-1.939-.547-3.866-.301-5.73-.063-1.453.185-2.828.362-4.192.188-5.8-.735-11.668-.318-17.34.085q-1.788.129-3.583.243c-1.75.108-3.43.295-4.777 1.342C2.56 3.277 1.973 5.17 1.627 6.692.705 10.735.584 14.9.466 18.924.42 20.641.34 22.354.261 24.071c-.156 3.39-.317 6.895-.242 10.359.057 2.638.036 5.304.017 7.88-.056 7.154-.113 14.552 1.523 21.762.298 1.317.718 2.799 1.917 3.733a5.16 5.16 0 0 0 3.051 1.065c4.045.081 7.961.114 11.737.114 8.76 0 16.746-.182 23.736-.38l.87-.016c2.41-.038 5.71-.091 7.4-1.582 1.951-1.723 1.763-4.54 1.598-7.023M44.852 6.777c.486.654.906 1.308 1.328 1.962.44.683.88 1.365 1.388 2.049.389.522.64 1.11.851 1.707l-7.32-.046c-.561-.003-1.141-.006-1.596-.211-.76-.342-1.26-1.28-1.532-2.866-.313-1.847-.226-3.83-.132-5.93.027-.611.044-1.224.062-1.837.446.04.89.108 1.327.234 2.282.646 3.896 2.618 5.624 4.938m4.38 59.053c-1.255 1.109-4.342 1.157-6.385 1.19l-.89.018c-9.986.283-22 .536-35.399.265a3.64 3.64 0 0 1-2.12-.734c-.791-.616-1.112-1.79-1.35-2.843-1.597-7.033-1.542-14.013-1.485-21.403.02-2.589.04-5.265-.016-7.927-.074-3.41.086-6.89.24-10.255.078-1.725.158-3.448.208-5.172.115-3.951.232-8.035 1.118-11.928.307-1.347.767-2.838 1.849-3.68.994-.775 2.417-.922 3.913-1.014 1.2-.076 2.397-.162 3.595-.245 3.37-.238 6.809-.484 10.246-.484 2.27 0 4.538.106 6.785.391 1.565.198 3.103.002 4.589-.188a32 32 0 0 1 2.204-.222c-.017.59-.033 1.183-.06 1.773-.092 2.09-.189 4.252.154 6.263.364 2.14 1.16 3.459 2.43 4.033.76.341 1.576.346 2.235.35l7.735.046h.005l.01-.001c.075.73-.037 1.516-.154 2.336-.041.292-.083.582-.116.87-.803 6.969-.02 14.13.736 21.056.675 6.167 1.37 12.542.925 18.696-.07.98 0 2.041.07 3.067.155 2.328.302 4.53-1.071 5.742"
			}), /* @__PURE__ */ jsx("path", {
				stroke: "#0F3063",
				strokeLinecap: "round",
				strokeWidth: 1.5,
				d: "M15 47.12c0 .403 0 1.705.274 3.348.1.605.82.52 1.289.534s.843.072 3.224.173c2.38.102 6.756.246 9.974.263 3.219.016 5.148-.1 6.228-.173 1.547-.105 1.952-.19 2.301-.306.088-.03.174-.058.248-.16.219-.653.22-2.156.118-3.9-.044-.65-.073-.822-.103-1M26.777 45.637a101 101 0 0 0-.202-5.19c-.145-2.196-.404-5.046-.523-6.572-.09-1.64-.06-2.508-.075-3.7-.014-.442-.043-.558-.073-.676M21.455 29.848c2.015-2.879 3.341-4.851 3.792-5.636.162-.295.191-.382 1.127.409s2.779 2.46 4.851 4.267"
			})]
		})
	});
};
const ForwardRef$63 = forwardRef(SvgFileAttachmentIcon);
//#endregion
//#region src/generated/FileImportIcon.tsx
const SvgFileImportIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 25",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("g", {
				clipPath: "url(#FileImportIcon_svg__a)",
				children: /* @__PURE__ */ jsx("path", {
					fill: "#0F172E",
					fillRule: "evenodd",
					d: "m10.09 9.083 3.41 3.41H0v1.412h13.5l-3.41 3.412.996.999 5.117-5.115-5.116-5.115zm13.29-3.15L19.265 1.82a2.13 2.13 0 0 0-1.497-.62H5.649v9.133h1.41V2.612h9.883v5.647h5.647v14.118H7.058v-6.353h-1.41v7.764H24V7.432a2.1 2.1 0 0 0-.62-1.498m-5.027-3.029 3.943 3.943h-3.943z",
					clipRule: "evenodd"
				})
			}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
				id: "FileImportIcon_svg__a",
				children: /* @__PURE__ */ jsx("path", {
					fill: "#fff",
					d: "M0 .5h24v24H0z"
				})
			}) })]
		})
	});
};
const ForwardRef$64 = forwardRef(SvgFileImportIcon);
//#endregion
//#region src/generated/FilePaperFill.tsx
const SvgFilePaperFill = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.4 14.7V3.9a.9.9 0 0 1 .9-.9h14.4a.9.9 0 0 1 .9.9v14.4a2.7 2.7 0 0 1-2.7 2.7H5.3a2.7 2.7 0 0 1-2.7-2.7v-1.8H17v1.8a.9.9 0 1 0 1.8 0v-3.6z"
			})
		})
	});
};
const ForwardRef$65 = forwardRef(SvgFilePaperFill);
//#endregion
//#region src/generated/FileUploadFillIcon.tsx
const SvgFileUploadFillIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 17 18",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m11.7 0 4.5 4.5v12.607a.893.893 0 0 1-.894.893H.894A.9.9 0 0 1 0 17.107V.893C0 .4.4 0 .894 0zM9 9h2.7L8.1 5.4 4.5 9h2.7v3.6H9z"
			})
		})
	});
};
const ForwardRef$66 = forwardRef(SvgFileUploadFillIcon);
//#endregion
//#region src/generated/FileUploadIcon.tsx
const SvgFileUploadIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				d: "M4.8 18.3h14.4V12H21v7.2a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V12h1.8zm8.1-9v6.3h-1.8V9.3H6.6L12 3.9l5.4 5.4z"
			})
		})
	});
};
const ForwardRef$67 = forwardRef(SvgFileUploadIcon);
//#endregion
//#region src/generated/FileZipIcon.tsx
const SvgFileZipIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 36 36",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsxs("g", {
				clipPath: "url(#FileZipIcon_svg__a)",
				children: [
					/* @__PURE__ */ jsxs("g", {
						filter: "url(#FileZipIcon_svg__b)",
						children: [/* @__PURE__ */ jsx("path", {
							fill: "#fff",
							d: "M26.4 36H9.6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h8.615a6 6 0 0 1 4.242 1.757l8.186 8.186a6 6 0 0 1 1.757 4.242V30a6 6 0 0 1-6 6"
						}), /* @__PURE__ */ jsx("path", {
							stroke: "#4E668B",
							strokeWidth: 1.5,
							d: "M26.4 35.25H9.6A5.25 5.25 0 0 1 4.35 30V6C4.35 3.1 6.7.75 9.6.75h8.615a5.25 5.25 0 0 1 3.712 1.538l8.185 8.185a5.25 5.25 0 0 1 1.538 3.712V30c0 2.9-2.35 5.25-5.25 5.25Z"
						})]
					}),
					/* @__PURE__ */ jsx("path", {
						stroke: "#4D658B",
						strokeWidth: 1.5,
						d: "M20.7.9v6.8a4 4 0 0 0 4 4h6.8"
					}),
					/* @__PURE__ */ jsxs("g", {
						filter: "url(#FileZipIcon_svg__c)",
						children: [
							/* @__PURE__ */ jsx("mask", {
								id: "FileZipIcon_svg__d",
								fill: "#fff",
								children: /* @__PURE__ */ jsx("path", { d: "M0 18a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" })
							}),
							/* @__PURE__ */ jsx("path", {
								fill: "#3F5982",
								d: "M0 18a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
							}),
							/* @__PURE__ */ jsx("path", {
								fill: "#000",
								fillOpacity: .08,
								d: "M-1 18a5 5 0 0 1 5-5h16a5 5 0 0 1 5 5h-2a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3zm25 12H0zM4 30a5 5 0 0 1-5-5v-7a5 5 0 0 1 5-5v2a3 3 0 0 0-3 3v8c0 2.21 1.343 4 3 4m16-17a5 5 0 0 1 5 5v7a5 5 0 0 1-5 5c1.657 0 3-1.79 3-4v-8a3 3 0 0 0-3-3z",
								mask: "url(#FileZipIcon_svg__d)"
							}),
							/* @__PURE__ */ jsx("path", {
								fill: "#fff",
								d: "M3.64 26v-.902l4.102-5.883H3.617V18H9.54v.902l-4.098 5.883h4.122V26zm8.994-8v8h-1.45v-8zm1.79 8v-8h3q.922 0 1.546.344.63.343.95.945.324.598.324 1.36 0 .768-.325 1.367a2.3 2.3 0 0 1-.957.941q-.631.34-1.558.34h-1.988v-1.192h1.793q.538 0 .882-.187.345-.187.508-.516.168-.327.168-.754 0-.424-.168-.75a1.14 1.14 0 0 0-.512-.503q-.343-.184-.886-.184h-1.328V26z"
							})
						]
					})
				]
			}), /* @__PURE__ */ jsxs("defs", { children: [
				/* @__PURE__ */ jsxs("filter", {
					id: "FileZipIcon_svg__b",
					width: 32.8,
					height: 43,
					x: 1.6,
					y: -4,
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					children: [
						/* @__PURE__ */ jsx("feFlood", {
							floodOpacity: 0,
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ jsx("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ jsx("feOffset", { dy: 1 }),
						/* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 1 }),
						/* @__PURE__ */ jsx("feComposite", {
							in2: "hardAlpha",
							operator: "out"
						}),
						/* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0" }),
						/* @__PURE__ */ jsx("feBlend", {
							in2: "BackgroundImageFix",
							result: "effect1_dropShadow_352_48666"
						}),
						/* @__PURE__ */ jsx("feBlend", {
							in: "SourceGraphic",
							in2: "effect1_dropShadow_352_48666",
							result: "shape"
						}),
						/* @__PURE__ */ jsx("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ jsx("feOffset", { dy: -4 }),
						/* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
						/* @__PURE__ */ jsx("feComposite", {
							in2: "hardAlpha",
							k2: -1,
							k3: 1,
							operator: "arithmetic"
						}),
						/* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0" }),
						/* @__PURE__ */ jsx("feBlend", {
							in2: "shape",
							result: "effect2_innerShadow_352_48666"
						})
					]
				}),
				/* @__PURE__ */ jsxs("filter", {
					id: "FileZipIcon_svg__c",
					width: 24,
					height: 20,
					x: 0,
					y: 14,
					colorInterpolationFilters: "sRGB",
					filterUnits: "userSpaceOnUse",
					children: [
						/* @__PURE__ */ jsx("feFlood", {
							floodOpacity: 0,
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ jsx("feBlend", {
							in: "SourceGraphic",
							in2: "BackgroundImageFix",
							result: "shape"
						}),
						/* @__PURE__ */ jsx("feColorMatrix", {
							in: "SourceAlpha",
							result: "hardAlpha",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						}),
						/* @__PURE__ */ jsx("feOffset", { dy: 4 }),
						/* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 2 }),
						/* @__PURE__ */ jsx("feComposite", {
							in2: "hardAlpha",
							k2: -1,
							k3: 1,
							operator: "arithmetic"
						}),
						/* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0" }),
						/* @__PURE__ */ jsx("feBlend", {
							in2: "shape",
							result: "effect1_innerShadow_352_48666"
						})
					]
				}),
				/* @__PURE__ */ jsx("clipPath", {
					id: "FileZipIcon_svg__a",
					children: /* @__PURE__ */ jsx("path", {
						fill: "#fff",
						d: "M0 0h36v36H0z"
					})
				})
			] })]
		})
	});
};
const ForwardRef$68 = forwardRef(SvgFileZipIcon);
//#endregion
//#region src/generated/FillInBlanksIcon.tsx
const SvgFillInBlanksIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 24,
				height: 24,
				fill: "#FCF6FC",
				rx: 3
			}), /* @__PURE__ */ jsx("path", {
				fill: "#C0A",
				d: "M19.102 13.5H17.63v-2.367h1.472zM15.977 14.027H5v-2h10.977z"
			})]
		})
	});
};
const ForwardRef$69 = forwardRef(SvgFillInBlanksIcon);
//#endregion
//#region src/generated/FilterIcon.tsx
const SvgFilterIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 12 12",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				fillRule: "evenodd",
				d: "M4.5 5 0 .5h12L7.5 5v6.5l-3-2z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$70 = forwardRef(SvgFilterIcon);
//#endregion
//#region src/generated/FlipIcon.tsx
const SvgFlipIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15.645 12.045 20.1 16.5l-4.455 4.455-1.273-1.273 2.283-2.283L4.8 17.4v-1.8h11.855l-2.283-2.282zm-7.29-9 1.273 1.273L7.345 6.6H19.2v1.8H7.345l2.283 2.282-1.273 1.273L3.9 7.5z"
			})
		})
	});
};
const ForwardRef$71 = forwardRef(SvgFlipIcon);
//#endregion
//#region src/generated/FolderArrowLeftFillIcon.tsx
const SvgFolderArrowLeftFillIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M21 13.013a5.4 5.4 0 0 0-7.827 7.087H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h6.673l1.8 1.8H20.1a.9.9 0 0 1 .9.9zM19.2 16.5h2.7v1.8h-2.7v3.15l-4.5-4.05 4.5-4.05z"
			})
		})
	});
};
const ForwardRef$72 = forwardRef(SvgFolderArrowLeftFillIcon);
//#endregion
//#region src/generated/FolderOpenIcon.tsx
const SvgFolderOpenIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 15 12",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				stroke: "currentColor",
				strokeWidth: .4,
				d: "M13.95 4.324c-.289-.353-.741-.59-1.318-.59h-.905c0-1.1-.906-1.963-2.059-1.963H6.787c-.412 0-.577-.236-.906-.629C5.551.71 5.14.2 4.317.2H2.258C1.106.2.2 1.063.2 2.164v7.07c0 .512.206 1.022.617 1.376.247.393.741.59 1.318.59h8.233c1.03 0 2.017-.669 2.305-1.494l1.441-4.242a1.12 1.12 0 0 0-.164-1.14ZM2.258.984h2.059c.411 0 .576.237.905.63.33.432.741.942 1.565.942h2.881c.7 0 1.235.511 1.235 1.179H4.4c-1.03 0-2.017.668-2.305 1.493L1.024 8.33V2.164c0-.668.534-1.18 1.234-1.18Zm11.074 4.244-1.44 4.243c-.165.51-.865.943-1.524.943H2.135q-.432-.001-.618-.236l-.04-.04a.55.55 0 0 1-.042-.432l1.44-4.242c.165-.511.865-.943 1.524-.943h8.233c.288 0 .535.078.659.235.123.157.082.354.041.472Z"
			})
		})
	});
};
const ForwardRef$73 = forwardRef(SvgFolderOpenIcon);
//#endregion
//#region src/generated/FootnoteIcon.tsx
const SvgFootnoteIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M9.822 4.19h9.645a.32.32 0 0 1 .22.086c.058.055.09.13.09.208v11.348c0 .078.034.153.092.208a.32.32 0 0 0 .22.086.32.32 0 0 0 .22-.086.29.29 0 0 0 .091-.208V4.484a.86.86 0 0 0-.274-.625.96.96 0 0 0-.66-.259H9.823a.32.32 0 0 0-.22.086.29.29 0 0 0-.09.209c0 .078.032.153.09.208a.32.32 0 0 0 .22.086m4.356 15.62H4.533a.32.32 0 0 1-.22-.086.29.29 0 0 1-.09-.208V8.168a.29.29 0 0 0-.092-.208.32.32 0 0 0-.22-.086.32.32 0 0 0-.22.086.29.29 0 0 0-.091.208v11.348c0 .234.099.459.274.625a.96.96 0 0 0 .66.259h9.644a.32.32 0 0 0 .22-.086.29.29 0 0 0 .09-.209.29.29 0 0 0-.09-.208.32.32 0 0 0-.22-.086"
			}), /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.692 8.4H6.308c-.17 0-.308.147-.308.327v6.546c0 .18.138.327.308.327h11.384c.17 0 .308-.147.308-.327V8.727c0-.18-.138-.327-.308-.327M15.809 16.8h-.004a.315.315 0 0 0-.137.573c.742.499.79 1.076.658 1.524H15.3a.3.3 0 0 0-.3.3V21.3a.3.3 0 0 0 .3.3h2.4a.3.3 0 0 0 .3-.3v-2.673a1.7 1.7 0 0 0-.346-1.049c-.271-.348-.811-.765-1.845-.778m5.445.778c-.271-.348-.811-.765-1.845-.778a.314.314 0 0 0-.141.573c.742.499.79 1.076.658 1.524H18.9a.3.3 0 0 0-.3.3V21.3a.3.3 0 0 0 .3.3h2.4a.3.3 0 0 0 .3-.3v-2.673a1.7 1.7 0 0 0-.346-1.049M8.19 7.2h.004a.315.315 0 0 0 .137-.573c-.743-.499-.79-1.076-.658-1.524H8.7a.3.3 0 0 0 .3-.3V2.7a.3.3 0 0 0-.3-.3H6.3a.3.3 0 0 0-.3.3v2.673c-.005.378.116.748.346 1.049.271.348.811.765 1.845.778m-3.596 0a.3.3 0 0 0 .172-.546l-.035-.027c-.742-.499-.79-1.076-.658-1.524H5.1a.3.3 0 0 0 .3-.3V2.7a.3.3 0 0 0-.3-.3H2.7a.3.3 0 0 0-.3.3v2.673c-.005.378.117.748.346 1.049.271.348.811.765 1.845.778z"
			})]
		})
	});
};
const ForwardRef$74 = forwardRef(SvgFootnoteIcon);
//#endregion
//#region src/generated/ForbidIcon.tsx
const SvgForbidIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-1.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m4.402-10.33L8.87 16.403a5.4 5.4 0 0 1-1.273-1.273L15.13 7.6c.492.35.922.78 1.273 1.272" })
		})
	});
};
const ForwardRef$75 = forwardRef(SvgForbidIcon);
//#endregion
//#region src/generated/FundBoxLineIcon.tsx
const SvgFundBoxLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.8 5.7v12.6h14.4V5.7zm-.9-1.8h16.2a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9m10.614 6.114L12.9 8.4h4.5v4.5l-1.614-1.614-3.477 3.478-1.91-1.909L7.855 15.4 6.58 14.128l3.819-3.82 1.909 1.91z"
			})
		})
	});
};
const ForwardRef$76 = forwardRef(SvgFundBoxLineIcon);
//#endregion
//#region src/generated/GlobeIcon.tsx
const SvgGlobeIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 20,
				height: 20,
				fill: "#fff",
				rx: 10
			}), /* @__PURE__ */ jsx("path", {
				fill: "#0F3063",
				d: "M10 16a6 6 0 1 1 0-12 6 6 0 0 1 0 12m-1.374-1.4a10.7 10.7 0 0 1-1.01-4H5.237a4.8 4.8 0 0 0 3.389 4m.192-4A9.55 9.55 0 0 0 10 14.651a9.54 9.54 0 0 0 1.182-4.051zm5.945 0h-2.38a10.7 10.7 0 0 1-1.009 4 4.8 4.8 0 0 0 3.389-4M5.237 9.4h2.38a10.7 10.7 0 0 1 1.009-4 4.8 4.8 0 0 0-3.389 4m3.582 0h2.362A9.54 9.54 0 0 0 10 5.349 9.54 9.54 0 0 0 8.818 9.4m2.555-4a10.7 10.7 0 0 1 1.01 4h2.379a4.81 4.81 0 0 0-3.389-4"
			})]
		})
	});
};
const ForwardRef$77 = forwardRef(SvgGlobeIcon);
//#endregion
//#region src/generated/GridIcon.tsx
const SvgGridIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M0 17.455h6.545V24H0zM0 8.727h6.545v6.545H0zM0 0h6.545v6.545H0z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#B7C0D0",
					d: "M8.728 0h6.545v6.545H8.728zM17.454 8.727h6.545v6.545h-6.545zM17.454 0h6.545v6.545h-6.545z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M8.728 8.727h6.545v6.545H8.728zM8.728 17.455h6.545V24H8.728zM17.454 17.455h6.545V24h-6.545z"
				})
			]
		})
	});
};
const ForwardRef$78 = forwardRef(SvgGridIcon);
//#endregion
//#region src/generated/GridMinusIcon.tsx
const SvgGridMinusIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", {
					fill: "currentColor",
					d: "M2 16.118h5.882V22H2zM2 9.059h5.882v5.882H2zM2 2h5.882v5.882H2zM9.059 2h5.882v5.882H9.059zM16.118 2H22v5.882h-5.882z"
				}),
				/* @__PURE__ */ jsx("path", {
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeWidth: 1.5,
					d: "M12.5 15.5h6"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 15.5,
					cy: 15.5,
					r: 5,
					stroke: "currentColor",
					strokeWidth: 1.5
				})
			]
		})
	});
};
const ForwardRef$79 = forwardRef(SvgGridMinusIcon);
//#endregion
//#region src/generated/GridPlusIcon.tsx
const SvgGridPlusIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", {
					fill: "currentColor",
					d: "M2 16.118h5.882V22H2zM2 9.059h5.882v5.882H2zM2 2h5.882v5.882H2zM9.059 2h5.882v5.882H9.059zM16.118 2H22v5.882h-5.882z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "currentColor",
					stroke: "currentColor",
					strokeWidth: .6,
					d: "M15 12.5V15h-2.5v1H15v2.5h1V16h2.5v-1H16v-2.5z"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 15.5,
					cy: 15.5,
					r: 5,
					stroke: "currentColor",
					strokeWidth: 1.5
				})
			]
		})
	});
};
const ForwardRef$80 = forwardRef(SvgGridPlusIcon);
//#endregion
//#region src/generated/GridWithPencilIcon.tsx
const SvgGridWithPencilIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M0 14.117h5.882v5.882H0zM0 7.059h5.882v5.882H0zM0 0h5.882v5.882H0zM7.059 0h5.882v5.882H7.059zM14.117 0h5.882v5.882h-5.882zM14.198 11.01l2.227 2.228-5.198 5.197H9v-2.228zm.742-.742 1.113-1.114a.525.525 0 0 1 .743 0l1.485 1.485a.525.525 0 0 1 0 .742l-1.114 1.114z"
			})
		})
	});
};
const ForwardRef$81 = forwardRef(SvgGridWithPencilIcon);
//#endregion
//#region src/generated/HashtagIcon.tsx
const SvgHashtagIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m6 20 1-4H3l.5-2h4l1-4h-4L5 8h4l1-4h2l-1 4h4l1-4h2l-1 4h4l-.5 2h-4l-1 4h4l-.5 2h-4l-1 4h-2l1-4H9l-1 4zm3.5-6h4l1-4h-4z"
			})
		})
	});
};
const ForwardRef$82 = forwardRef(SvgHashtagIcon);
//#endregion
//#region src/generated/HistoryIcon.tsx
const SvgHistoryIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2,
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", { d: "M3 3v5h5" }),
				/* @__PURE__ */ jsx("path", { d: "M3.05 13A9 9 0 1 0 6 5.3L3 8" }),
				/* @__PURE__ */ jsx("path", { d: "M12 7v5l3 2" })
			]
		})
	});
};
const ForwardRef$83 = forwardRef(SvgHistoryIcon);
//#endregion
//#region src/generated/HomeIcon.tsx
const SvgHomeIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "m12 8 5.714 4.572v6.857h-4v-4a1.714 1.714 0 0 0-3.42-.165l-.008.165v4h-4v-6.857zm4.571-3.428v3.755L20 11.144c0 .7-.505 1.284-1.171 1.405L12 6.858l-6.828 5.691a1.43 1.43 0 0 1-1.165-1.26L4 11.145l8-6.572 2.857 2.347V4.572z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$84 = forwardRef(SvgHomeIcon);
//#endregion
//#region src/generated/HotspotIcon.tsx
const SvgHotspotIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 24,
				height: 24,
				fill: "#E7F5F4",
				rx: 3
			}), /* @__PURE__ */ jsx("path", {
				fill: "#18CBB8",
				d: "M10.731 13.269v3.641H8.966l3.09 3.09 2.868-3.09H13.27V13.27h3.641v1.655L20 12.055l-3.09-3.09v1.766H13.27V7.09h1.655L11.944 4 8.967 7.09h1.765v3.641H7.09V8.966L4 12.056l3.09 2.868V13.27zm.993-.993h.552v-.552h-.552z"
			})]
		})
	});
};
const ForwardRef$85 = forwardRef(SvgHotspotIcon);
//#endregion
//#region src/generated/HotspotPin.tsx
const SvgHotspotPin = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M10.898.1v2.756A7.204 7.204 0 0 1 17.143 9.1h2.756v1.8l-2.756.001a7.204 7.204 0 0 1-6.243 6.243l-.001 2.756h-1.8v-2.756a7.204 7.204 0 0 1-6.245-6.243H.098V9.1h2.755a7.204 7.204 0 0 1 6.245-6.245V.1zm-.9 4.5a5.4 5.4 0 1 0 0 10.8 5.4 5.4 0 0 0 0-10.8m0 3.6a1.8 1.8 0 1 1 0 3.6 1.8 1.8 0 0 1 0-3.6" })
		})
	});
};
const ForwardRef$86 = forwardRef(SvgHotspotPin);
//#endregion
//#region src/generated/HotspotPositionObjectIcon.tsx
const SvgHotspotPositionObjectIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", { d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18m0-1.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4" }),
				/* @__PURE__ */ jsx("circle", {
					cx: 12,
					cy: 4,
					r: 2.5,
					stroke: "#fff"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 20.094,
					cy: 12.145,
					r: 2.5,
					stroke: "#fff",
					transform: "rotate(85.686 20.094 12.145)"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 12,
					cy: 20,
					r: 2.5,
					stroke: "#fff"
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 4.14,
					cy: 12.145,
					r: 2.5,
					stroke: "#fff",
					transform: "rotate(85.686 4.14 12.145)"
				})
			]
		})
	});
};
const ForwardRef$87 = forwardRef(SvgHotspotPositionObjectIcon);
//#endregion
//#region src/generated/InfoIcon.tsx
const SvgInfoIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m-.9-9.9v5.4h1.8v-5.4zm0-3.6v1.8h1.8V7.5z"
			})
		})
	});
};
const ForwardRef$89 = forwardRef(SvgInfoIcon);
//#endregion
//#region src/generated/InfoUnfilledIcon.tsx
const SvgInfoUnfilledIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M10 17.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m0-1.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12m-.75-9.75h1.5v1.5h-1.5zm0 3h1.5v4.5h-1.5z"
			})
		})
	});
};
const ForwardRef$90 = forwardRef(SvgInfoUnfilledIcon);
//#endregion
//#region src/generated/InformationFilledIcon.tsx
const SvgInformationFilledIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12m-.6-6.6V11h1.2V7.4zm0-2.4v1.2h1.2V5z"
			})
		})
	});
};
const ForwardRef$91 = forwardRef(SvgInformationFilledIcon);
//#endregion
//#region src/generated/InformationLineIcon.tsx
const SvgInformationLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-1.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m-.9-11.7h1.8v1.8h-1.8zm0 3.6h1.8v5.4h-1.8z"
			})
		})
	});
};
const ForwardRef$92 = forwardRef(SvgInformationLineIcon);
//#endregion
//#region src/generated/InsertCommentIcon.tsx
const SvgInsertCommentIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M14.3 3.9v1.8h-9v12.047L6.887 16.5H19.7v-6.3h1.8v7.2a.9.9 0 0 1-.9.9H7.51L3.5 21.45V4.8a.9.9 0 0 1 .9-.9zm4.5 0V1.2h1.8v2.7h2.7v1.8h-2.7v2.7h-1.8V5.7h-2.7V3.9z"
			})
		})
	});
};
const ForwardRef$93 = forwardRef(SvgInsertCommentIcon);
//#endregion
//#region src/generated/InsertFootnoteIcon.tsx
const SvgInsertFootnoteIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 18 19",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsxs("g", {
				fill: "#3F5982",
				clipPath: "url(#InsertFootnoteIcon_svg__a)",
				children: [/* @__PURE__ */ jsx("path", { d: "M7.031 2.047h8.719a.28.28 0 0 1 .281.281v10.828a.281.281 0 0 0 .563 0V2.328a.845.845 0 0 0-.844-.844H7.031a.281.281 0 1 0 0 .563m3.938 14.906H2.25a.28.28 0 0 1-.281-.281V5.844a.281.281 0 1 0-.563 0v10.828a.845.845 0 0 0 .844.844h8.719a.281.281 0 1 0 0-.563" }), /* @__PURE__ */ jsx("path", { d: "M14.203 6.406H3.797a.28.28 0 0 0-.281.282v5.625c0 .155.126.28.28.28h10.407a.28.28 0 0 0 .281-.28V6.687a.28.28 0 0 0-.28-.28M12.571 14h-.004a.295.295 0 0 0-.128.537c.696.468.741 1.01.617 1.428h-.962a.28.28 0 0 0-.281.282v1.972a.28.28 0 0 0 .28.281h2.25a.28.28 0 0 0 .282-.281v-2.506a1.58 1.58 0 0 0-.324-.984c-.254-.325-.76-.717-1.73-.729m5.105.73c-.254-.327-.76-.718-1.73-.73a.295.295 0 0 0-.132.537c.696.468.741 1.01.617 1.428h-.962a.28.28 0 0 0-.281.282v1.972a.28.28 0 0 0 .28.281h2.25a.28.28 0 0 0 .282-.281v-2.506a1.58 1.58 0 0 0-.324-.984M5.429 5h.004a.295.295 0 0 0 .128-.537c-.696-.468-.74-1.01-.617-1.429h.962a.28.28 0 0 0 .282-.28V.78A.28.28 0 0 0 5.906.5h-2.25a.28.28 0 0 0-.28.281v2.506c-.006.355.108.701.324.984.254.325.76.717 1.73.729M2.058 5a.281.281 0 0 0 .16-.512l-.032-.025c-.696-.468-.74-1.01-.617-1.429h.962a.28.28 0 0 0 .282-.28V.78A.28.28 0 0 0 2.53.5H.281a.28.28 0 0 0-.28.281v2.506c-.006.355.108.701.324.984.254.325.76.717 1.73.729z" })]
			}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
				id: "InsertFootnoteIcon_svg__a",
				children: /* @__PURE__ */ jsx("path", {
					fill: "#fff",
					d: "M0 .5h18v18H0z"
				})
			}) })]
		})
	});
};
const ForwardRef$94 = forwardRef(SvgInsertFootnoteIcon);
//#endregion
//#region src/generated/LinkIcon.tsx
const SvgLinkIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "m18.228 15.182-1.273-1.274 1.273-1.273a4.5 4.5 0 1 0-6.364-6.364L10.59 7.545 9.318 6.272 10.592 5a6.3 6.3 0 1 1 8.91 8.91zm-2.546 2.545L14.41 19a6.3 6.3 0 1 1-8.91-8.91l1.273-1.272 1.273 1.274-1.273 1.272a4.5 4.5 0 1 0 6.364 6.364l1.273-1.272 1.273 1.272m-.637-9.546 1.274 1.274-6.364 6.363-1.274-1.273 6.364-6.363" })
		})
	});
};
const ForwardRef$95 = forwardRef(SvgLinkIcon);
//#endregion
//#region src/generated/ListIcon.tsx
const SvgListIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", {
					fill: "#B7C0D0",
					d: "M0 0h24v4H0z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M0 6h24v12H0z"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#B7C0D0",
					d: "M0 20h24v4H0z"
				})
			]
		})
	});
};
const ForwardRef$96 = forwardRef(SvgListIcon);
//#endregion
//#region src/generated/ListSingleSelectIcon.tsx
const SvgListSingleSelectIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3B404F",
				d: "M9.375 8.25a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m1.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0M18.75 6h-6v1.5h6zm0 5.25h-6v1.5h6zm0 5.25h-6V18h6zm-10.875.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-9.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
			})
		})
	});
};
const ForwardRef$97 = forwardRef(SvgListSingleSelectIcon);
//#endregion
//#region src/generated/LoaderIcon.tsx
const SvgLoaderIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12.5 3a.9.9 0 0 1 .9.9v2.7a.9.9 0 1 1-1.8 0V3.9a.9.9 0 0 1 .9-.9m0 13.5a.9.9 0 0 1 .9.9v2.7a.9.9 0 1 1-1.8 0v-2.7a.9.9 0 0 1 .9-.9m9-4.5a.9.9 0 0 1-.9.9h-2.7a.9.9 0 1 1 0-1.8h2.7a.9.9 0 0 1 .9.9M8 12a.9.9 0 0 1-.9.9H4.4a.9.9 0 1 1 0-1.8h2.7a.9.9 0 0 1 .9.9m10.864 6.364a.9.9 0 0 1-1.273 0l-1.909-1.909a.9.9 0 0 1 1.273-1.273l1.909 1.908a.9.9 0 0 1 0 1.274M9.318 8.818a.9.9 0 0 1-1.273 0L6.137 6.91A.9.9 0 1 1 7.41 5.636l1.908 1.909a.9.9 0 0 1 0 1.273m-3.181 9.546a.9.9 0 0 1 0-1.273l1.909-1.909a.9.9 0 1 1 1.273 1.273L7.41 18.364a.9.9 0 0 1-1.273 0m9.545-9.546a.9.9 0 0 1 0-1.273l1.908-1.909a.9.9 0 0 1 1.274 1.273l-1.909 1.909a.9.9 0 0 1-1.273 0"
			})
		})
	});
};
const ForwardRef$98 = forwardRef(SvgLoaderIcon);
//#endregion
//#region src/generated/LockClosedIcon.tsx
const SvgLockClosedIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "M9.237 7.528v2.47h5.527v-2.47zm-1.843.001C7.394 5.028 9.456 3 12 3s4.606 2.028 4.606 4.53V10H19v11.2H5V10h2.394zM12 17.7a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2m2.764-10.17c0-1.5-1.238-2.717-2.764-2.717S9.237 6.03 9.237 7.53z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$99 = forwardRef(SvgLockClosedIcon);
//#endregion
//#region src/generated/LockOpenIcon.tsx
const SvgLockOpenIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M12 3c2.544 0 4.606 2.028 4.606 4.53v1h-1.84V7.246h-.002c0-1.5-1.237-2.718-2.764-2.718S9.237 5.746 9.237 7.247V10.5H19v11.2H5V10.5h2.394V7.53C7.394 5.027 9.456 3 12 3m0 11a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2" })
		})
	});
};
const ForwardRef$100 = forwardRef(SvgLockOpenIcon);
//#endregion
//#region src/generated/LongAnswerIcon.tsx
const SvgLongAnswerIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 24,
				height: 24,
				fill: "#FDF6F6",
				rx: 3
			}), /* @__PURE__ */ jsx("path", {
				stroke: "#FF4D6A",
				strokeWidth: 2,
				d: "M4 7.132h9M4 12h2.571M4 17.05h5.571M8.715 12H20M11.715 17.05H20M14.14 7.132h5.858"
			})]
		})
	});
};
const ForwardRef$101 = forwardRef(SvgLongAnswerIcon);
//#endregion
//#region src/generated/MagnifyingGlassIcon.tsx
const SvgMagnifyingGlassIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m17.127 15.513 3.373 3.373L19.386 20l-3.373-3.373a7.06 7.06 0 0 1-4.424 1.55A7.09 7.09 0 0 1 4.5 11.09 7.09 7.09 0 0 1 11.589 4a7.09 7.09 0 0 1 7.088 7.089 7.06 7.06 0 0 1-1.55 4.424m-1.58-.585a5.5 5.5 0 0 0 1.555-3.84 5.51 5.51 0 0 0-5.513-5.513 5.51 5.51 0 0 0-5.514 5.514 5.51 5.51 0 0 0 5.514 5.513 5.5 5.5 0 0 0 3.84-1.555z"
			})
		})
	});
};
const ForwardRef$102 = forwardRef(SvgMagnifyingGlassIcon);
//#endregion
//#region src/generated/MailIcon.tsx
const SvgMailIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M3.9 4.5h16.2a.9.9 0 0 1 .9.9v13.2a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V5.4a.9.9 0 0 1 .9-.9m15.3 3.814-7.135 6.39L4.8 8.294V17.7h14.4zM5.26 6.3l6.795 5.996L18.752 6.3z" })
		})
	});
};
const ForwardRef$103 = forwardRef(SvgMailIcon);
//#endregion
//#region src/generated/MapPinAddLineIcon.tsx
const SvgMapPinAddLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m12 20.01 4.455-4.455a6.3 6.3 0 1 0-8.91 0zm0 2.545-5.727-5.727a8.1 8.1 0 1 1 11.455 0zM11.1 10.2V7.5h1.8v2.7h2.7V12h-2.7v2.7h-1.8V12H8.4v-1.8z"
			})
		})
	});
};
const ForwardRef$104 = forwardRef(SvgMapPinAddLineIcon);
//#endregion
//#region src/generated/MatchingIcon.tsx
const SvgMatchingIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: 24,
					height: 24,
					fill: "#FEF3EB",
					rx: 3
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#F2AE40",
					d: "M9 18h6zm0-5.5h6zM9 7h6z"
				}),
				/* @__PURE__ */ jsx("path", {
					stroke: "#F2AE40",
					strokeMiterlimit: 10,
					strokeWidth: 1.5,
					d: "M9 18h6m-6-5.5h6M9 7h6"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#F2AE40",
					stroke: "#F2AE40",
					strokeMiterlimit: 10,
					strokeWidth: 1.5,
					d: "M16.879 17.667a1.06 1.06 0 1 1 2.121 0 1.06 1.06 0 0 1-2.121 0Zm0-5.303a1.06 1.06 0 1 1 2.12 0 1.06 1.06 0 0 1-2.12 0Zm0-5.303a1.06 1.06 0 1 1 2.121 0 1.06 1.06 0 0 1-2.121 0ZM5 7.06a1.06 1.06 0 1 1 2.121 0A1.06 1.06 0 0 1 5 7.06Zm0 5.303a1.06 1.06 0 1 1 2.12 0 1.06 1.06 0 0 1-2.12 0Zm0 5.303a1.06 1.06 0 1 1 2.121 0 1.06 1.06 0 0 1-2.121 0Z"
				})
			]
		})
	});
};
const ForwardRef$105 = forwardRef(SvgMatchingIcon);
//#endregion
//#region src/generated/MicFilledIcon.tsx
const SvgMicFilledIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 17 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.05 0a4.5 4.5 0 0 1 4.5 4.5v3.6a4.5 4.5 0 1 1-9 0V4.5A4.5 4.5 0 0 1 8.05 0M0 9h1.814a6.302 6.302 0 0 0 12.472 0H16.1a8.1 8.1 0 0 1-7.15 7.15v3.65h-1.8v-3.65A8.104 8.104 0 0 1 0 9"
			})
		})
	});
};
const ForwardRef$106 = forwardRef(SvgMicFilledIcon);
//#endregion
//#region src/generated/MicIcon.tsx
const SvgMicIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 17 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M8.05 1.8a2.7 2.7 0 0 0-2.7 2.7v3.6a2.7 2.7 0 0 0 5.4 0V4.5a2.7 2.7 0 0 0-2.7-2.7m0-1.8a4.5 4.5 0 0 1 4.5 4.5v3.6a4.5 4.5 0 1 1-9 0V4.5A4.5 4.5 0 0 1 8.05 0M0 9h1.814a6.302 6.302 0 0 0 12.472 0H16.1a8.1 8.1 0 0 1-7.15 7.15v3.65h-1.8v-3.65A8.104 8.104 0 0 1 0 9"
			})
		})
	});
};
const ForwardRef$107 = forwardRef(SvgMicIcon);
//#endregion
//#region src/generated/MinusRoundIcon.tsx
const SvgMinusRoundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 16,
				height: 16,
				fill: "#F17B2C",
				rx: 8
			}), /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				fillRule: "evenodd",
				d: "M3 8a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
				clipRule: "evenodd"
			})]
		})
	});
};
const ForwardRef$108 = forwardRef(SvgMinusRoundIcon);
//#endregion
//#region src/generated/MultipleChoiceIcon.tsx
const SvgMultipleChoiceIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: 24,
					height: 24,
					fill: "#E7F5F4",
					rx: 3
				}),
				/* @__PURE__ */ jsx("rect", {
					width: 16,
					height: 16,
					x: 4,
					y: 4,
					stroke: "#18CBB8",
					rx: 8
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 12,
					cy: 12,
					r: 4.5,
					fill: "#18CBB8"
				})
			]
		})
	});
};
const ForwardRef$109 = forwardRef(SvgMultipleChoiceIcon);
//#endregion
//#region src/generated/NumericalAnswerIcon.tsx
const SvgNumericalAnswerIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 24,
				height: 24,
				fill: "#EBEDFF",
				rx: 3
			}), /* @__PURE__ */ jsx("path", {
				fill: "#6355F6",
				d: "m9.156 13.35.283-2.7H6.602V9.3h2.98l.354-3.375h1.358L10.939 9.3h2.693l.354-3.375h1.358L14.989 9.3h2.413v1.35h-2.555l-.283 2.7h2.838v1.35h-2.98l-.355 3.375H12.71l.354-3.375h-2.693l-.354 3.375H8.66l.354-3.375H6.602v-1.35zm1.357 0h2.693l.284-2.7h-2.693z"
			})]
		})
	});
};
const ForwardRef$110 = forwardRef(SvgNumericalAnswerIcon);
//#endregion
//#region src/generated/PaperAirplaneIcon.tsx
const SvgPaperAirplaneIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				fillRule: "evenodd",
				d: "M6.911 12.667 19 12l-12.089-.667v-.021L5 6l14 6-14 6 1.911-5.323z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$111 = forwardRef(SvgPaperAirplaneIcon);
//#endregion
//#region src/generated/PauseIcon.tsx
const SvgPauseIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M6.6 5.7h1.8v12.6H6.6zm9 0h1.8v12.6h-1.8z"
			})
		})
	});
};
const ForwardRef$112 = forwardRef(SvgPauseIcon);
//#endregion
//#region src/generated/PencilIcon.tsx
const SvgPencilIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M7.719 17.401H3.9v-3.819L14.192 3.291a.9.9 0 0 1 1.272 0l2.546 2.546a.9.9 0 0 1 0 1.273zm-3.819 1.8h16.2v1.8H3.9z"
			})
		})
	});
};
const ForwardRef$113 = forwardRef(SvgPencilIcon);
//#endregion
//#region src/generated/PencilWithEraserIcon.tsx
const SvgPencilWithEraserIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m13.31 7.373 3.818 3.818-8.91 8.91H4.4v-3.82l8.91-8.91zM14.583 6.1l1.908-1.91a.9.9 0 0 1 1.273 0l2.546 2.546a.9.9 0 0 1 0 1.273L18.4 9.918z"
			})
		})
	});
};
const ForwardRef$114 = forwardRef(SvgPencilWithEraserIcon);
//#endregion
//#region src/generated/PersonIcon.tsx
const SvgPersonIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 20,
				height: 20,
				fill: "#fff",
				rx: 10
			}), /* @__PURE__ */ jsx("path", {
				fill: "#0F3063",
				d: "M5 16c0-1.313.242-1.786 1.18-2.714.937-.929 2.494-1.238 3.82-1.238s2.812.309 3.75 1.238c.938.928 1.25 1.4 1.25 2.714h-1.25c0-.985-.047-1.303-.75-2s-2.005-.714-3-.714-2.297.017-3 .714-.75 1.015-.75 2zm5-4.571c-2.072 0-3.75-1.663-3.75-3.715S7.928 4 10 4s3.75 1.662 3.75 3.714S12.072 11.43 10 11.43m0-1.239c1.381 0 2.5-1.108 2.5-2.476S11.381 5.238 10 5.238 7.5 6.346 7.5 7.714 8.619 10.19 10 10.19"
			})]
		})
	});
};
const ForwardRef$115 = forwardRef(SvgPersonIcon);
//#endregion
//#region src/generated/PieChartLineIcon.tsx
const SvgPieChartLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 6.3-8.588v1.912A7.203 7.203 0 0 0 12 19.2a7.2 7.2 0 0 0 6.676-4.5h1.912A9 9 0 0 1 12 21m8.955-8.1H11.1V3.045Q11.545 3 12 3a9 9 0 0 1 8.955 9.9"
			})
		})
	});
};
const ForwardRef$116 = forwardRef(SvgPieChartLineIcon);
//#endregion
//#region src/generated/PilcrowIcon.tsx
const SvgPilcrowIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M16 5.611h-3.85v7.823h-.902q-1.692 0-2.864-.608-1.173-.616-1.778-1.678Q6 10.078 6 8.717q0-1.348.606-2.41.605-1.07 1.778-1.684Q9.556 4 11.248 4H16zM14.075 19V4H16v15z"
			})
		})
	});
};
const ForwardRef$117 = forwardRef(SvgPilcrowIcon);
//#endregion
//#region src/generated/PlayIcon.tsx
const SvgPlayIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M18.638 12.374 9.1 18.734a.45.45 0 0 1-.699-.375V5.641a.45.45 0 0 1 .7-.375l9.538 6.36a.45.45 0 0 1 0 .748"
			})
		})
	});
};
const ForwardRef$118 = forwardRef(SvgPlayIcon);
//#endregion
//#region src/generated/PlayMiniIcon.tsx
const SvgPlayMiniIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "m8.177 6.095 9.457 5.517a.45.45 0 0 1 0 .777l-9.457 5.517a.45.45 0 0 1-.677-.39V6.483a.45.45 0 0 1 .677-.389"
			})
		})
	});
};
const ForwardRef$119 = forwardRef(SvgPlayMiniIcon);
//#endregion
//#region src/generated/PlusIcon.tsx
const SvgPlusIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.1 11.1V5.7h1.8v5.4h5.4v1.8h-5.4v5.4h-1.8v-5.4H5.7v-1.8z"
			})
		})
	});
};
const ForwardRef$120 = forwardRef(SvgPlusIcon);
//#endregion
//#region src/generated/PlusRoundIcon.tsx
const SvgPlusRoundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 36 36",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: 36,
					height: 36,
					fill: "#5973A6",
					rx: 4,
					style: { fillOpacity: .06 }
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M19 17.5h4a1 1 0 1 1 0 2h-4V23a1 1 0 1 1-2 0v-3.5h-4a1 1 0 1 1 0-2h4V14a1 1 0 1 1 2 0z"
				}),
				/* @__PURE__ */ jsx("mask", {
					id: "PlusRoundIcon_svg__a",
					width: 12,
					height: 11,
					x: 12,
					y: 13,
					maskUnits: "userSpaceOnUse",
					children: /* @__PURE__ */ jsx("path", {
						fill: "#fff",
						d: "M19 17.5h4a1 1 0 1 1 0 2h-4V23a1 1 0 1 1-2 0v-3.5h-4a1 1 0 1 1 0-2h4V14a1 1 0 1 1 2 0z"
					})
				})
			]
		})
	});
};
const ForwardRef$121 = forwardRef(SvgPlusRoundIcon);
//#endregion
//#region src/generated/PresentationFillIcon.tsx
const SvgPresentationFillIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M9.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-2.25 9v4.5h-1.5v-9a2.25 2.25 0 0 1 3.83-1.602l1.78 1.681 1.735-1.734 1.06 1.06-2.765 2.766-1.14-1.077V19.5h-1.5V15zM11 6.75h6.75v6.75H11V15h3.274l2.118 4.5h1.657L15.932 15H18.5a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75H11z"
			})
		})
	});
};
const ForwardRef$122 = forwardRef(SvgPresentationFillIcon);
//#endregion
//#region src/generated/ProgressCircleIcon.tsx
const SvgProgressCircleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 23 22",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("circle", {
				cx: 11.736,
				cy: 11,
				r: 10.633,
				fill: "white !important",
				stroke: "currentColor",
				strokeWidth: .5
			}), /* @__PURE__ */ jsx("circle", {
				cx: 11.736,
				cy: 10.999,
				r: 7.333,
				fill: "currentColor"
			})]
		})
	});
};
const ForwardRef$123 = forwardRef(SvgProgressCircleIcon);
//#endregion
//#region src/generated/QuestionRoundIcon.tsx
const SvgQuestionRoundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "#5B6F98",
				d: "M0 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0"
			}), /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				d: "M4.8 8.4a3.2 3.2 0 1 1 4 3.1v.51H7.2V10H8a1.6 1.6 0 1 0-1.6-1.6zM8.8 14.8v-1.6H7.2v1.6z"
			})]
		})
	});
};
const ForwardRef$124 = forwardRef(SvgQuestionRoundIcon);
//#endregion
//#region src/generated/QuestionSetIcon.tsx
const SvgQuestionSetIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 24,
				height: 24,
				fill: "#0F3063",
				rx: 3
			}), /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				d: "M15.333 7.8V5.7a.72.72 0 0 0-.195-.495.65.65 0 0 0-.471-.205h-8a.65.65 0 0 0-.472.205A.72.72 0 0 0 6 5.7v9.8c0 .186.07.364.195.495a.65.65 0 0 0 .472.205h2v2.1c0 .386.3.7.671.7h7.99a.64.64 0 0 0 .475-.203A.7.7 0 0 0 18 18.3l-.002-9.8c0-.386-.3-.7-.67-.7zm1.332 1.4.002 8.4H10V9.2zM14 7.8H8.667v7H7.333V6.4H14zm1.333 3.5h-4v1.4h4zm0 2.8h-4v1.4h4z"
			})]
		})
	});
};
const ForwardRef$125 = forwardRef(SvgQuestionSetIcon);
//#endregion
//#region src/generated/QuillPenIcon.tsx
const SvgQuillPenIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M20.6 3C7.1 3 5.3 15.6 4.4 21h1.798q.9-4.5 4.502-4.95c3.6-.45 6.3-3.6 7.2-6.3l-1.35-.9.9-.9c.9-.9 1.804-2.25 3.15-4.95"
			})
		})
	});
};
const ForwardRef$126 = forwardRef(SvgQuillPenIcon);
//#endregion
//#region src/generated/RecordCircleIcon.tsx
const SvgRecordCircleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-1.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m0-2.7a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9"
			})
		})
	});
};
const ForwardRef$127 = forwardRef(SvgRecordCircleIcon);
//#endregion
//#region src/generated/RecordStopIcon.tsx
const SvgRecordStopIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9M9.3 9.3v5.4h5.4V9.3z"
			})
		})
	});
};
const ForwardRef$128 = forwardRef(SvgRecordStopIcon);
//#endregion
//#region src/generated/ReplyAllIcon.tsx
const SvgReplyAllIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13.8 5.25V9.3a9 9 0 0 1 8.971 9.729 8.1 8.1 0 0 0-6.89-4.324L15.6 14.7h-1.8v4.05L6.6 12zm-5.4 0v2.463L3.828 12l4.571 4.285.001 2.465L1.2 12z"
			})
		})
	});
};
const ForwardRef$129 = forwardRef(SvgReplyAllIcon);
//#endregion
//#region src/generated/RewindMiniIcon.tsx
const SvgRewindMiniIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M11.1 16.532a.45.45 0 0 1-.71.368l-6.419-4.533a.45.45 0 0 1 0-.734l6.42-4.533a.45.45 0 0 1 .709.369zm.971-4.165a.45.45 0 0 1 0-.734l6.42-4.533a.45.45 0 0 1 .709.369v9.063a.45.45 0 0 1-.71.368z"
			})
		})
	});
};
const ForwardRef$130 = forwardRef(SvgRewindMiniIcon);
//#endregion
//#region src/generated/RubricIcon.tsx
const SvgRubricIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M2 2h5.88v5.88H2zM9.06 2h5.88v5.88H9.06zM16.12 2H22v5.88h-5.88zM2 9.06h5.88v5.88H2zM9.06 9.06h5.88v5.88H9.06zM2 16.12h5.88V22H2z"
			}), /* @__PURE__ */ jsx("path", {
				fill: "#B7C0D0",
				d: "M16.12 9.06H22v5.88h-5.88zM9.06 16.12h5.88V22H9.06zM16.12 16.12H22V22h-5.88z"
			})]
		})
	});
};
const ForwardRef$131 = forwardRef(SvgRubricIcon);
//#endregion
//#region src/generated/SaveIcon.tsx
const SvgSaveIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M8 18.3v-5.4h9v5.4h1.8V8.245L16.255 5.7H6.2v12.6zM5.3 3.9H17l3.6 3.6v11.7a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9m4.5 10.8v3.6h5.4v-3.6z" })
		})
	});
};
const ForwardRef$132 = forwardRef(SvgSaveIcon);
//#endregion
//#region src/generated/ShakeHandsIcon.tsx
const SvgShakeHandsIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M17.969 7.5h.531a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-.75.75H17l-3.126-4.377a1.5 1.5 0 0 0-1.652-.565l-1.864.56a1.5 1.5 0 0 1-1.491-.377l-.22-.22a.75.75 0 0 1 .114-1.154l4.051-2.7A1.5 1.5 0 0 1 14.45 5.4l3.116 1.983a.75.75 0 0 0 .403.117M7.27 13.72l-1.212 1.06a.75.75 0 0 0 .031 1.154l3.856 3.03a.75.75 0 0 0 1.114-.218l.528-.924a1.5 1.5 0 0 0-.192-1.753l-2.027-2.23a1.5 1.5 0 0 0-2.098-.119M8.784 6.75H5.75A.75.75 0 0 0 5 7.5v5.637c0 .306.094.601.263.848l.055-.05 1.212-1.06a2.625 2.625 0 0 1 3.67.21l2.027 2.228c.765.842.901 2.08.337 3.068l-.49.86a1.5 1.5 0 0 0 1.303-.117l3.307-1.984a.75.75 0 0 0 .224-1.08l-3.95-5.533a.375.375 0 0 0-.413-.141l-1.864.559a2.63 2.63 0 0 1-2.61-.658l-.22-.22a1.875 1.875 0 0 1 .286-2.886z"
			})
		})
	});
};
const ForwardRef$133 = forwardRef(SvgShakeHandsIcon);
//#endregion
//#region src/generated/ShareForwardIcon.tsx
const SvgShareForwardIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.8 18.3h14.4v-4.5H21v5.4a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9v-5.4h1.8zm7.2-8.1H9.3a5.4 5.4 0 0 0-4.369 2.226A7.2 7.2 0 0 1 12 6.6V3l7.2 5.4-7.2 5.4z"
			})
		})
	});
};
const ForwardRef$134 = forwardRef(SvgShareForwardIcon);
//#endregion
//#region src/generated/ShareIcon.tsx
const SvgShareIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#0F172E",
				fillRule: "evenodd",
				d: "M9.651 3.316 18 9.436l-8.349 7.238v-3.896H8.126c-1.074 0-2.112.39-2.92 1.098L2 16.684v-3.91a5.7 5.7 0 0 1 5.699-5.699H9.65zm1.267 2.499v2.527h-3.22a4.43 4.43 0 0 0-4.432 4.432v1.117l1.105-.968a5.7 5.7 0 0 1 3.755-1.412h2.792v2.39l5.053-4.382z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$135 = forwardRef(SvgShareIcon);
//#endregion
//#region src/generated/ShootingStarIcon.tsx
const SvgShootingStarIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m14.902 15.157-1.992 4.185a.54.54 0 0 1-.88.14l-3.187-3.365a.54.54 0 0 0-.321-.164l-4.597-.601a.54.54 0 0 1-.404-.793l2.216-4.072a.54.54 0 0 0 .056-.356l-.849-4.557a.54.54 0 0 1 .63-.63l4.557.849a.54.54 0 0 0 .356-.056L14.56 3.52a.54.54 0 0 1 .793.405l.6 4.596a.54.54 0 0 0 .165.32l3.365 3.189a.54.54 0 0 1-.14.879l-4.185 1.992a.54.54 0 0 0-.255.255m.717 1.735 1.273-1.273 3.818 3.818-1.273 1.273z"
			})
		})
	});
};
const ForwardRef$136 = forwardRef(SvgShootingStarIcon);
//#endregion
//#region src/generated/ShortAnswerIcon.tsx
const SvgShortAnswerIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 24,
				height: 24,
				fill: "#F0F5F9",
				rx: 3
			}), /* @__PURE__ */ jsx("path", {
				stroke: "#0073E6",
				strokeWidth: 2,
				d: "M4 9.268h9M4 14.732h4.571M9.715 14.732H20M14.14 9.268h5.858"
			})]
		})
	});
};
const ForwardRef$137 = forwardRef(SvgShortAnswerIcon);
//#endregion
//#region src/generated/SkipBackIcon.tsx
const SvgSkipBackIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "m8.4 11.4 9.2-6.134a.45.45 0 0 1 .7.375v12.718a.451.451 0 0 1-.7.375L8.4 12.6v5.7a.9.9 0 1 1-1.8 0V5.7a.9.9 0 0 1 1.8 0z"
			})
		})
	});
};
const ForwardRef$138 = forwardRef(SvgSkipBackIcon);
//#endregion
//#region src/generated/SkipBackMiniIcon.tsx
const SvgSkipBackMiniIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M7.5 6.6a.9.9 0 0 1 .9.9v9a.9.9 0 0 1-1.8 0v-9a.9.9 0 0 1 .9-.9m1.871 5.767a.45.45 0 0 1 0-.734l6.42-4.533a.45.45 0 0 1 .709.368v9.064a.45.45 0 0 1-.71.368z"
			})
		})
	});
};
const ForwardRef$139 = forwardRef(SvgSkipBackMiniIcon);
//#endregion
//#region src/generated/SkipForward.tsx
const SvgSkipForward = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "m15.6 12.6-9.2 6.134a.45.45 0 0 1-.7-.375V5.641a.45.45 0 0 1 .7-.375l9.2 6.134V5.7a.9.9 0 1 1 1.8 0v12.6a.9.9 0 0 1-1.8 0z"
			})
		})
	});
};
const ForwardRef$140 = forwardRef(SvgSkipForward);
//#endregion
//#region src/generated/SkipForwardMiniIcon.tsx
const SvgSkipForwardMiniIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M8.21 16.9a.45.45 0 0 1-.71-.368V7.468a.45.45 0 0 1 .71-.368l6.419 4.533a.45.45 0 0 1 0 .734zm7.39-9.4a.9.9 0 1 1 1.8 0v9a.9.9 0 1 1-1.8 0z"
			})
		})
	});
};
const ForwardRef$141 = forwardRef(SvgSkipForwardMiniIcon);
//#endregion
//#region src/generated/SlowDownLineIcon.tsx
const SvgSlowDownLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.333 11.037c0 1.563.635 2.979 1.66 4.004l-1.002 1a7.05 7.05 0 0 1-2.074-5.004A7.08 7.08 0 0 1 10 3.958a7.08 7.08 0 0 1 7.083 7.079 7.05 7.05 0 0 1-2.074 5.005l-1.002-1.001a5.64 5.64 0 0 0 1.66-4.004A5.665 5.665 0 0 0 10 5.374a5.665 5.665 0 0 0-5.667 5.663m3.334-3.332 3.188 3.185-1.002 1.001-3.187-3.185z"
			})
		})
	});
};
const ForwardRef$142 = forwardRef(SvgSlowDownLineIcon);
//#endregion
//#region src/generated/SparksIcon.tsx
const SvgSparksIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M11.25 5.273c.841 0 1.523-.682 1.523-1.523h.704c0 .841.682 1.523 1.523 1.523v.704c-.841 0-1.523.682-1.523 1.523h-.704c0-.841-.682-1.523-1.523-1.523zM3.125 9.375a3.75 3.75 0 0 0 3.75-3.75h1.25a3.75 3.75 0 0 0 3.75 3.75v1.25a3.75 3.75 0 0 0-3.75 3.75h-1.25a3.75 3.75 0 0 0-3.75-3.75zm10.156 1.875c0 1.122-.91 2.031-2.031 2.031v.938c1.122 0 2.031.91 2.031 2.031h.938c0-1.122.91-2.031 2.031-2.031v-.938a2.03 2.03 0 0 1-2.031-2.031z"
			})
		})
	});
};
const ForwardRef$143 = forwardRef(SvgSparksIcon);
//#endregion
//#region src/generated/SparksWithMinusIcon.tsx
const SvgSparksWithMinusIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M13.5 6.328c1.01 0 1.828-.818 1.828-1.828h.844c0 1.01.818 1.828 1.828 1.828v.844c-1.01 0-1.828.818-1.828 1.828h-.844c0-1.01-.818-1.828-1.828-1.828zM3.75 11.25a4.5 4.5 0 0 0 4.5-4.5h1.5a4.5 4.5 0 0 0 4.5 4.5v1.5a4.5 4.5 0 0 0-4.5 4.5h-1.5a4.5 4.5 0 0 0-4.5-4.5zm12.188 2.25a2.437 2.437 0 0 1-2.438 2.438v1.124a2.437 2.437 0 0 1 2.438 2.438h1.124a2.437 2.437 0 0 1 2.438-2.437v-1.125a2.437 2.437 0 0 1-2.437-2.438z"
			}), /* @__PURE__ */ jsxs("g", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				children: [
					/* @__PURE__ */ jsx("path", {
						fill: "currentColor",
						d: "M13.757 22.243a6 6 0 1 0 8.486-8.485 6 6 0 0 0-8.486 8.485"
					}),
					/* @__PURE__ */ jsx("path", {
						fill: "#fff",
						d: "M14.55 21.448a4.877 4.877 0 1 0 6.896-6.896 4.877 4.877 0 0 0-6.897 6.896"
					}),
					/* @__PURE__ */ jsx("path", {
						fill: "currentColor",
						d: "M15 17.4h6v1.2h-6z"
					})
				]
			})]
		})
	});
};
const ForwardRef$144 = forwardRef(SvgSparksWithMinusIcon);
//#endregion
//#region src/generated/SpeedMiniIcon.tsx
const SvgSpeedMiniIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M5.51 16.9a.45.45 0 0 1-.71-.368V7.468a.45.45 0 0 1 .71-.368l6.419 4.533a.45.45 0 0 1 0 .734zm7.39-9.431a.45.45 0 0 1 .71-.369l6.419 4.533a.45.45 0 0 1 0 .734l-6.42 4.533a.45.45 0 0 1-.709-.368z"
			})
		})
	});
};
const ForwardRef$145 = forwardRef(SvgSpeedMiniIcon);
//#endregion
//#region src/generated/SquarePlayIcon.tsx
const SvgSquarePlayIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 24,
				height: 24,
				fill: "#FCF6FC",
				rx: 3
			}), /* @__PURE__ */ jsx("path", {
				fill: "#D095CE",
				d: "M4 4.883C4 4.396 4.396 4 4.883 4h14.234c.487 0 .883.396.883.883v14.234a.883.883 0 0 1-.883.883H4.883A.883.883 0 0 1 4 19.117zm6.775 3.93a.356.356 0 0 0-.553.295v5.784a.356.356 0 0 0 .553.295l4.337-2.891a.355.355 0 0 0 0-.592z"
			})]
		})
	});
};
const ForwardRef$146 = forwardRef(SvgSquarePlayIcon);
//#endregion
//#region src/generated/StackIcon.tsx
const SvgStackIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m19.775 14.88 1.082.65a.45.45 0 0 1 0 .772l-7.893 4.735a.9.9 0 0 1-.928 0l-7.892-4.735a.45.45 0 0 1 0-.773l1.081-.649 7.275 4.365zm0-4.23 1.082.65a.45.45 0 0 1 0 .771L12.5 17.086l-8.356-5.014a.45.45 0 0 1 0-.772l1.081-.649 7.275 4.365zM12.963 2.38l7.894 4.735a.45.45 0 0 1 0 .773L12.5 12.9 4.144 7.887a.45.45 0 0 1 0-.773l7.893-4.735a.9.9 0 0 1 .926 0m-.463 1.82L6.998 7.5l5.502 3.302L18.002 7.5z"
			})
		})
	});
};
const ForwardRef$147 = forwardRef(SvgStackIcon);
//#endregion
//#region src/generated/SubtractIcon.tsx
const SvgSubtractIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 6 2",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.37 1.248H.634V.064H5.37z"
			})
		})
	});
};
const ForwardRef$148 = forwardRef(SvgSubtractIcon);
//#endregion
//#region src/generated/SubtractRoundIcon.tsx
const SvgSubtractRoundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-1.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m-4.5-8.1h9v1.8h-9z"
			})
		})
	});
};
const ForwardRef$149 = forwardRef(SvgSubtractRoundIcon);
//#endregion
//#region src/generated/SwapLineIcon.tsx
const SvgSwapLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#071831",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m0-1.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4M7.5 9.3l2.7-3.15 2.7 3.15h-1.8v3.6H9.3V9.3zm9 5.4-2.7 3.15-2.7-3.15h1.8v-3.6h1.8v3.6z"
			})
		})
	});
};
const ForwardRef$150 = forwardRef(SvgSwapLineIcon);
//#endregion
//#region src/generated/SwitchIcon.tsx
const SvgSwitchIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 28",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M1.701 22Q.997 22 .5 21.472A1.8 1.8 0 0 1 0 20.197v-12.4q0-.746.499-1.274A1.6 1.6 0 0 1 1.7 5.994H5.89q.088-.83.684-1.412A1.97 1.97 0 0 1 8 4q.84 0 1.435.582t.675 1.412H14.3q.704 0 1.202.529.5.528.499 1.274v12.4q0 .746-.499 1.275A1.6 1.6 0 0 1 14.3 22zm0-1.496H14.3a.27.27 0 0 0 .199-.096.3.3 0 0 0 .09-.21v-12.4a.3.3 0 0 0-.09-.212.27.27 0 0 0-.2-.096H1.702a.27.27 0 0 0-.199.096.3.3 0 0 0-.09.211v12.4q0 .115.09.211a.27.27 0 0 0 .2.096M8 6.838q.306 0 .506-.212a.75.75 0 0 0 .2-.536.75.75 0 0 0-.2-.536A.67.67 0 0 0 8 5.342a.67.67 0 0 0-.506.212.75.75 0 0 0-.2.536.75.75 0 0 0 .2.536.67.67 0 0 0 .506.212"
				}),
				/* @__PURE__ */ jsxs("mask", {
					id: "SwitchIcon_svg__a",
					width: 8,
					height: 7,
					x: 2,
					y: 9.004,
					fill: "#000",
					maskUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("path", {
						fill: "#fff",
						d: "M2 9.004h8v7H2z"
					}), /* @__PURE__ */ jsx("path", {
						fillRule: "evenodd",
						d: "m4.447 13.225 1.28 2.147h-.943L3 12.752v-.128l1.784-2.62h.943L4.444 12.15H9v1.074z",
						clipRule: "evenodd"
					})]
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					fillRule: "evenodd",
					d: "m4.447 13.225 1.28 2.147h-.943L3 12.752v-.128l1.784-2.62h.943L4.444 12.15H9v1.074z",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M4.447 13.225v-.236h-.416l.213.357zm1.28 2.147v.236h.416l-.213-.357zm-.943 0-.195.133.07.103h.125zM3 12.752h-.236v.072l.04.06zm0-.128-.195-.133-.041.06v.073zm1.784-2.62v-.236H4.66l-.07.103zm.943 0 .203.121.213-.357h-.416zM4.444 12.15l-.203-.121-.213.357h.416zm4.556 0h.236v-.236H9zm0 1.074v.236h.236v-.236zm-4.756.12 1.28 2.148.406-.242-1.28-2.147zm1.483 1.79h-.943v.473h.943zm-.747.104-1.785-2.62-.39.266 1.784 2.62zm-1.744-2.487v-.128h-.472v.128zm-.04.005 1.784-2.62-.39-.266-1.785 2.62zm1.588-2.517h.943v-.472h-.943zm.74-.357L4.242 12.03l.406.242 1.283-2.147zm-1.08 2.504H9v-.472H4.444zm4.32-.236v1.074h.472V12.15zM9 12.99H4.447v.472H9z",
					mask: "url(#SwitchIcon_svg__a)"
				}),
				/* @__PURE__ */ jsxs("mask", {
					id: "SwitchIcon_svg__b",
					width: 8,
					height: 7,
					x: 5.813,
					y: 12.496,
					fill: "#000",
					maskUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("path", {
						fill: "#fff",
						d: "M5.813 12.496h8v7h-8z"
					}), /* @__PURE__ */ jsx("path", {
						fillRule: "evenodd",
						d: "m11.365 15.275-1.28-2.147h.943l1.784 2.62v.128l-1.784 2.62h-.943l1.284-2.147H6.813v-1.074z",
						clipRule: "evenodd"
					})]
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					fillRule: "evenodd",
					d: "m11.365 15.275-1.28-2.147h.943l1.784 2.62v.128l-1.784 2.62h-.943l1.284-2.147H6.813v-1.074z",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M11.365 15.275v.236h.416l-.213-.357zm-1.28-2.147v-.236H9.67l.212.357zm.943 0 .195-.133-.07-.103h-.125zm1.784 2.62h.237v-.072l-.041-.06zm0 .128.196.133.04-.06v-.073zm-1.784 2.62v.236h.125l.07-.103zm-.943 0-.202-.121-.214.357h.416zm1.284-2.147.202.121.214-.357h-.416zm-4.556 0h-.237v.236h.237zm0-1.074v-.236h-.237v.236zm4.755-.12-1.28-2.148-.406.242 1.28 2.147zm-1.483-1.79h.943v-.473h-.943zm.748-.104 1.784 2.62.39-.266-1.784-2.62zm1.743 2.487v.128h.473v-.128zm.041-.005-1.784 2.62.39.266 1.785-2.62zm-1.589 2.517h-.943v.472h.943zm-.74.357 1.283-2.147-.405-.242-1.283 2.147zm1.08-2.504H6.814v.472h4.556zm-4.32.236v-1.074h-.472v1.074zm-.236-.838h4.553v-.472H6.813z",
					mask: "url(#SwitchIcon_svg__b)"
				})
			]
		})
	});
};
const ForwardRef$151 = forwardRef(SvgSwitchIcon);
//#endregion
//#region src/generated/TabletPortrait.tsx
const SvgTabletPortrait = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			viewBox: "0 0 16 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				d: "M12.84 0H3.16C2.52 0 2 .52 2 1.16v13.68c0 .64.52 1.16 1.16 1.16h9.68c.64 0 1.16-.52 1.16-1.16V1.16C14 .52 13.48 0 12.84 0M7.996.57c.152 0 .281.13.281.282a.283.283 0 0 1-.28.28.28.28 0 0 1-.282-.28c0-.153.125-.282.281-.282m.02 14.282a.829.829 0 0 1 0-1.657.83.83 0 0 1 .832.828.83.83 0 0 1-.832.829m4.27-2.282H3.714V2.285h8.57Zm0 0",
				style: {
					stroke: "none",
					fillRule: "nonzero",
					fill: "#000",
					fillOpacity: 1
				}
			})
		})
	});
};
const ForwardRef$152 = forwardRef(SvgTabletPortrait);
//#endregion
//#region src/generated/TagIcon.tsx
const SvgTagIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 18 18",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10.026 0q5.236-.002 6.606 1.368T18 7.975c0 .677-.27 1.326-.748 1.805l-7.846 7.846a1.28 1.28 0 0 1-1.806 0L.374 10.4a1.28 1.28 0 0 1 0-1.806L8.22.748A2.56 2.56 0 0 1 10.025 0m0 1.916a.64.64 0 0 0-.375.122l-.077.066-7.393 7.393 6.322 6.322 7.395-7.393a.64.64 0 0 0 .178-.352l.008-.1c.001-3.003-.375-4.818-.807-5.25s-2.248-.809-5.25-.808m.284 2.162a2.554 2.554 0 1 1 3.612 3.612 2.554 2.554 0 0 1-3.612-3.612m2.709.904a1.277 1.277 0 1 0-1.806 1.805 1.277 1.277 0 0 0 1.806-1.805"
			})
		})
	});
};
const ForwardRef$153 = forwardRef(SvgTagIcon);
//#endregion
//#region src/generated/TeamLineIcon.tsx
const SvgTeamLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 25",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 11.6a4.5 4.5 0 0 1 4.5 4.5v5.4h-1.8v-5.4a2.7 2.7 0 0 0-2.542-2.696L12 13.4a2.7 2.7 0 0 0-2.695 2.542L9.3 16.1v5.4H7.5v-5.4a4.5 4.5 0 0 1 4.5-4.5m-5.85 2.7q.377.001.729.085a5.4 5.4 0 0 0-.27 1.417L6.6 16.1v.077a1.3 1.3 0 0 0-.32-.072l-.13-.005a1.35 1.35 0 0 0-1.344 1.22l-.006.13v4.05H3v-4.05a3.15 3.15 0 0 1 3.15-3.15m11.7 0A3.15 3.15 0 0 1 21 17.45v4.05h-1.8v-4.05a1.35 1.35 0 0 0-1.22-1.344l-.13-.006q-.238.001-.45.076V16.1c0-.6-.097-1.175-.278-1.714q.35-.085.728-.086M6.15 8.9a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m11.7 0a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m-11.7 1.8a.45.45 0 1 0 0 .9.45.45 0 0 0 0-.9m11.7 0a.45.45 0 1 0 0 .9.45.45 0 0 0 0-.9M12 3.5a3.6 3.6 0 1 1 0 7.2 3.6 3.6 0 0 1 0-7.2m0 1.8a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6"
			})
		})
	});
};
const ForwardRef$154 = forwardRef(SvgTeamLineIcon);
//#endregion
//#region src/generated/TextIcon.tsx
const SvgTextIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 39 18",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "#fff",
				stroke: "currentColor",
				strokeWidth: 2,
				d: "M1.2 1.8h36v14.4h-36z"
			}), /* @__PURE__ */ jsx("path", { d: "M6.637 12.568v-.75h1.125v-5.25H6.637v-.75h3v.75H8.512v5.25h1.125v.75z" })]
		})
	});
};
const ForwardRef$155 = forwardRef(SvgTextIcon);
//#endregion
//#region src/generated/TickIcon.tsx
const SvgTickIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "m9.6 18-4.893-4.893a1 1 0 0 1 0-1.414l.186-.186a1 1 0 0 1 1.414 0L9.6 14.8l8.093-8.093a1 1 0 0 1 1.414 0l.186.186a1 1 0 0 1 0 1.414z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$156 = forwardRef(SvgTickIcon);
//#endregion
//#region src/generated/TickRoundBackgroundIcon.tsx
const SvgTickRoundBackgroundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9m-.897-5.4 6.363-6.364-1.273-1.273-5.09 5.092-2.546-2.546-1.273 1.272z"
			})
		})
	});
};
const ForwardRef$157 = forwardRef(SvgTickRoundBackgroundIcon);
//#endregion
//#region src/generated/TickRoundIcon.tsx
const SvgTickRoundIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 18 19",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: 18,
					height: 18,
					y: .5,
					fill: "currentColor",
					rx: 3
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#fff",
					d: "m7.888 11.198-2.26-1.94L4 10.907 7.888 14.5 15 7.151 13.373 5.5z"
				}),
				/* @__PURE__ */ jsx("rect", {
					width: 17,
					height: 17,
					x: .5,
					y: 1,
					stroke: "currentColor",
					rx: 2.5
				})
			]
		})
	});
};
const ForwardRef$158 = forwardRef(SvgTickRoundIcon);
//#endregion
//#region src/generated/TimeIcon.tsx
const SvgTimeIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m.5 6.633 2.714 1.567-.75 1.299L11.002 13H11V7h1.5z" })
		})
	});
};
const ForwardRef$159 = forwardRef(SvgTimeIcon);
//#endregion
//#region src/generated/TimerLineIcon.tsx
const SvgTimerLineIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "m14.213 5.476 1.09-1.09 1.06 1.06-1.09 1.09a6.75 6.75 0 1 1-1.06-1.06M10 16a5.25 5.25 0 1 0 0-10.5A5.25 5.25 0 0 0 10 16m-.75-9h1.5v4.5h-1.5zM7 1.75h6v1.5H7z"
			})
		})
	});
};
const ForwardRef$160 = forwardRef(SvgTimerLineIcon);
//#endregion
//#region src/generated/TrashIcon.tsx
const SvgTrashIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M16.5 6.6H21v1.8h-1.8v11.7a.9.9 0 0 1-.9.9H5.7a.9.9 0 0 1-.9-.9V8.4H3V6.6h4.5V3.9a.9.9 0 0 1 .9-.9h7.2a.9.9 0 0 1 .9.9zm.9 1.8H6.6v10.8h10.8zm-8.1 2.7h1.8v5.4H9.3zm3.6 0h1.8v5.4h-1.8zM9.3 4.8v1.8h5.4V4.8z"
			})
		})
	});
};
const ForwardRef$161 = forwardRef(SvgTrashIcon);
//#endregion
//#region src/generated/TrueFalseIcon.tsx
const SvgTrueFalseIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [
				/* @__PURE__ */ jsx("rect", {
					width: 24,
					height: 24,
					fill: "#F1F2FF",
					rx: 3
				}),
				/* @__PURE__ */ jsx("rect", {
					width: 16,
					height: 16,
					x: 4,
					y: 4,
					stroke: "#3F5982",
					rx: 8
				}),
				/* @__PURE__ */ jsx("path", {
					fill: "#3F5982",
					d: "M12 3.805a7.954 7.954 0 0 1 7.954 7.954v.62A7.954 7.954 0 0 1 12 20.335z"
				})
			]
		})
	});
};
const ForwardRef$162 = forwardRef(SvgTrueFalseIcon);
//#endregion
//#region src/generated/UserGroupIcon.tsx
const SvgUserGroupIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 30 30",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M15 14a5 5 0 0 1 5 5v6h-2v-6a3 3 0 0 0-2.824-2.995L15 16a3 3 0 0 0-2.995 2.824L12 19v6h-2v-6a5 5 0 0 1 5-5m-6.5 3q.42.001.81.094a6 6 0 0 0-.301 1.575L9 19v.086a1.5 1.5 0 0 0-.356-.08L8.5 19a1.5 1.5 0 0 0-1.493 1.356L7 20.5V25H5v-4.5A3.5 3.5 0 0 1 8.5 17m13 0a3.5 3.5 0 0 1 3.5 3.5V25h-2v-4.5a1.5 1.5 0 0 0-1.356-1.493L21.5 19q-.264.001-.5.085V19c0-.666-.108-1.306-.309-1.904A3.4 3.4 0 0 1 21.5 17m-13-6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m13 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5m-13 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m13 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M15 5a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
			})
		})
	});
};
const ForwardRef$163 = forwardRef(SvgUserGroupIcon);
//#endregion
//#region src/generated/UserIcon.tsx
const SvgUserIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M4.8 21a7.2 7.2 0 1 1 14.4 0h-1.8a5.4 5.4 0 1 0-10.8 0zm7.2-8.1a5.4 5.4 0 0 1-5.4-5.4c0-2.983 2.416-5.4 5.4-5.4 2.983 0 5.4 2.417 5.4 5.4s-2.416 5.4-5.4 5.4m0-1.8c1.989 0 3.6-1.61 3.6-3.6S13.989 3.9 12 3.9a3.6 3.6 0 0 0-3.6 3.6c0 1.99 1.611 3.6 3.6 3.6"
			})
		})
	});
};
const ForwardRef$164 = forwardRef(SvgUserIcon);
//#endregion
//#region src/generated/UserSharedIcon.tsx
const SvgUserSharedIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", { d: "M13.8 14.026v1.881A5.4 5.4 0 0 0 6.6 21l-1.8-.001a7.2 7.2 0 0 1 9-6.973M12 12.9a5.4 5.4 0 0 1-5.4-5.4c0-2.984 2.417-5.4 5.4-5.4s5.4 2.416 5.4 5.4c0 2.983-2.416 5.4-5.4 5.4m0-1.8c1.99 0 3.6-1.611 3.6-3.6S13.99 3.9 12 3.9a3.6 3.6 0 0 0-3.6 3.6c0 1.989 1.612 3.6 3.6 3.6m5.928 5.4-1.646-1.646 1.274-1.273 3.817 3.819-3.817 3.818-1.274-1.273 1.646-1.645h-3.227v-1.8z" })
		})
	});
};
const ForwardRef$165 = forwardRef(SvgUserSharedIcon);
//#endregion
//#region src/generated/VideoCameraFilledIcon.tsx
const SvgVideoCameraFilledIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 15",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m14.4 4.68 4.692-3.285a.45.45 0 0 1 .708.369v10.872a.45.45 0 0 1-.708.369L14.4 9.72v3.78a.9.9 0 0 1-.9.9H.9a.9.9 0 0 1-.9-.9V.9A.9.9 0 0 1 .9 0h12.6a.9.9 0 0 1 .9.9zM3.6 3.6v1.8h1.8V3.6z"
			})
		})
	});
};
const ForwardRef$166 = forwardRef(SvgVideoCameraFilledIcon);
//#endregion
//#region src/generated/VideoCameraIcon.tsx
const SvgVideoCameraIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 15",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "m14.4 4.68 4.692-3.285a.45.45 0 0 1 .708.369v10.872a.45.45 0 0 1-.708.369L14.4 9.72v3.78a.9.9 0 0 1-.9.9H.9a.9.9 0 0 1-.9-.9V.9A.9.9 0 0 1 .9 0h12.6a.9.9 0 0 1 .9.9zm0 2.843 3.6 2.52V4.356l-3.6 2.52zM1.8 1.8v10.8h10.8V1.8zm1.8 1.8h1.8v1.8H3.6z"
			})
		})
	});
};
const ForwardRef$167 = forwardRef(SvgVideoCameraIcon);
//#endregion
//#region src/generated/VideoCameraSlashIcon.tsx
const SvgVideoCameraSlashIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsxs("g", {
				clipPath: "url(#VideoCameraSlashIcon_svg__a)",
				children: [
					/* @__PURE__ */ jsx("path", {
						fill: "#3F5982",
						stroke: "#3F5982",
						strokeWidth: 1.5,
						d: "M1.812 1.903a.643.643 0 1 0-.91.909l1.973 1.973A2.79 2.79 0 0 0 .715 7.5v9A2.786 2.786 0 0 0 3.5 19.286h9.002c1.323 0 2.43-.923 2.715-2.16l4.971 4.972a.643.643 0 0 0 .91-.91z"
					}),
					/* @__PURE__ */ jsx("path", {
						fill: "#3F5982",
						d: "M9.727 6 8.442 4.714h6.06A2.786 2.786 0 0 1 17.288 7.5v1.353l3.895-2.664a1.071 1.071 0 0 1 1.676.884v9.856c0 .653-.553 1.103-1.13 1.072l-4.441-4.44-1.286-1.286z"
					}),
					/* @__PURE__ */ jsx("path", {
						stroke: "#3F5982",
						strokeWidth: 1.5,
						d: "m17.288 13.56-1.286-1.285L9.727 6 8.442 4.714h6.06A2.786 2.786 0 0 1 17.288 7.5v1.353l3.895-2.664a1.071 1.071 0 0 1 1.676.884v9.856c0 .653-.553 1.103-1.13 1.072zm0 0v-3.15l4.285-2.93v9.043z"
					})
				]
			}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
				id: "VideoCameraSlashIcon_svg__a",
				children: /* @__PURE__ */ jsx("path", {
					fill: "#fff",
					d: "M0 0h24v24H0z"
				})
			}) })]
		})
	});
};
const ForwardRef$168 = forwardRef(SvgVideoCameraSlashIcon);
//#endregion
//#region src/generated/ViewThreadsIcon.tsx
const SvgViewThreadsIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 25 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "m14.3 21.45-2.52-3.15H7.1a.9.9 0 0 1-.9-.9V7.593a.9.9 0 0 1 .9-.9h14.4a.9.9 0 0 1 .9.9V17.4a.9.9 0 0 1-.9.9h-4.68zm1.655-4.95H20.6V8.493H8V16.5h4.645l1.655 2.068zM3.5 3h15.3v1.8H4.4v9.9H2.6V3.9a.9.9 0 0 1 .9-.9"
			})
		})
	});
};
const ForwardRef$169 = forwardRef(SvgViewThreadsIcon);
//#endregion
//#region src/generated/WarnIcon.tsx
const SvgWarnIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 16 16",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#F17B2C",
				d: "M8 14.005a6 6 0 1 1 0-12 6 6 0 0 1 0 12m-.6-6.6v3.6h1.2v-3.6zm0-2.4v1.2h1.2v-1.2z"
			})
		})
	});
};
const ForwardRef$170 = forwardRef(SvgWarnIcon);
//#endregion
//#region src/generated/WarnTriangleIcon.tsx
const SvgWarnTriangleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsxs("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 13 12",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: [/* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M5.707 1.2a.8.8 0 0 1 1.386 0l5.014 8.685a.8.8 0 0 1-.693 1.2H1.386a.8.8 0 0 1-.693-1.2z"
			}), /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				d: "M7.04 3.723v4.533H5.76V3.723zM7.04 10.123V9.056H5.76v1.067z"
			})]
		})
	});
};
const ForwardRef$171 = forwardRef(SvgWarnTriangleIcon);
//#endregion
//#region src/generated/WindowIcon.tsx
const SvgWindowIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 72 72",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#3F5982",
				d: "M60.3 11.7H11.7A2.7 2.7 0 0 0 9 14.4v43.2a2.7 2.7 0 0 0 2.7 2.7h48.6a2.7 2.7 0 0 0 2.7-2.7V14.4a2.7 2.7 0 0 0-2.7-2.7M14.4 30.6h43.2v24.3H14.4zm40.5-10.8v5.4h-5.4v-5.4zm-10.8 0v5.4h-5.4v-5.4z"
			})
		})
	});
};
const ForwardRef$172 = forwardRef(SvgWindowIcon);
//#endregion
//#region src/generated/XMarkIcon.tsx
const SvgXMarkIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "currentColor",
			viewBox: "0 0 24 24",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "m12 10.571 2.864-2.864a1 1 0 0 1 1.415 0l.014.014a1 1 0 0 1 0 1.415L13.429 12l2.864 2.864a1 1 0 0 1 0 1.415l-.014.014a1 1 0 0 1-1.415 0L12 13.429l-2.864 2.864a1 1 0 0 1-1.415 0l-.014-.014a1 1 0 0 1 0-1.415L10.571 12 7.707 9.136a1 1 0 0 1 0-1.415l.014-.014a1 1 0 0 1 1.415 0z",
				clipRule: "evenodd"
			})
		})
	});
};
const ForwardRef$173 = forwardRef(SvgXMarkIcon);
//#endregion
//#region src/generated/ChevronUpIcon.tsx
const SvgChevronUpIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "currentColor",
				d: "M10 7.845 4.167 13.68 2.988 12.5 10 5.488l7.012 7.012-1.178 1.179z"
			})
		})
	});
};
const ForwardRef$31 = forwardRef(SvgChevronUpIcon);
//#endregion
//#region src/generated/IndeterminateCircleIcon.tsx
const SvgIndeterminateCircleIcon = (iconProps, ref) => {
	const { style, size = 16, ...props } = iconProps;
	return /* @__PURE__ */ jsx(Root, {
		label: props.label,
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			style: {
				...style,
				"width": "1em",
				"height": "1em",
				"fontSize": size
			},
			ref,
			...props,
			children: /* @__PURE__ */ jsx("path", {
				fill: "#B7C0D0",
				d: "M10 17.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15M6.25 9.25v1.5h7.5v-1.5z"
			})
		})
	});
};
const ForwardRef$88 = forwardRef(SvgIndeterminateCircleIcon);
//#endregion
export { AccessibleIconWrapper, ForwardRef as AddCircleIcon, ForwardRef$1 as AddCircleSolidIcon, ForwardRef$2 as ArrowCirclingLeftIcon, ForwardRef$3 as ArrowDownTrayIcon, ForwardRef$4 as ArrowImportLineIcon, ForwardRef$5 as ArrowIntoLineDownIcon, ForwardRef$6 as ArrowLeftIcon, ForwardRef$7 as ArrowLeftRightIcon, ForwardRef$8 as ArrowPathIcon, ForwardRef$9 as ArrowRightIcon, ForwardRef$10 as ArrowTopRightOnSquareIcon, ForwardRef$11 as ArrowUpTrayIcon, ForwardRef$12 as ArrowsCirclingIcon, ForwardRef$13 as BarChartIcon, ForwardRef$14 as BookIcon, ForwardRef$15 as BookMarkFilledIcon, ForwardRef$16 as BookMarkIcon, ForwardRef$17 as BuildingLibraryIcon, ForwardRef$18 as BurgerIcon, ForwardRef$19 as CadmusIcon, ForwardRef$20 as CalendarFilledIcon, ForwardRef$21 as CalendarIcon, ForwardRef$22 as CalendarWithCheckIcon, ForwardRef$23 as CameraIcon, ForwardRef$24 as CaretIcon, ForwardRef$25 as CheckCircleIcon, ForwardRef$26 as CheckIcon, ForwardRef$27 as CheckRoundIcon, ForwardRef$28 as ChevronDownIcon, ForwardRef$29 as ChevronLeftIcon, ForwardRef$30 as ChevronRightIcon, ForwardRef$31 as ChevronUpIcon, ForwardRef$32 as CircleIcon, ForwardRef$33 as ClockIcon, ForwardRef$34 as ClockWithCircledLineIcon, ForwardRef$35 as CloseFillIcon, ForwardRef$36 as CloseIcon, ForwardRef$37 as CloseRoundIcon, ForwardRef$38 as Cog6ToothIcon, ForwardRef$39 as Cog8ToothIcon, ForwardRef$40 as CommentBubbleIcon, ForwardRef$41 as CommentIcon, ForwardRef$42 as CommentWithFeatherIcon, ForwardRef$43 as CommentWithFeatherMinusIcon, ForwardRef$44 as ContributionsIcon, ForwardRef$45 as CopyIcon, ForwardRef$46 as CorrectRoundIcon, ForwardRef$47 as CreateSubQuestionIcon, ForwardRef$48 as CrossIcon, ForwardRef$49 as DisabledIcon, ForwardRef$50 as DocumentPencilIcon, ForwardRef$51 as DoubleQuotesIcon, ForwardRef$52 as DownloadIcon, ForwardRef$53 as DropdownIcon, ForwardRef$54 as EditLineIcon, ForwardRef$55 as EllipsisHorizontalIcon, ForwardRef$56 as ErrorIcon, ForwardRef$57 as ExclamationCircleIcon, ForwardRef$58 as ExclamationTriangleIcon, ForwardRef$59 as ExitIcon, ForwardRef$60 as ExportIcon, ForwardRef$61 as EyeClosedIcon, ForwardRef$62 as EyeIcon, ForwardRef$63 as FileAttachmentIcon, ForwardRef$64 as FileImportIcon, ForwardRef$65 as FilePaperFill, ForwardRef$66 as FileUploadFillIcon, ForwardRef$67 as FileUploadIcon, ForwardRef$68 as FileZipIcon, ForwardRef$69 as FillInBlanksIcon, ForwardRef$70 as FilterIcon, ForwardRef$71 as FlipIcon, ForwardRef$72 as FolderArrowLeftFillIcon, ForwardRef$73 as FolderOpenIcon, ForwardRef$74 as FootnoteIcon, ForwardRef$75 as ForbidIcon, ForwardRef$76 as FundBoxLineIcon, ForwardRef$77 as GlobeIcon, ForwardRef$78 as GridIcon, ForwardRef$79 as GridMinusIcon, ForwardRef$80 as GridPlusIcon, ForwardRef$81 as GridWithPencilIcon, ForwardRef$82 as HashtagIcon, ForwardRef$83 as HistoryIcon, ForwardRef$84 as HomeIcon, ForwardRef$85 as HotspotIcon, ForwardRef$86 as HotspotPin, ForwardRef$87 as HotspotPositionObjectIcon, Icon, ForwardRef$88 as IndeterminateCircleIcon, ForwardRef$89 as InfoIcon, ForwardRef$90 as InfoUnfilledIcon, ForwardRef$91 as InformationFilledIcon, ForwardRef$92 as InformationLineIcon, ForwardRef$93 as InsertCommentIcon, ForwardRef$94 as InsertFootnoteIcon, ForwardRef$95 as LinkIcon, ForwardRef$96 as ListIcon, ForwardRef$97 as ListSingleSelectIcon, ForwardRef$98 as LoaderIcon, ForwardRef$99 as LockClosedIcon, ForwardRef$100 as LockOpenIcon, ForwardRef$101 as LongAnswerIcon, ForwardRef$102 as MagnifyingGlassIcon, ForwardRef$103 as MailIcon, ForwardRef$104 as MapPinAddLineIcon, ForwardRef$105 as MatchingIcon, ForwardRef$106 as MicFilledIcon, ForwardRef$107 as MicIcon, ForwardRef$108 as MinusRoundIcon, ForwardRef$109 as MultipleChoiceIcon, ForwardRef$110 as NumericalAnswerIcon, ForwardRef$111 as PaperAirplaneIcon, ForwardRef$112 as PauseIcon, ForwardRef$113 as PencilIcon, ForwardRef$114 as PencilWithEraserIcon, ForwardRef$115 as PersonIcon, ForwardRef$116 as PieChartLineIcon, ForwardRef$117 as PilcrowIcon, ForwardRef$118 as PlayIcon, ForwardRef$119 as PlayMiniIcon, ForwardRef$120 as PlusIcon, ForwardRef$121 as PlusRoundIcon, ForwardRef$122 as PresentationFillIcon, ForwardRef$123 as ProgressCircleIcon, ForwardRef$124 as QuestionRoundIcon, ForwardRef$125 as QuestionSetIcon, ForwardRef$126 as QuillPenIcon, ForwardRef$127 as RecordCircleIcon, ForwardRef$128 as RecordStopIcon, ForwardRef$129 as ReplyAllIcon, ForwardRef$130 as RewindMiniIcon, ForwardRef$131 as RubricIcon, ForwardRef$132 as SaveIcon, ForwardRef$133 as ShakeHandsIcon, ForwardRef$134 as ShareForwardIcon, ForwardRef$135 as ShareIcon, ForwardRef$136 as ShootingStarIcon, ForwardRef$137 as ShortAnswerIcon, ForwardRef$138 as SkipBackIcon, ForwardRef$139 as SkipBackMiniIcon, ForwardRef$140 as SkipForward, ForwardRef$141 as SkipForwardMiniIcon, ForwardRef$142 as SlowDownLineIcon, ForwardRef$143 as SparksIcon, ForwardRef$144 as SparksWithMinusIcon, ForwardRef$145 as SpeedMiniIcon, ForwardRef$146 as SquarePlayIcon, ForwardRef$147 as StackIcon, ForwardRef$148 as SubtractIcon, ForwardRef$149 as SubtractRoundIcon, ForwardRef$150 as SwapLineIcon, ForwardRef$151 as SwitchIcon, ForwardRef$152 as TabletPortrait, ForwardRef$153 as TagIcon, ForwardRef$154 as TeamLineIcon, ForwardRef$155 as TextIcon, ForwardRef$156 as TickIcon, ForwardRef$157 as TickRoundBackgroundIcon, ForwardRef$158 as TickRoundIcon, ForwardRef$159 as TimeIcon, ForwardRef$160 as TimerLineIcon, ForwardRef$161 as TrashIcon, ForwardRef$162 as TrueFalseIcon, ForwardRef$163 as UserGroupIcon, ForwardRef$164 as UserIcon, ForwardRef$165 as UserSharedIcon, ForwardRef$166 as VideoCameraFilledIcon, ForwardRef$167 as VideoCameraIcon, ForwardRef$168 as VideoCameraSlashIcon, ForwardRef$169 as ViewThreadsIcon, ForwardRef$170 as WarnIcon, ForwardRef$171 as WarnTriangleIcon, ForwardRef$172 as WindowIcon, ForwardRef$173 as XMarkIcon, iconList };

//# sourceMappingURL=index.mjs.map